(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_footer-link-group"] && !Shopify.designMode) return;
  try {
    class FooterLinkGroup extends BaseElement {
    init() {
      this._toggle = this.querySelector('.footer-link-group__toggle');
      this._panel = this.querySelector('.footer-link-group__panel');
      if (!this._toggle || !this._panel) return;

      this._mq = window.matchMedia('(min-width: 1024px)');
      this._onToggle = this._handleToggle.bind(this);
      this._onMediaChange = this._syncViewport.bind(this);
      this._toggle.addEventListener('click', this._onToggle);
      this._mq.addEventListener('change', this._onMediaChange);
      this.classList.add('is-enhanced');
      this._syncViewport();
    }

    dispose() {
      this._toggle?.removeEventListener('click', this._onToggle);
      this._mq?.removeEventListener('change', this._onMediaChange);
      this.classList.remove('is-enhanced');
      this._setExpanded(true);
      if (this._toggle) this._toggle.disabled = true;
      this._toggle = null;
      this._panel = null;
      this._mq = null;
      this._onToggle = null;
      this._onMediaChange = null;
    }

    _handleToggle() {
      if (this._mq.matches) return;
      const isExpanded = this._toggle.getAttribute('aria-expanded') === 'true';
      this._setExpanded(!isExpanded);
    }

    _syncViewport() {
      const isDesktop = this._mq.matches;
      this._toggle.disabled = isDesktop;
      this._setExpanded(isDesktop);
    }

    _setExpanded(isExpanded) {
      if (!this._toggle || !this._panel) return;
      this._toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      this._panel.hidden = !isExpanded;
    }
  }

  if (!customElements.get('footer-link-group')) {
    customElements.define('footer-link-group', FooterLinkGroup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_footer-links"] && !Shopify.designMode) return;
  try {
    class FooterLinks extends BaseElement {
    init() {
      this._onClick = this._handleClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    dispose() {
      this.removeEventListener('click', this._onClick);
      this._onClick = null;
    }

    _handleClick(event) {
      const trigger = event.target.closest('button[element-selector]');
      if (!trigger || !this.contains(trigger)) return;

      const selector = trigger.getAttribute('element-selector');
      if (!selector) return;

      let target;
      try {
        target = document.querySelector(selector);
      } catch (error) {
        if (error.name !== 'SyntaxError') throw error;
        return;
      }

      if (!target) return;

      if (target.matches('iframe#launcher') && typeof window.zE === 'function') {
        try {
          window.zE('messenger', 'open');
          return;
        } catch (_messengerError) {
          try {
            window.zE('webWidget', 'open');
            return;
          } catch (_webWidgetError) {
            target.click();
            return;
          }
        }
      }

      target.click();
    }
  }

  if (!customElements.get('footer-links')) {
    customElements.define('footer-links', FooterLinks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_footer-subscribe"] && !Shopify.designMode) return;
  try {
    class FooterSubscribe extends BaseElement {
    init() {
      this._form = this.querySelector('.footer-subscribe__form');
      this._emailInput = this.querySelector('.footer-subscribe__input');
      this._agreementInput = this.querySelector('.footer-subscribe__checkbox');
      this._submitButton = this.querySelector('.footer-subscribe__submit');
      this._status = this.querySelector('.footer-subscribe__status');
      this._submitLabel = this.getAttribute('submit-label') || 'Subscribe';
      this._abortController = null;
      this._isSubmitting = false;
      this._requestId = (this._requestId || 0) + 1;
      this._onSubmit = this._handleSubmit.bind(this);
      this._onEmailInput = this._clearValidation.bind(this);
      this._onAgreementChange = this._clearValidation.bind(this);

      this._form?.addEventListener('submit', this._onSubmit);
      this._emailInput?.addEventListener('input', this._onEmailInput);
      this._agreementInput?.addEventListener('change', this._onAgreementChange);
    }

    dispose() {
      this._form?.removeEventListener('submit', this._onSubmit);
      this._emailInput?.removeEventListener('input', this._onEmailInput);
      this._agreementInput?.removeEventListener('change', this._onAgreementChange);
      this._cancelApiWait();
      this._cancelRequest();
      this._setSubmitting(false);
      this._clearValidation();
      this._requestId = (this._requestId || 0) + 1;
      this._form = null;
      this._emailInput = null;
      this._agreementInput = null;
      this._submitButton = null;
      this._status = null;
      this._onSubmit = null;
      this._onEmailInput = null;
      this._onAgreementChange = null;
      this._abortController = null;
      this._isSubmitting = false;
    }

    async _handleSubmit(event) {
      event.preventDefault();
      if (this._isSubmitting || !this._emailInput) return;

      this._clearValidation();
      const email = this._emailInput.value.trim();
      const requireAgreement = this.getAttribute('require-agreement') === 'true';
      const companyId = String(this.getAttribute('company-id') || '').trim();
      const listId = String(this.getAttribute('list-id') || '').trim();

      if (!email || !this._emailInput.validity.valid) {
        this._showError(this.getAttribute('invalid-message'), this._emailInput);
        return;
      }

      if (requireAgreement && (!this._agreementInput || !this._agreementInput.checked)) {
        this._showError(this.getAttribute('agreement-required-message'), this._agreementInput);
        return;
      }

      if (!companyId || !listId) {
        this._showError(this.getAttribute('missing-config-message'));
        return;
      }

      const requestId = this._requestId;
      this._cancelRequest();
      this._abortController = new AbortController();
      this._setSubmitting(true);

      try {
        const klaviyo = await this._getKlaviyoApi();
        if (requestId !== this._requestId) return;

        if (!klaviyo?.subscribe || !klaviyo?.validateEmail) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }

        if (!klaviyo.validateEmail(email)) {
          this._showError(this.getAttribute('invalid-message'), this._emailInput);
          return;
        }

        const result = await klaviyo.subscribe({
          email: email,
          apiKey: companyId,
          listId: listId,
          emitSuccess: false,
          signal: this._abortController.signal
        });
        if (requestId !== this._requestId) return;

        if (result?.aborted) return;

        if (result?.success || this._isDuplicateResult(result)) {
          this._emailInput.value = '';
          if (this._agreementInput) this._agreementInput.checked = false;
          this._showStatus(this.getAttribute('success-message'));
          return;
        }

        this._showError(this.getAttribute('error-message'));
      } catch (error) {
        if (requestId === this._requestId) {
          this._showError(this.getAttribute('error-message'));
        }
      } finally {
        if (requestId === this._requestId) {
          this._setSubmitting(false);
          this._abortController = null;
        }
      }
    }

    _getKlaviyoApi() {
      if (window.$klaviyo?.subscribe && window.$klaviyo?.validateEmail) {
        return Promise.resolve(window.$klaviyo);
      }

      return new Promise((resolve) => {
        const finish = (api) => {
          window.clearTimeout(this._apiReadyTimeout);
          window.removeEventListener('ndev:klaviyo-api-ready', this._onApiReady);
          this._apiReadyTimeout = null;
          this._onApiReady = null;
          this._apiReadyResolve = null;
          resolve(api);
        };

        this._apiReadyResolve = finish;
        this._onApiReady = () => {
          const api = window.$klaviyo?.subscribe && window.$klaviyo?.validateEmail ? window.$klaviyo : null;
          finish(api);
        };
        this._apiReadyTimeout = window.setTimeout(() => finish(null), 3000);
        window.addEventListener('ndev:klaviyo-api-ready', this._onApiReady, { once: true });
      });
    }

    _cancelApiWait() {
      if (this._apiReadyResolve) {
        this._apiReadyResolve(null);
      }
    }

    _cancelRequest() {
      this._abortController?.abort();
      this._abortController = null;
    }

    _isDuplicateResult(result) {
      const error = result?.error;
      const messages = [
        typeof error === 'string' ? error : '',
        error?.message,
        error?.detail,
        error?.errors?.[0]?.detail
      ];
      const normalized = messages.filter(Boolean).join(' ').toLowerCase();
      return normalized.includes('already') || normalized.includes('exists');
    }

    _setSubmitting(isSubmitting) {
      this._isSubmitting = isSubmitting;
      const submittingMessage = this.getAttribute('submitting-message') || 'Submitting...';
      if (this._submitButton) {
        this._submitButton.disabled = isSubmitting;
        this._submitButton.setAttribute(
          'aria-label',
          isSubmitting ? submittingMessage : this._submitLabel
        );
      }
      this._form?.setAttribute('aria-busy', String(isSubmitting));
      if (isSubmitting) this._showStatus(submittingMessage);
    }

    _clearValidation() {
      this._emailInput?.setAttribute('aria-invalid', 'false');
      this._agreementInput?.setAttribute('aria-invalid', 'false');
      if (this._status) {
        this._status.textContent = '';
        this._status.classList.remove('is-error');
      }
    }

    _showStatus(message) {
      if (!this._status) return;
      this._status.classList.remove('is-error');
      this._status.textContent = message || '';
    }

    _showError(message, control) {
      if (control) {
        control.setAttribute('aria-invalid', 'true');
        control.focus();
      }
      if (!this._status) return;
      this._status.classList.add('is-error');
      this._status.textContent = message || this.getAttribute('error-message') || 'Subscription failed. Please try again.';
    }
  }

  if (!customElements.get('footer-subscribe')) {
    customElements.define('footer-subscribe', FooterSubscribe);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-26-pd-subscribe-card"] && !Shopify.designMode) return;
  try {
    class NdevSubscribeCard extends BaseElement {
    createdCallback() {
      this._intervalId = null;
      this._currentIndex = 0;
      this._onMediaChange = this._syncCarousel.bind(this);
    }

    init() {
      this._mq.addEventListener('change', this._onMediaChange);
      this._syncCarousel();
    }

    _syncCarousel() {
      if (this._mq.matches) {
        this._stopCarousel();
        this._resetSlides();
      } else {
        this._startCarousel();
      }
    }

    static get observedAttributes() {
      return ['autoplay-interval'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'autoplay-interval' && oldValue !== null && oldValue !== newValue) {
        this._syncCarousel();
      }
    }

    _startCarousel() {
      const slides = this.querySelectorAll('[data-carousel-track] .ndev-subscribe-card__carousel-slide');
      if (slides.length <= 1) return;

      const intervalMs = parseInt(this.getAttribute('autoplay-interval')) || 2000;
      if (intervalMs <= 0) return;

      this._stopCarousel();
      this._slides = slides;
      this._currentIndex = 0;
      this._setActive(0);

      this._intervalId = setInterval(() => {
        this._nextSlide();
      }, intervalMs);
    }

    _nextSlide() {
      if (!this._slides || this._slides.length <= 1) return;
      this._currentIndex = (this._currentIndex + 1) % this._slides.length;
      this._setActive(this._currentIndex);
    }

    _setActive(index) {
      for (let i = 0; i < this._slides.length; i++) {
        this._slides[i].classList.toggle('active', i === index);
      }
    }

    _resetSlides() {
      if (this._slides) {
        for (let i = 0; i < this._slides.length; i++) {
          this._slides[i].classList.toggle('active', i === 0);
        }
      }
    }

    _stopCarousel() {
      if (this._intervalId) {
        clearInterval(this._intervalId);
        this._intervalId = null;
      }
    }

    dispose() {
      this._mq.removeEventListener('change', this._onMediaChange);
      this._stopCarousel();
      this._slides = null;
    }
  }
  if (!customElements.get('ndev-subscribe-card')) {
    customElements.define('ndev-subscribe-card', NdevSubscribeCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-ax26-clean-and-corners"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-ax26-clean-and-corners';
    const ROOT_SELECTOR = '[data-ndev-ax26-clean-and-corners]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function queryCards(root) {
      return root ? root.querySelectorAll('.ndev-ax26-clean-and-corners-card') : [];
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const cards = queryCards(root);
      if (!cards.length) return;

      const paginationEl = root.querySelector('[data-ndev-ax26-clean-and-corners-pagination]');
      const paginationPrevBtn = paginationEl
        ? paginationEl.querySelector('.ndev-ax26-clean-and-corners__pagination-button--prev')
        : null;
      const paginationNextBtn = paginationEl
        ? paginationEl.querySelector('.ndev-ax26-clean-and-corners__pagination-button--next')
        : null;
      const ringHost = paginationNextBtn
        ? paginationNextBtn.querySelector('[data-ndev-ax26-clean-and-corners-ring-host]')
        : null;

      let ringAnimId = null;

      function cancelRingAnim() {
        if (ringAnimId) {
          cancelAnimationFrame(ringAnimId);
          ringAnimId = null;
        }
      }

      function startRingAnim(ring, duration) {
        if (!ring) return;
        cancelRingAnim();
        ring.style.strokeDashoffset = '113.1';
        let startTime = performance.now();
        function step(now) {
          let elapsed = now - startTime;
          let progress = Math.min(elapsed / duration, 1);
          ring.style.strokeDashoffset = String(113.1 * (1 - progress));
          if (progress < 1) {
            ringAnimId = requestAnimationFrame(step);
          }
        }
        ringAnimId = requestAnimationFrame(step);
      }

      const allSwitchItems = [];

      for (let c = 0; c < cards.length; c++) {
        const switchEl = cards[c].querySelector('.ndev-ax26-clean-and-corners-card__switch');
        if (!switchEl) continue;

        while (switchEl.firstChild) {
          switchEl.removeChild(switchEl.firstChild);
        }

        for (let i = 0; i < cards.length; i++) {
          const title = (cards[i].getAttribute('data-title') || '').trim();
          const item = document.createElement('div');
          item.classList.add('ndev-ax26-clean-and-corners-card__switch-item');
          item.textContent = title;
          item.dataset.index = String(i);
          item.addEventListener('click', function (e) {
            e.stopPropagation();
            const idx = parseInt(this.dataset.index, 10);
            setActive(idx);
            startTimer();
          });
          switchEl.appendChild(item);
          allSwitchItems.push(item);
        }

        switchEl.classList.add('ndev-ax26-clean-and-corners-card__switch--ready');
      }

      let autoplayOn = root.getAttribute('data-autoplay') === 'true';
      const autoplayMs = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;
      const autoplayInView = (root.getAttribute('data-autoplay-start') || 'immediate').trim() === 'in_view';

      let index = 0;
      let timer = null;
      let io = null;
      let reducedMotion = false;
      let inViewKickTimer = null;

      try {
        reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      autoplayOn = autoplayOn && !reducedMotion;

      if (autoplayOn && ringHost) {
        while (ringHost.firstChild) {
          ringHost.removeChild(ringHost.firstChild);
        }
        const ringSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        ringSvg.setAttribute('class', 'ndev-ax26-clean-and-corners__progress-ring-svg');
        ringSvg.setAttribute('viewBox', '0 0 40 40');
        const ringCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        ringCircle.setAttribute('class', 'ndev-ax26-clean-and-corners__progress-ring');
        ringCircle.setAttribute('cx', '20');
        ringCircle.setAttribute('cy', '20');
        ringCircle.setAttribute('r', '18');
        ringSvg.appendChild(ringCircle);
        ringHost.appendChild(ringSvg);
      }

      function getProgressRing() {
        return paginationEl ? paginationEl.querySelector('.ndev-ax26-clean-and-corners__progress-ring') : null;
      }

      function updatePaginationDisabled() {
        if (!paginationPrevBtn || !paginationNextBtn) return;
        const lock = cards.length <= 1;
        paginationPrevBtn.disabled = lock;
        paginationNextBtn.disabled = lock;
      }

      function setClasses(n) {
        index = n;
        for (let c = 0; c < cards.length; c++) {
          cards[c].classList.toggle('actived', c === n);
        }
        for (let s = 0; s < allSwitchItems.length; s++) {
          let itemIdx = parseInt(allSwitchItems[s].dataset.index, 10);
          allSwitchItems[s].classList.toggle('ndev-ax26-clean-and-corners-card__switch-item--active', itemIdx === n);
        }
        updatePaginationDisabled();
      }

      function setActive(i) {
        if (!cards.length) return;
        const n = ((i % cards.length) + cards.length) % cards.length;
        setClasses(n);
      }

      function next() {
        setActive(index + 1);
        startRingAnim(getProgressRing(), autoplayMs);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startTimer() {
        stopTimer();
        if (!autoplayOn || cards.length < 2) return;
        timer = setInterval(next, autoplayMs);
        startRingAnim(getProgressRing(), autoplayMs);
      }

      function inViewport() {
        const r = root.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        const vw = window.innerWidth || document.documentElement.clientWidth || 0;
        return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
      }

      function setupAutoplay() {
        if (!autoplayOn) return;

        const mobileMq = window.matchMedia('(max-width: 1023px)');

        function startIfMobile() {
          if (!mobileMq.matches) {
            stopTimer();
            cancelRingAnim();
            return;
          }
          if (autoplayInView && !inViewport()) return;
          startTimer();
        }

        mobileMq.addEventListener('change', startIfMobile);

        if (autoplayInView && typeof IntersectionObserver !== 'undefined') {
          io = new IntersectionObserver(
            function (entries) {
              if (!mobileMq.matches) return;
              const ok = entries.some(function (en) {
                return en.isIntersecting;
              });
              if (ok) {
                startTimer();
              } else {
                stopTimer();
                cancelRingAnim();
              }
            },
            { root: null, threshold: 0 }
          );
          io.observe(root);
          if (mobileMq.matches) {
            inViewKickTimer = setTimeout(function () {
              inViewKickTimer = null;
              if (inViewport()) startTimer();
            }, 50);
          }
        } else {
          startIfMobile();
        }
      }

      function onCardClick(e) {
        let target = e.target;
        while (target && target !== root) {
          if (target.classList && target.classList.contains('ndev-ax26-clean-and-corners-card')) {
            for (let i = 0; i < cards.length; i++) {
              if (cards[i] === target) {
                setActive(i);
                startTimer();
                return;
              }
            }
          }
          target = target.parentElement;
        }
      }

      function onPaginationClick(e) {
        if (!paginationEl) return;
        let target = e.target;
        while (target && target !== paginationEl) {
          if (target.classList && target.classList.contains('ndev-ax26-clean-and-corners__pagination-button--prev')) {
            setActive(index - 1);
            startTimer();
            return;
          }
          if (target.classList && target.classList.contains('ndev-ax26-clean-and-corners__pagination-button--next')) {
            setActive(index + 1);
            startTimer();
            return;
          }
          target = target.parentElement;
        }
      }

      updatePaginationDisabled();
      root.addEventListener('click', onCardClick);
      if (paginationEl) {
        paginationEl.addEventListener('click', onPaginationClick);
      }

      setupAutoplay();

      root.classList.add(NS + '--ready');
      setClasses(0);

      controllers.set(root, {
        root: root,
        destroy: function () {
          stopTimer();
          cancelRingAnim();
          if (inViewKickTimer) clearTimeout(inViewKickTimer);
          root.removeEventListener('click', onCardClick);
          if (paginationEl) {
            paginationEl.removeEventListener('click', onPaginationClick);
          }
          if (io) {
            io.disconnect();
            io = null;
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
          try { root.classList.remove(NS + '--ready'); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      let target = event && event.target ? event.target : null;
      if (target) {
        requestAnimationFrame(function () {
          initAll(target);
        });
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-ax26-flip-card"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-ax26-flip-card';
    const ROOT_SELECTOR = '[data-ndev-ax26-flip-card]';
    const TRACK_SELECTOR = '[data-ndev-ax26-flip-card-track]';
    const INIT_ATTR = 'data-' + NS + '-initialized';
    const TAB_COMMENT_PREFIX = 'ndev-ax26-flip-tab|';
    /** PC 视口（与主题二级断点一致）：传给 matchMedia 的查询字符串，不是布尔值 */
    const MQ_PC = '(min-width: 1024px)';

    function querySlideFaceElements(root) {
      const wrap = root.querySelector('.ndev-ax26-flip-card__slides');
      if (!wrap) return [];
      const out = [];
      const nodes = wrap.children;
      for (let i = 0; i < nodes.length; i++) {
        const el = nodes[i];
        if (!el || el.nodeType !== 1) continue;
        const tag = el.tagName;
        if (tag === 'STYLE' || tag === 'SCRIPT') continue;
        if (el.hasAttribute && el.hasAttribute('data-ndev-ax26-flip-card-slide-face')) {
          out.push(el);
        }
      }
      return out;
    }

    function readTrigger(root, attr) {
      const v = root.getAttribute(attr);
      return v === 'tabs' ? 'tabs' : 'scroll';
    }

    function getEffectiveTrigger(root) {
      const desktop = window.matchMedia && window.matchMedia(MQ_PC).matches;
      return desktop ? readTrigger(root, 'data-pc-trigger') : readTrigger(root, 'data-mb-trigger');
    }

    function readTabLabelFromWrapper(wrap) {
      if (!wrap || typeof wrap.getAttribute !== 'function') return '';
      const ds = wrap.getAttribute('data-ndev-ax26-flip-card-tab-label');
      if (ds != null && String(ds).trim() !== '') return String(ds).trim();
      const nodes = wrap.childNodes;
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (n && n.nodeType === 8) {
          const t = (n.textContent || '').trim();
          if (t.indexOf(TAB_COMMENT_PREFIX) === 0) return t.slice(TAB_COMMENT_PREFIX.length).trim();
        }
      }
      return '';
    }

    function clearTabList(tabList) {
      if (!tabList) return;
      while (tabList.firstChild) {
        tabList.removeChild(tabList.firstChild);
      }
    }

    function buildTabs(slides, tabList) {
      clearTabList(tabList);
      const labels = document.createElement('div');
      labels.className = 'ndev-ax26-flip-card__tabs-labels';
      labels.setAttribute('role', 'tablist');
      labels.setAttribute('aria-label', 'Slide tabs');

      const btns = [];
      const n = slides.length;
      for (let i = 0; i < n; i++) {
        const face = slides[i];
        let label = readTabLabelFromWrapper(face);
        if (!label) label = 'Tab ' + (i + 1);
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'ndev-ax26-flip-card__tab';
        b.setAttribute('role', 'tab');
        b.setAttribute('data-tab-index', String(i));
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.setAttribute('tabindex', i === 0 ? '0' : '-1');
        b.textContent = label;
        labels.appendChild(b);
        btns.push(b);
      }

      const track = document.createElement('div');
      track.className = 'ndev-ax26-flip-card__tabs-track';
      track.setAttribute('aria-hidden', 'true');
      const count = Math.max(n, 1);
      track.style.setProperty('--ndev-ax26-flip-tab-count', String(count));
      track.style.setProperty('--ndev-ax26-flip-tab-active', '0');

      const line = document.createElement('div');
      line.className = 'ndev-ax26-flip-card__tabs-line';
      const indicator = document.createElement('div');
      indicator.className = 'ndev-ax26-flip-card__tabs-indicator';
      track.appendChild(line);
      track.appendChild(indicator);

      const tabCaption = document.createElement('div');
      tabCaption.className = 'ndev-ax26-flip-card__tab-caption';
      tabCaption.setAttribute('data-ndev-ax26-flip-card-tab-caption', '');
      tabCaption.setAttribute('hidden', '');

      tabList.appendChild(labels);
      tabList.appendChild(track);
      tabList.appendChild(tabCaption);

      return btns;
    }

    function syncTabAria(tabButtons, idx, root) {
      if (!tabButtons || !tabButtons.length) return;
      for (let i = 0; i < tabButtons.length; i++) {
        tabButtons[i].setAttribute('aria-selected', i === idx ? 'true' : 'false');
        tabButtons[i].setAttribute('tabindex', i === idx ? '0' : '-1');
      }
      if (!root || typeof root.querySelector !== 'function') return;
      const track = root.querySelector('.ndev-ax26-flip-card__tabs-track');
      if (!track) return;
      track.style.setProperty('--ndev-ax26-flip-tab-count', String(tabButtons.length));
      track.style.setProperty('--ndev-ax26-flip-tab-active', String(idx));
    }

    function syncTabCaption(root, slides, idx) {
      if (!root || !slides || !slides.length) return;
      const cap = root.querySelector('[data-ndev-ax26-flip-card-tab-caption]');
      if (!cap) return;
      while (cap.firstChild) cap.removeChild(cap.firstChild);
      if (getEffectiveTrigger(root) !== 'tabs') {
        cap.setAttribute('hidden', '');
        return;
      }
      const slide = slides[idx];
      const src =
        slide && slide.querySelector ? slide.querySelector('[data-ndev-ax26-flip-card-media-caption]') : null;
      if (!src) {
        cap.setAttribute('hidden', '');
        return;
      }
      const nodes = src.childNodes;
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (!n) continue;
        cap.appendChild(n.cloneNode(true));
      }
      const text = (cap.textContent || '').trim();
      if (text) {
        cap.removeAttribute('hidden');
      } else {
        while (cap.firstChild) cap.removeChild(cap.firstChild);
        cap.setAttribute('hidden', '');
      }
    }

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function parseFlipMs(root) {
      const raw = root.getAttribute('data-flip-ms');
      const n = parseInt(raw, 10);
      return n > 0 ? n : 600;
    }

    function clearFlipClasses(slide) {
      slide.classList.remove(
        'flip-out-fwd',
        'flip-out-back',
        'flip-in-from-fwd',
        'flip-in-to-fwd',
        'flip-in-from-back',
        'flip-in-to-back'
      );
    }

    function setSlidesIdle(slides, exceptIndex) {
      for (let i = 0; i < slides.length; i++) {
        const s = slides[i];
        clearFlipClasses(s);
        s.classList.remove('is-active');
        if (i === exceptIndex) {
          s.classList.add('is-active');
        }
      }
    }

    function pauseAllVideos(slides) {
      for (let i = 0; i < slides.length; i++) {
        const vids = slides[i].querySelectorAll('video');
        for (let j = 0; j < vids.length; j++) {
          try {
            vids[j].pause();
          } catch (e) {}
        }
      }
    }

    function playSlideVideos(slide) {
      if (!slide) return;
      const vids = slide.querySelectorAll('video');
      for (let j = 0; j < vids.length; j++) {
        const v = vids[j];
        try {
          if (!v.muted) v.muted = true;
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } catch (e) {}
      }
      const mediaRoot = slide.matches('[data-ndev-media]') ? slide : slide.querySelector('[data-ndev-media]');
      if (mediaRoot && typeof mediaRoot.__ndevMediaSync === 'function') {
        try {
          mediaRoot.__ndevMediaSync();
        } catch (e) {}
      }
    }

    function updateA11y(root, slides, index) {
      const status = root.querySelector('[data-ndev-ax26-flip-card-status]');
      if (!status || !slides.length) return;
      const cur = index + 1;
      const total = slides.length;
      status.textContent = 'Slide ' + cur + ' of ' + total;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const track = root.querySelector(TRACK_SELECTOR);
      const slides = querySlideFaceElements(root);
      const flipMs = parseFlipMs(root);
      const tabList = root.querySelector('[data-ndev-ax26-flip-card-tabs]');

      if (!track || slides.length === 0) {
        controllers.set(root, {
          root: root,
          destroy: function () {
            try {
              root.removeAttribute(INIT_ATTR);
            } catch (e) {}
          },
        });
        return;
      }

      let displayedIndex = 0;
      let animating = false;
      let pendingTarget = null;
      let animTimer = null;
      let scrollRaf = 0;
      let scrollBound = false;
      let resizeObserver = null;
      let tabButtons = [];
      let onTabClickHandler = null;
      let mq = null;
      let onMqChangeHandler = null;

      /**
       * 视口竖直中线 vc 与 track 盒子 [top, bottom]：在卡片高度内均分 N 段（N = 张数）。
       * vc 在卡片上方 → 0；在卡片内 → floor((vc - top) / height * n)；在卡片下方 → n-1。
       */
      function readScrollIndex() {
        const rect = track.getBoundingClientRect();
        const n = slides.length;
        const vh = window.innerHeight || 1;
        if (n < 1) return 0;
        const vc = vh * 0.5;
        const top = rect.top;
        const bottom = rect.bottom;
        const h = rect.height || 1;

        if (vc <= top) return 0;
        if (vc >= bottom) return n - 1;

        const u = (vc - top) / h;
        let idx = Math.floor(u * n);
        if (idx < 0) idx = 0;
        if (idx >= n) idx = n - 1;
        return idx;
      }

      function applyInstantIndex(idx) {
        pauseAllVideos(slides);
        for (let i = 0; i < slides.length; i++) {
          clearFlipClasses(slides[i]);
          slides[i].classList.remove('is-active');
        }
        const s = slides[idx];
        if (s) s.classList.add('is-active');
        displayedIndex = idx;
        playSlideVideos(slides[idx]);
        updateA11y(root, slides, idx);
        syncTabAria(tabButtons, idx, root);
        syncTabCaption(root, slides, idx);
      }

      function finishAnimCleanup(oldIdx, newIdx) {
        const oldSlide = slides[oldIdx];
        const newSlide = slides[newIdx];
        if (oldSlide) {
          clearFlipClasses(oldSlide);
          oldSlide.classList.remove('is-active');
        }
        if (newSlide) {
          clearFlipClasses(newSlide);
          newSlide.classList.add('is-active');
        }
        animating = false;
        displayedIndex = newIdx;
        pauseAllVideos(slides);
        playSlideVideos(newSlide);
        updateA11y(root, slides, newIdx);
        syncTabAria(tabButtons, newIdx, root);

        if (pendingTarget !== null && pendingTarget !== displayedIndex) {
          const nextT = pendingTarget;
          pendingTarget = null;
          goToIndex(nextT, true);
        }
      }

      function goToIndex(targetIndex, force) {
        if (targetIndex === displayedIndex && !force) return;
        if (animating) {
          pendingTarget = targetIndex;
          syncTabAria(tabButtons, targetIndex, root);
          syncTabCaption(root, slides, targetIndex);
          return;
        }

        const oldIdx = displayedIndex;
        const newIdx = targetIndex;
        syncTabAria(tabButtons, newIdx, root);
        syncTabCaption(root, slides, newIdx);
        const forward = newIdx > oldIdx;

        if (prefersReducedMotion()) {
          pauseAllVideos(slides);
          setSlidesIdle(slides, newIdx);
          displayedIndex = newIdx;
          playSlideVideos(slides[newIdx]);
          updateA11y(root, slides, newIdx);
          syncTabCaption(root, slides, newIdx);
          return;
        }

        animating = true;
        pendingTarget = null;
        pauseAllVideos(slides);

        const oldSlide = slides[oldIdx];
        const newSlide = slides[newIdx];

        if (oldSlide) {
          oldSlide.classList.remove('is-active');
          oldSlide.classList.add('flip-out-fwd');
        }

        if (newSlide) {
          clearFlipClasses(newSlide);
          newSlide.classList.remove('is-active');
          newSlide.classList.add('flip-in-from-fwd');
        }

        if (animTimer) {
          clearTimeout(animTimer);
          animTimer = null;
        }

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (newSlide) {
              newSlide.classList.remove('flip-in-from-fwd');
              newSlide.classList.add('flip-in-to-fwd');
            }
          });
        });

        animTimer = setTimeout(function () {
          animTimer = null;
          finishAnimCleanup(oldIdx, newIdx);
        }, flipMs + 40);
      }

      function onScrollRaf() {
        scrollRaf = 0;
        if (getEffectiveTrigger(root) !== 'scroll') return;
        const idx = readScrollIndex();
        if (idx !== displayedIndex && !animating) {
          goToIndex(idx, false);
        } else if (idx !== displayedIndex && animating) {
          pendingTarget = idx;
        }
      }

      function onScroll() {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(onScrollRaf);
      }

      function onResize() {
        onScroll();
      }

      function detachScrollMode() {
        if (!scrollBound) return;
        scrollBound = false;
        window.removeEventListener('scroll', onScroll, { passive: true });
        window.removeEventListener('resize', onResize, { passive: true });
        if (resizeObserver) {
          try {
            resizeObserver.disconnect();
          } catch (e) {}
          resizeObserver = null;
        }
      }

      function attachScrollMode() {
        if (scrollBound) return;
        scrollBound = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize, { passive: true });
        if (typeof ResizeObserver === 'function') {
          resizeObserver = new ResizeObserver(onResize);
          resizeObserver.observe(track);
        }
      }

      function detachTabMode() {
        if (tabList && onTabClickHandler) {
          tabList.removeEventListener('click', onTabClickHandler);
        }
        onTabClickHandler = null;
        if (tabList) clearTabList(tabList);
        tabButtons = [];
      }

      function applyMode() {
        detachScrollMode();
        detachTabMode();
        const eff = getEffectiveTrigger(root);
        if (eff === 'scroll') {
          attachScrollMode();
          window.requestAnimationFrame(function () {
            const idx = readScrollIndex();
            if (idx !== displayedIndex) {
              applyInstantIndex(idx);
            }
            onScroll();
          });
        } else if (tabList) {
          tabButtons = buildTabs(slides, tabList);
          onTabClickHandler = function (ev) {
            const btn = ev.target && ev.target.closest && ev.target.closest('.ndev-ax26-flip-card__tab[data-tab-index]');
            if (!btn || !tabList.contains(btn)) return;
            const idx = parseInt(btn.getAttribute('data-tab-index'), 10);
            if (!isNaN(idx) && idx >= 0 && idx < slides.length) {
              goToIndex(idx, false);
            }
          };
          tabList.addEventListener('click', onTabClickHandler);
          syncTabAria(tabButtons, displayedIndex, root);
          syncTabCaption(root, slides, displayedIndex);
        }
      }

      applyInstantIndex(0);
      applyMode();

      if (window.matchMedia) {
        mq = window.matchMedia(MQ_PC);
        onMqChangeHandler = function () {
          applyMode();
        };
        if (mq.addEventListener) {
          mq.addEventListener('change', onMqChangeHandler);
        } else if (mq.addListener) {
          mq.addListener(onMqChangeHandler);
        }
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          detachScrollMode();
          detachTabMode();
          if (mq && onMqChangeHandler) {
            if (mq.removeEventListener) {
              mq.removeEventListener('change', onMqChangeHandler);
            } else if (mq.removeListener) {
              mq.removeListener(onMqChangeHandler);
            }
          }
          mq = null;
          onMqChangeHandler = null;
          if (animTimer) {
            clearTimeout(animTimer);
            animTimer = null;
          }
          pauseAllVideos(slides);
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    function handleBlockLoadEvent(event) {
      const t = event && event.target;
      if (!t || typeof t.closest !== 'function') {
        initAll();
        return;
      }
      const flipRoot = t.closest(ROOT_SELECTOR);
      if (flipRoot) {
        initOne(flipRoot);
        return;
      }
      initAll(t);
    }

    function handleBlockUnloadEvent(event) {
      const t = event && event.target;
      if (!t || typeof t.closest !== 'function') {
        destroyAll();
        return;
      }
      const flipRoot = t.closest(ROOT_SELECTOR);
      if (flipRoot) {
        destroyOne(flipRoot);
        if (document.body && document.body.contains(flipRoot)) {
          window.requestAnimationFrame(function () {
            if (document.body.contains(flipRoot)) initOne(flipRoot);
          });
        }
        return;
      }
      destroyAll(t);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:load', handleBlockLoadEvent);

    document.addEventListener('shopify:section:unload', handleBlockUnloadEvent);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-chub-tab-faq"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-ndev-chub-faq]';
    const INIT_ATTR = 'data-ndev-chub-faq-initialized';

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const singleOpen = root.getAttribute('data-single-open') === '1';
      const accordionName = root.getAttribute('data-accordion-name') || '';
      const triggers = Array.from(root.querySelectorAll('ui-tab[data-ndev-chub-faq-trigger][target]'));

      if (singleOpen && accordionName) {
        triggers.forEach((t) => t.setAttribute('name', accordionName));
      } else {
        triggers.forEach((t) => t.removeAttribute('name'));
      }

      // 无闪动：对初始带 open 的 trigger，同步面板 active
      triggers.forEach((t) => {
        if (!t.hasAttribute('open')) return;
        const id = t.getAttribute('target') || '';
        if (!id) return;
        const panel = root.querySelector(`#${CSS.escape(id)}`);
        panel?.classList?.add?.('active');
      });

      root.setAttribute(INIT_ATTR, '1');
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-chub-tabs"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-ndev-community-hub-tabs]';
    const INIT_ATTR = 'data-ndev-community-hub-tabs-initialized';

    const instances = new WeakMap();

    const raf2 = (fn) => {
      if (typeof window.requestAnimationFrame !== 'function') {
        window.setTimeout(fn, 0);
        return;
      }
      window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
    };

    function checkNavigationButtons(panel, swiper, swiperContainer, navButtons) {
      if (!panel || !swiper || !swiperContainer || !navButtons) return;
      const wrapper = swiperContainer.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperContainer.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const panelToSwiper = new Map();
      const tabs = Array.from(root.querySelectorAll('.ndev-community-hub-tabs__titles ui-tab[target]'));
      const panels = Array.from(root.querySelectorAll('.ndev-community-hub-tabs__panel'));

      const getPanelById = (id) => {
        if (!id) return null;
        return root.querySelector(`#${CSS.escape(id)}`) || null;
      };

      const setActivePanel = (panel) => {
        if (!panel) return;
        panels.forEach((p) => p.classList.remove('is-active'));
        panel.classList.add('is-active');
      };

      const destroyPanelSwiper = (panel) => {
        const swiper = panelToSwiper.get(panel);
        if (!swiper) return;
        swiper?.destroy?.(true, true);
        panelToSwiper.delete(panel);
      };

      const ensurePanelSwiper = (panel) => {
        if (!panel) return;
        const swiperContainer = panel.querySelector('.swiper-container');
        if (!swiperContainer || typeof window.Swiper === 'undefined') return;

        let swiper = panelToSwiper.get(panel) || null;
        const navButtons = panel.querySelector('.ndev-community-hub__nav-buttons');

        const nextEl = panel.querySelector('.ndev-community-hub__nav-button--next');
        const prevEl = panel.querySelector('.ndev-community-hub__nav-button--prev');

        if (!swiper) {
          swiper = new window.Swiper(swiperContainer, {
            slidesPerView: 'auto',
            initialSlide: 0,
            spaceBetween: 0,
            navigation: {
              nextEl,
              prevEl,
              disabledClass: 'swiper-button-disabled',
            },
            on: {
              init: function () {
                window.setTimeout(() => checkNavigationButtons(panel, swiper, swiperContainer, navButtons), 100);
              },
            },
          });
          panelToSwiper.set(panel, swiper);
        }

        raf2(() => {
          swiper?.update?.();
          swiper?.slideTo?.(0, 0);
          checkNavigationButtons(panel, swiper, swiperContainer, navButtons);
        });
      };

      const onTabShow = (ev) => {
        const tab = ev?.target?.closest?.('ui-tab') || ev?.target;
        if (!tab || tab.tagName?.toLowerCase?.() !== 'ui-tab') return;
        // 只处理标题栏的主 tabs，避免面板内部（如 FAQ accordion）也使用 `<ui-tab>` 时误触发切换。
        if (!tab.closest?.('.ndev-community-hub-tabs__titles')) return;
        const targetId = tab.getAttribute('target') || '';
        const panel = getPanelById(targetId);
        if (!panel) return;

        setActivePanel(panel);

        raf2(() => ensurePanelSwiper(panel));
      };

      const initActive = () => {
        const activePanel = root.querySelector('.ndev-community-hub-tabs__panel.is-active');
        if (activePanel) {
          ensurePanelSwiper(activePanel);
          return;
        }

        // Prefer `<ui-tab open>`'s target, fallback to the first panel.
        const openTab = root.querySelector('ui-tab[open][target]');
        const targetPanel = openTab ? getPanelById(openTab.getAttribute('target')) : null;
        const firstPanel = root.querySelector('.ndev-community-hub-tabs__panel');
        const panel = targetPanel || firstPanel;
        if (!panel) return;

        setActivePanel(panel);
        ensurePanelSwiper(panel);
      };

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          panelToSwiper.forEach((swiper, panel) => {
            const swiperContainer = panel.querySelector('.swiper-container');
            const navButtons = panel.querySelector('.ndev-community-hub__nav-buttons');
            swiper?.update?.();
            checkNavigationButtons(panel, swiper, swiperContainer, navButtons);
          });
        }, 250);
      };

      // `show/switch` 事件主要由 `<ui-tab>` 自身派发，不保证冒泡；这里同时做 tab 级监听 + 捕获监听，避免漏掉。
      tabs.forEach((tab) => {
        tab.addEventListener('show', onTabShow);
        tab.addEventListener('switch', onTabShow);
        tab.addEventListener('click', onTabShow);
      });
      root.addEventListener('show', onTabShow, true);
      root.addEventListener('switch', onTabShow, true);
      window.addEventListener('resize', onResize);

      initActive();

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, {
        destroy: () => {
          tabs.forEach((tab) => {
            tab.removeEventListener('show', onTabShow);
            tab.removeEventListener('switch', onTabShow);
            tab.removeEventListener('click', onTabShow);
          });
          root.removeEventListener('show', onTabShow, true);
          root.removeEventListener('switch', onTabShow, true);
          window.removeEventListener('resize', onResize);
          if (resizeTimeout) window.clearTimeout(resizeTimeout);
          Array.from(panelToSwiper.keys()).forEach(destroyPanelSwiper);
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function destroyOne(root) {
      const inst = instances.get(root);
      if (!inst) return;
      inst.destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-cpi-images"] && !Shopify.designMode) return;
  try {
    (function () {
    var IMAGES_SELECTOR = '[data-ndev-closable-product-intro-images]';
    var ITEM_SELECTOR = '.ndev-closable-product-intro__image-item';
    var DOTS_SELECTOR = '[data-ndev-closable-product-intro-dots]';
    var INIT_ATTR = 'data-ndev-cpi-images-init';
    var ACTIVE_ATTR = 'data-ndev-cpi-active-index';
    var MOBILE_QUERY = '(max-width: 1023px)';

    function clamp(n, min, max) {
      if (n < min) return min;
      if (n > max) return max;
      return n;
    }

    function getItems(root) {
      return root.querySelectorAll(ITEM_SELECTOR);
    }

    function reportGA4(el) {
      var raw = el.getAttribute('data-ga4-report');
      if (raw && $narwal && typeof $narwal.report === 'function') {
        $narwal.report($narwal.getJSON(raw));
      }
    }

    function createController(root) {
      var controller = {};
      var cleanup = [];
      var mql = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
      var dotsRoot = null;
      var scrollRaf = 0;
      var scrollEndTimer = 0;
      var resizeTimer = 0;
      var mutationObserver = null;
      var lastReportedIdx = null;
      var overlayRaf = 0;

      function on(el, type, handler, options) {
        if (!el || !el.addEventListener) return;
        el.addEventListener(type, handler, options || false);
        cleanup.push(function () {
          try { el.removeEventListener(type, handler, options || false); } catch (e) {}
        });
      }

      function isMobileNow() {
        if (mql) return !!mql.matches;
        return window.innerWidth < 1024;
      }

      function getDotsRoot() {
        if (dotsRoot) return dotsRoot;
        var wrapper = root.parentElement;
        if (!wrapper) return null;
        dotsRoot = wrapper.querySelector(DOTS_SELECTOR);
        return dotsRoot;
      }

      function syncOverlayHeight() {
        overlayRaf = 0;
        var items = getItems(root);
        if (!items || !items.length) {
          try { root.style.removeProperty('--ndev-cpi-overlay-height'); } catch (e) {}
          return;
        }

        // 关键：测量前先清空统一高度，否则会把 padding/固定高度再次计入，导致数值“越算越大”
        try { root.style.removeProperty('--ndev-cpi-overlay-height'); } catch (e) {}

        var maxH = 0;
        for (var i = 0; i < items.length; i++) {
          var overlay = items[i].querySelector('.ndev-closable-product-intro__image-overlay');
          if (!overlay) continue;
          // 用 offsetHeight 取“实际渲染高度”（包含 padding），避免 scrollHeight 与固定高度互相影响
          var h = overlay.offsetHeight || 0;
          if (h > maxH) maxH = h;
        }

        if (maxH > 0) {
          try { root.style.setProperty('--ndev-cpi-overlay-height', Math.ceil(maxH) + 'px'); } catch (e) {}
        } else {
          try { root.style.removeProperty('--ndev-cpi-overlay-height'); } catch (e) {}
        }
      }

      function scheduleSyncOverlayHeight() {
        if (overlayRaf) return;
        overlayRaf = requestAnimationFrame(syncOverlayHeight);
      }

      function shouldShowPager(items) {
        if (!isMobileNow()) return false;
        if (!items || items.length <= 1) return false;
        // 只在内容宽度大于容器宽度（可横向滚动）时展示翻页器
        return (root.scrollWidth - root.clientWidth) > 1;
      }

      function updatePagerVisibility(items) {
        var rootEl = getDotsRoot();
        if (!rootEl) return false;
        var show = shouldShowPager(items);
        // hidden 优先级高于 CSS display，避免 M 端误展示
        rootEl.hidden = !show;
        return show;
      }

      function getActiveIndex(items) {
        var stored = parseInt(root.getAttribute(ACTIVE_ATTR), 10);
        if (!isNaN(stored) && stored >= 0 && stored < items.length) return stored;

        var defaultIndex1 = parseInt(root.getAttribute('data-default-active'), 10) || 1;
        var defaultIndex0 = (defaultIndex1 >= 1 && defaultIndex1 <= items.length) ? defaultIndex1 - 1 : 0;
        return defaultIndex0;
      }

      function setActiveClass(items, activeIdx) {
        Array.prototype.forEach.call(items, function (item, i) {
          if (i === activeIdx) item.classList.add('is-active');
          else item.classList.remove('is-active');
        });
      }

      function buildDots(items) {
        var rootEl = getDotsRoot();
        if (!rootEl) return;
        if (!updatePagerVisibility(items)) return;

        var existing = rootEl.querySelectorAll('.ndev-closable-product-intro__images-dot').length;
        var needRebuild = existing !== items.length;
        if (!needRebuild) return;

        rootEl.innerHTML = '';
        var frag = document.createDocumentFragment();
        for (var i = 0; i < items.length; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ndev-closable-product-intro__images-dot';
          dot.setAttribute('aria-label', 'Image ' + (i + 1));
          dot.setAttribute('data-ndev-cpi-dot-index', String(i));
          frag.appendChild(dot);
        }
        rootEl.appendChild(frag);
        rootEl.setAttribute('data-ndev-cpi-dots-count', String(items.length));
      }

      function setDotsActive(activeIdx) {
        var rootEl = getDotsRoot();
        if (!rootEl) return;
        if (rootEl.hidden) return;
        var dots = rootEl.querySelectorAll('.ndev-closable-product-intro__images-dot');
        if (!dots.length) return;
        Array.prototype.forEach.call(dots, function (dot, i) {
          if (i === activeIdx) dot.classList.add('is-active');
          else dot.classList.remove('is-active');
        });
      }

      function scrollToIndex(items, idx, behavior) {
        if (!isMobileNow()) return;
        if (!items[idx]) return;

        var rootRect = root.getBoundingClientRect();
        var itemRect = items[idx].getBoundingClientRect();
        var currentLeft = root.scrollLeft;

        var itemCenter = (itemRect.left - rootRect.left) + currentLeft + itemRect.width / 2;
        var targetLeft = itemCenter - root.clientWidth / 2;
        var maxLeft = Math.max(0, root.scrollWidth - root.clientWidth);
        if (targetLeft < 0) targetLeft = 0;
        if (targetLeft > maxLeft) targetLeft = maxLeft;

        try {
          root.scrollTo({ left: targetLeft, behavior: behavior || 'auto' });
        } catch (e) {
          root.scrollLeft = targetLeft;
        }
      }

      function closestIndexToCenter(items) {
        var center = root.scrollLeft + root.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        for (var i = 0; i < items.length; i++) {
          var itemCenter = items[i].offsetLeft + items[i].offsetWidth / 2;
          var dist = Math.abs(itemCenter - center);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        }
        return best;
      }

      function closestIndexForScrollPosition(items) {
        if (!items.length) return 0;
        var maxLeft = Math.max(0, root.scrollWidth - root.clientWidth);
        var left = root.scrollLeft;
        var EDGE_EPS = 2;
        if (maxLeft <= EDGE_EPS) return closestIndexToCenter(items);
        if (left <= EDGE_EPS) return 0;
        if (maxLeft - left <= EDGE_EPS) return items.length - 1;
        return closestIndexToCenter(items);
      }

      function setActiveIndex(nextIdx, opts) {
        var items = getItems(root);
        if (!items.length) return;

        updatePagerVisibility(items);
        var idx = clamp(nextIdx, 0, items.length - 1);
        var prevIdx = parseInt(root.getAttribute(ACTIVE_ATTR), 10);
        var changed = (isNaN(prevIdx) || prevIdx !== idx);
        var force = !!(opts && opts.force);

        buildDots(items);

        if (force || changed) {
          root.setAttribute(ACTIVE_ATTR, String(idx));
          setActiveClass(items, idx);
          setDotsActive(idx);
        } else {
          // dots / class 可能因 DOM 更新丢失，这里仍保证一致
          setActiveClass(items, idx);
          setDotsActive(idx);
        }

        scheduleSyncOverlayHeight();

        if (opts && opts.scroll) {
          scrollToIndex(items, idx, opts.behavior || 'smooth');
        }

        if (opts && opts.report && items[idx]) {
          if (opts.reportMode === 'always') {
            reportGA4(items[idx]);
          } else {
            if (lastReportedIdx !== idx) {
              lastReportedIdx = idx;
              reportGA4(items[idx]);
            }
          }
        }
      }

      function syncToMode() {
        var items = getItems(root);
        if (!items.length) return;

        var idx = getActiveIndex(items);
        setActiveIndex(idx, { force: true, report: false, scroll: false });
        updatePagerVisibility(items);
        scheduleSyncOverlayHeight();

        if (isMobileNow()) {
          // 模式切换 + 媒体查询生效存在一帧延迟，双 rAF 让布局稳定后再对齐
          try {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                var liveItems = getItems(root);
                if (!liveItems.length) return;
                updatePagerVisibility(liveItems);
                var active = getActiveIndex(liveItems);
                scrollToIndex(liveItems, active, 'auto');
                scheduleSyncOverlayHeight();
              });
            });
          } catch (e) {
            // fallback
            scrollToIndex(items, idx, 'auto');
          }
        } else {
          try { root.scrollLeft = 0; } catch (e) {}
        }
      }

      function onDotsClick(e) {
        if (!isMobileNow()) return;
        var rootEl = getDotsRoot();
        if (!rootEl) return;
        if (rootEl.hidden) return;

        var target = e && e.target ? e.target : null;
        if (!target || !target.getAttribute) return;
        var raw = target.getAttribute('data-ndev-cpi-dot-index');
        if (raw == null) return;
        var idx = parseInt(raw, 10);
        if (isNaN(idx)) return;
        setActiveIndex(idx, { scroll: true, behavior: 'smooth', report: true, reportMode: 'always' });
      }

      function onRootMouseOver(e) {
        if (isMobileNow()) return;
        var t = e && e.target ? e.target : null;
        if (!t) return;
        var item = t.closest ? t.closest(ITEM_SELECTOR) : null;
        if (!item || !root.contains(item)) return;
        if (e.relatedTarget && item.contains(e.relatedTarget)) return;
        var items = getItems(root);
        var idx = Array.prototype.indexOf.call(items, item);
        if (idx < 0) return;
        setActiveIndex(idx, { report: true, reportMode: 'once' });
      }

      function onRootClick(e) {
        if (isMobileNow()) return;
        var t = e && e.target ? e.target : null;
        if (!t) return;
        var item = t.closest ? t.closest(ITEM_SELECTOR) : null;
        if (!item || !root.contains(item)) return;
        var items = getItems(root);
        var idx = Array.prototype.indexOf.call(items, item);
        if (idx < 0) return;
        setActiveIndex(idx, { report: true, reportMode: 'always' });
      }

      function onScroll() {
        if (!isMobileNow()) return;
        if ((root.scrollWidth - root.clientWidth) <= 1) return;
        if (scrollRaf) return;

        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          var items = getItems(root);
          if (!items.length) return;
          updatePagerVisibility(items);
          var idx = closestIndexForScrollPosition(items);

          // 滚动过程中只同步 UI（不刷屏上报）
          setActiveIndex(idx, { report: false, scroll: false });

          if (scrollEndTimer) clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(function () {
            var liveItems = getItems(root);
            if (!liveItems.length) return;
            var finalIdx = closestIndexForScrollPosition(liveItems);
            setActiveIndex(finalIdx, { report: true, reportMode: 'once', scroll: false });
          }, 140);
        });
      }

      function onResize() {
        if (!isMobileNow()) return;
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var items = getItems(root);
          if (!items.length) return;
          var showPager = updatePagerVisibility(items);
          var idx = getActiveIndex(items);
          if (showPager) scrollToIndex(items, idx, 'auto');
          scheduleSyncOverlayHeight();
        }, 120);
      }

      function onModeChange() {
        syncToMode();
      }

      function observeMutations() {
        if (!window.MutationObserver) return;
        mutationObserver = new MutationObserver(function () {
          // blocks 增删/重排后，重建 dots + 纠正 active index（不触发上报）
          var items = getItems(root);
          if (!items.length) return;
          var showPager = updatePagerVisibility(items);
          buildDots(items);
          var idx = getActiveIndex(items);
          setActiveIndex(idx, { force: true, report: false, scroll: false });
          if (showPager) scrollToIndex(items, idx, 'auto');
          scheduleSyncOverlayHeight();
        });
        mutationObserver.observe(root, { childList: true });
        cleanup.push(function () {
          try { mutationObserver.disconnect(); } catch (e) {}
          mutationObserver = null;
        });
      }

      controller.refresh = function () {
        var items = getItems(root);
        if (!items.length) return;
        buildDots(items);
        var idx = getActiveIndex(items);
        setActiveIndex(idx, { force: true, report: false, scroll: false });
        syncToMode();
        scheduleSyncOverlayHeight();
      };

      controller.destroy = function () {
        if (scrollEndTimer) clearTimeout(scrollEndTimer);
        if (resizeTimer) clearTimeout(resizeTimer);
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        if (overlayRaf) cancelAnimationFrame(overlayRaf);
        for (var i = 0; i < cleanup.length; i++) cleanup[i]();
        cleanup = [];
        dotsRoot = null;
        try { delete root.__ndevCpiImagesController; } catch (e) {}
        try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        try { root.classList.remove('is-ready'); } catch (e) {}
      };

      // bind
      on(root, 'mouseover', onRootMouseOver);
      on(root, 'click', onRootClick);
      on(root, 'scroll', onScroll, { passive: true });
      on(window, 'resize', onResize);

      var dRoot = getDotsRoot();
      if (dRoot) on(dRoot, 'click', onDotsClick);

      if (mql) {
        if (typeof mql.addEventListener === 'function') {
          mql.addEventListener('change', onModeChange);
          cleanup.push(function () { try { mql.removeEventListener('change', onModeChange); } catch (e) {} });
        } else if (typeof mql.addListener === 'function') {
          mql.addListener(onModeChange);
          cleanup.push(function () { try { mql.removeListener(onModeChange); } catch (e) {} });
        }
      }

      observeMutations();
      root.setAttribute(INIT_ATTR, '1');
      controller.refresh();
      if (!root.classList.contains('is-ready')) root.classList.add('is-ready');

      // 字体加载 / 图片 overlay 内容渲染后再对齐一次
      on(window, 'load', scheduleSyncOverlayHeight);
      on(root, 'transitionend', function (e) {
        // overlay 描述展开/收起会触发 transition，这里兜底重算
        var t = e && e.target ? e.target : null;
        if (!t || !t.classList) return;
        if (t.classList.contains('ndev-closable-product-intro__image-overlay-desc')) scheduleSyncOverlayHeight();
      });
      return controller;
    }

    function initImages(root) {
      if (!root) return;
      var items = getItems(root);
      if (!items.length) return;

      if (root.__ndevCpiImagesController && root.__ndevCpiImagesController.refresh) {
        root.__ndevCpiImagesController.refresh();
        return;
      }

      root.__ndevCpiImagesController = createController(root);
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var roots = base.querySelectorAll(IMAGES_SELECTOR);
      Array.prototype.forEach.call(roots, initImages);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e && e.target ? e.target : null);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var scope = e && e.target ? e.target : null;
      if (!scope || !scope.querySelectorAll) return;
      var roots = scope.querySelectorAll(IMAGES_SELECTOR);
      Array.prototype.forEach.call(roots, function (root) {
        if (root && root.__ndevCpiImagesController && root.__ndevCpiImagesController.destroy) {
          root.__ndevCpiImagesController.destroy();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-cpi-media"] && !Shopify.designMode) return;
  try {
    (function () {
    var ROOT_SELECTOR = '[data-ndev-cpi-media]';
    var INIT_ATTR = 'data-ndev-cpi-media-init';

    function toBool(raw) {
      return raw === true || raw === 'true' || raw === '1';
    }

    function isInActiveTabPanel(root) {
      var panel = root.closest('.ndev-cpi-tabs__panel');
      if (!panel) return true;
      return panel.classList.contains('active');
    }

    function ensureInlineVideoAttrs(video) {
      if (!video) return;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function safePause(video, resetOnResume) {
      if (!video) return;
      try {
        video.pause();
      } catch (e) {}
      if (resetOnResume) {
        try {
          video.currentTime = 0;
        } catch (e) {}
      }
    }

    function safePlay(video) {
      if (!video) return;
      try {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR)) return;

      var kind = root.getAttribute('data-media-kind') || 'image';
      if (kind !== 'video') {
        root.setAttribute(INIT_ATTR, '1');
        return;
      }

      var video = root.querySelector('video');
      if (!video) {
        root.setAttribute(INIT_ATTR, '1');
        return;
      }

      ensureInlineVideoAttrs(video);

      var autoplayEnabled = toBool(root.getAttribute('data-autoplay'));
      var loopEnabled = toBool(root.getAttribute('data-loop'));
      var resetOnResume = toBool(root.getAttribute('data-reset-on-resume'));

      video.loop = loopEnabled;

      var inView = false;

      function sync() {
        var active = isInActiveTabPanel(root);
        var eligible = inView && active && !document.hidden;

        if (!eligible) {
          safePause(video, resetOnResume);
          return;
        }

        if (autoplayEnabled) {
          if (!video.muted) video.muted = true;
          safePlay(video);
        }
      }

      root.__ndevCpiMediaSync = sync;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.target !== root) return;
              inView = !!entry.isIntersecting;
            });
            sync();
          },
          { root: null, rootMargin: '0px 0px 0px 0px', threshold: 0.35 }
        );
        observer.observe(root);
      } else {
        inView = true;
        sync();
      }

      document.addEventListener('visibilitychange', function () {
        sync();
      });

      var tabsRoot = root.closest('.ndev-closable-product-intro__tabs-block');
      if (tabsRoot && !tabsRoot.getAttribute('data-ndev-cpi-media-tabs-bound')) {
        tabsRoot.setAttribute('data-ndev-cpi-media-tabs-bound', '1');
        var titles = tabsRoot.querySelector('.ndev-cpi-tabs__titles');
        if (titles) {
          titles.addEventListener('click', function () {
            setTimeout(function () {
              initAll(tabsRoot);
              tabsRoot.querySelectorAll(ROOT_SELECTOR).forEach(function (r) {
                if (typeof r.__ndevCpiMediaSync === 'function') r.__ndevCpiMediaSync();
              });
            }, 0);
          });
        }
      }

      root.setAttribute(INIT_ATTR, '1');
    }

    function initAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e && e.target ? e.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-cpi-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var CARD_SELECTOR = '[data-ndev-closable-product-intro-card]';
    var INIT_ATTR = 'data-ndev-cpi-card-init';

    function initCard(card) {
      if (card.getAttribute(INIT_ATTR)) return;

      var closeBtn = card.querySelector('[data-ndev-closable-product-intro-close]');
      var reopenBtns = card.querySelectorAll('[data-ndev-closable-product-intro-reopen]');

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          card.classList.add('is-collapsed');
        });
      }

      reopenBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          card.classList.remove('is-collapsed');
        });
      });

      card.setAttribute(INIT_ATTR, '1');
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      base.querySelectorAll(CARD_SELECTOR).forEach(initCard);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e && e.target ? e.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-event-calendar-tabs"] && !Shopify.designMode) return;
  try {
    class NdevEventCalendarTabs extends BaseElement {
    createdCallback() {}

    init() {
      this.titlesContainer = this.querySelector('.ndev-event-calendar-tabs__titles');
      if (!this.titlesContainer) return;

      this.indicator = document.createElement('div');
      this.indicator.className = 'ndev-event-calendar-tabs__indicator';
      this.titlesContainer.insertBefore(this.indicator, this.titlesContainer.firstChild);

      requestAnimationFrame(() => {
        this.positionIndicator();
        this.setupObservers();
      });
    }

    positionIndicator() {
      if (!this.indicator || !this.titlesContainer) return;
      const activeTab = this.titlesContainer.querySelector('ui-tab[open]');
      if (!activeTab) {
        this.indicator.style.opacity = '0';
        return;
      }

      const containerRect = this.titlesContainer.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();

      this.indicator.style.transform = `translate(${tabRect.left - containerRect.left}px, ${tabRect.top - containerRect.top}px)`;
      this.indicator.style.width = `${tabRect.width}px`;
      this.indicator.style.height = `${tabRect.height}px`;
      this.indicator.style.opacity = '1';
    }

    setupObservers() {
      if (!this.titlesContainer) return;
      let rafId = null;

      const scheduleUpdate = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          this.positionIndicator();
        });
      };

      this.mutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            scheduleUpdate();
            return;
          }
          if (mutation.type === 'childList') {
            scheduleUpdate();
            return;
          }
        }
      });

      this.mutationObserver.observe(this.titlesContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['open']
      });

      this.resizeObserver = new ResizeObserver(() => {
        scheduleUpdate();
      });
      this.resizeObserver.observe(this.titlesContainer);
    }

    dispose() {
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      if (this.indicator) {
        this.indicator.remove();
        this.indicator = null;
      }
      this.titlesContainer = null;
    }

    static get observedAttributes() {
      return [''];
    }

    attributeChangedCallback(name, oldValue, newValue) {}
  }
  if (!customElements.get('ndev-event-calendar-tabs')) {
    customElements.define('ndev-event-calendar-tabs', NdevEventCalendarTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-event-card"] && !Shopify.designMode) return;
  try {
    (function() {
    const MQL = window.matchMedia('(max-width: 1023px)');
    let enabled = MQL.matches;

    MQL.addEventListener('change', function(e) {
      enabled = e.matches;
    });

    document.addEventListener('click', function(e) {
      if (!enabled) return;

      const card = e.target.closest('.ndev-event-card');
      if (!card) return;

      const panel = card.closest('.ndev-event-calendar-tabs__panel');
      const hasEnd = card.classList.contains('card-has-end');
      const hasStart = card.classList.contains('card-has-start');

      if (
        card.classList.contains('is-expired') ||
        (!hasEnd && panel && panel.classList.contains('is-expired')) ||
        card.classList.contains('is-pending') ||
        (!hasStart && panel && panel.classList.contains('is-pending'))
      ) return;

      const link = card.querySelector('.ndev-event-card__link .ndev-button__btn');
      if (!link) return;

      if (link.contains(e.target)) return;

      link.click();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-home-feature-points-tabs"] && !Shopify.designMode) return;
  try {
    class NdevHomeFeaturePointsTabs extends BaseElement {
    init() {
      this.dispose();

      this.layout = this.querySelector('.ndev-home-feature-points-tabs__layout');
      this.listeners = [];
      this.items = this.layout
        ? Array.from(this.layout.children)
            .filter((item) => item.classList.contains('ndev-home-feature-point-tab'))
            .map((root) => ({
              root,
              trigger: root.querySelector(':scope > .ndev-home-feature-point-tab__trigger'),
              description: root.querySelector('.ndev-home-feature-point-tab__description'),
              panel: root.querySelector(':scope > .ndev-home-feature-point-tab__panel'),
            }))
            .filter((item) => item.trigger && item.panel)
        : [];

      if (!this.items.length) return;

      this.setAttribute('enhanced', '');

      this.items.forEach((item) => {
        item.trigger.disabled = false;
        this.listen(item.trigger, 'click', () => this.activate(item));
        this.listen(item.trigger, 'keydown', (event) => this.handleKeydown(event, item));
      });

      this.listen(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));

      const initialItem = this.items.find((item) => item.root.getAttribute('default-active') === 'true') || this.items[0];
      this.activate(initialItem);
    }

    listen(target, type, handler) {
      target.addEventListener(type, handler);
      this.listeners.push({ target, type, handler });
    }

    activate(nextItem) {
      if (!nextItem || !this.items.includes(nextItem)) return;

      this.items.forEach((item) => {
        const isActive = item === nextItem;

        item.trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        if (isActive && item.description) {
          item.trigger.setAttribute('aria-describedby', item.description.id);
        } else {
          item.trigger.removeAttribute('aria-describedby');
        }
        item.panel.toggleAttribute('hidden', !isActive);
        item.panel.toggleAttribute('inert', !isActive);
        this.syncMedia(item.panel, isActive ? 'play' : 'pause');
      });
    }

    syncMedia(panel, action) {
      const eventName = panel.getAttribute('media-toggle-event');
      if (!eventName) return;

      document.dispatchEvent(new CustomEvent(eventName, { detail: { action } }));
    }

    handleKeydown(event, currentItem) {
      const currentIndex = this.items.indexOf(currentItem);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.items.length;
      else if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.items.length) % this.items.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = this.items.length - 1;
      else return;

      event.preventDefault();
      this.items[nextIndex].trigger.focus({ preventScroll: true });
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;

      const selectedRoot = event.target.closest('.ndev-home-feature-point-tab');
      const selectedItem = this.items.find((item) => item.root === selectedRoot);
      if (selectedItem) this.activate(selectedItem);
    }

    dispose() {
      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler }) => target.removeEventListener(type, handler));
      }

      if (this.items) {
        this.items.forEach((item) => {
          this.syncMedia(item.panel, 'pause');
        });
      }

      this.listeners = [];
      this.items = [];
      this.layout = null;
      this.removeAttribute('enhanced');
    }
  }

  if (!customElements.get('ndev-home-feature-points-tabs')) {
    customElements.define('ndev-home-feature-points-tabs', NdevHomeFeaturePointsTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-home-kol-tabs"] && !Shopify.designMode) return;
  try {
    class NdevHomeKolTabs extends BaseElement {
    init() {
      this.dispose();

      this.listeners = [];
      this.layout = this.querySelector('.ndev-home-kol-tabs__layout');
      this.items = Array.from(this.querySelectorAll('.ndev-home-kol-tab'))
        .map((root) => ({
          root,
          trigger: root.querySelector(':scope > .ndev-home-kol-tab__trigger'),
          panel: root.querySelector(':scope > .ndev-home-kol-tab__panel'),
        }))
        .filter((item) => item.trigger && item.panel);

      if (!this.items.length) return;

      this.items.forEach((item) => {
        this.listen(item.trigger, 'click', () => this.activate(item));
      });
      this.listen(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));

      const initialItem =
        this.items.find((item) => item.trigger.getAttribute('aria-expanded') === 'true' && !item.panel.hidden) ||
        this.items[0];
      this.activate(initialItem);
      this.setupIndicator();
    }

    listen(target, type, handler) {
      target.addEventListener(type, handler);
      this.listeners.push({ target, type, handler });
    }

    activate(nextItem) {
      if (!nextItem || !this.items.includes(nextItem)) return;

      this.items.forEach((item) => {
        const isActive = item === nextItem;
        item.trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        item.panel.toggleAttribute('hidden', !isActive);
        item.panel.toggleAttribute('inert', !isActive);
      });

      this.scheduleIndicatorUpdate();
    }

    setupIndicator() {
      if (!this.layout || this.items.length <= 1) return;

      this.listen(window, 'resize', () => this.scheduleIndicatorUpdate());
      if (document.fonts?.addEventListener) {
        this.listen(document.fonts, 'loadingdone', () => this.scheduleIndicatorUpdate());
      }

      if ('ResizeObserver' in window) {
        this.indicatorResizeObserver = new ResizeObserver(() => this.scheduleIndicatorUpdate());
        this.indicatorResizeObserver.observe(this.layout);
        this.items.forEach((item) => this.indicatorResizeObserver.observe(item.trigger));
      }

      this.scheduleIndicatorUpdate();
    }

    scheduleIndicatorUpdate() {
      if (!this.layout || this.items.length <= 1 || this.indicatorFrame) return;

      this.indicatorFrame = requestAnimationFrame(() => {
        this.indicatorFrame = null;
        this.updateIndicator();
      });
    }

    updateIndicator() {
      const activeItem = this.items.find((item) => item.trigger.getAttribute('aria-expanded') === 'true');
      if (!this.layout || !activeItem) return;

      const layoutRect = this.layout.getBoundingClientRect();
      const tabRect = activeItem.trigger.getBoundingClientRect();
      this.layout.style.setProperty('--ndev-home-kol-indicator-x', `${tabRect.left - layoutRect.left}px`);
      this.layout.style.setProperty('--ndev-home-kol-indicator-width', `${tabRect.width}px`);

      if (this.hasAttribute('indicator-ready')) return;

      this.setAttribute('indicator-ready', '');
      this.indicatorAnimationFrame = requestAnimationFrame(() => {
        this.indicatorAnimationFrame = null;
        if (this.isConnected) this.setAttribute('indicator-animated', '');
      });
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;

      const selectedRoot = event.target.closest('.ndev-home-kol-tab');
      const selectedItem = this.items.find((item) => item.root === selectedRoot);
      if (selectedItem) this.activate(selectedItem);
    }

    dispose() {
      if (this.indicatorFrame) cancelAnimationFrame(this.indicatorFrame);
      if (this.indicatorAnimationFrame) cancelAnimationFrame(this.indicatorAnimationFrame);
      if (this.indicatorResizeObserver) this.indicatorResizeObserver.disconnect();

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler }) => target.removeEventListener(type, handler));
      }

      this.removeAttribute('indicator-ready');
      this.removeAttribute('indicator-animated');
      if (this.layout) {
        this.layout.style.removeProperty('--ndev-home-kol-indicator-x');
        this.layout.style.removeProperty('--ndev-home-kol-indicator-width');
      }

      this.indicatorFrame = null;
      this.indicatorAnimationFrame = null;
      this.indicatorResizeObserver = null;
      this.listeners = [];
      this.layout = null;
      this.items = [];
    }
  }

  if (!customElements.get('ndev-home-kol-tabs')) {
    customElements.define('ndev-home-kol-tabs', NdevHomeKolTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-j68-subscribe-form"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ndev-j68-subscribe-form')) return;

    const dialogScrollLockOwners = new Set();
    let bodyOverflowBeforeDialog = '';

    const lockBodyScroll = (owner) => {
      if (!document.body || dialogScrollLockOwners.has(owner)) return;
      if (dialogScrollLockOwners.size === 0) {
        bodyOverflowBeforeDialog = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      dialogScrollLockOwners.add(owner);
    };

    const unlockBodyScroll = (owner) => {
      if (!dialogScrollLockOwners.delete(owner) || dialogScrollLockOwners.size > 0 || !document.body) return;
      document.body.style.overflow = bodyOverflowBeforeDialog;
      bodyOverflowBeforeDialog = '';
    };

    class NdevJ68SubscribeForm extends BaseElement {
      init() {
      this._generation = (this._generation || 0) + 1;
      this._form = this.querySelector('form');
      this._input = this.querySelector('input[type="email"]');
      this._checkbox = this.querySelector('input[type="checkbox"]');
      this._button = this.querySelector('button[type="submit"]');
      this._buttonText = this.querySelector('.ndev-j68-subscribe-form__button-text');
      this._message = this.querySelector('[data-message]');
      this._inlineSuccess = this.querySelector('[data-inline-success]');
      this._urgencyMessages = Array.from(this.querySelectorAll('[data-urgency-message]'));
      this._dialogLayer = this.querySelector('[data-success-dialog]');
      this._dialog = this._dialogLayer ? this._dialogLayer.querySelector('[role="dialog"]') : null;
      this._dialogClose = this.querySelector('[data-dialog-close]');
      this._defaultButtonText = this.getAttribute('button-text') || (this._buttonText ? this._buttonText.textContent : '');
      this._isSubmitting = false;
      this._statsRequestId = 0;
      this._latestStatsTiers = [];
      this._activeTier = null;
      this._isSuccessLocked = false;
      this._dialogCloseTimer = null;
      this._klaviyoWait = null;
      this._onSubmit = this._handleSubmit.bind(this);
      this._onInput = this._hideMessages.bind(this);
      this._onDialogClose = () => this._closeDialog();
      this._onDialogBackdrop = (event) => {
        if (event.target === this._dialogLayer) this._closeDialog();
      };
      this._onDialogKeydown = this._handleDialogKeydown.bind(this);

      this._resetUiState();

      if (this._form) this._form.addEventListener('submit', this._onSubmit);
      if (this._input) this._input.addEventListener('input', this._onInput);
      if (this._checkbox) this._checkbox.addEventListener('change', this._onInput);
      if (this._dialogClose) this._dialogClose.addEventListener('click', this._onDialogClose);
      if (this._dialogLayer) this._dialogLayer.addEventListener('click', this._onDialogBackdrop);
      document.addEventListener('keydown', this._onDialogKeydown);

      this._syncUrgencyFromConfig();
      this._syncStatusesFromConfig();
      this._refreshStats();
      }

      _resetUiState() {
      unlockBodyScroll(this);
      this.classList.remove('is-loading', 'is-error', 'is-success', 'is-success-locked');
      this.setAttribute('aria-busy', 'false');
      if (this._input) this._input.disabled = false;
      if (this._checkbox) this._checkbox.disabled = false;
      if (this._button) this._button.disabled = false;
      if (this._message) {
        this._message.hidden = true;
        this._message.removeAttribute('role');
        this._message.setAttribute('aria-live', 'polite');
        this._message.replaceChildren();
      }
      if (this._inlineSuccess) this._inlineSuccess.hidden = true;
      if (this._dialogLayer) {
        this._dialogLayer.hidden = true;
        this._dialogLayer.classList.remove('is-open', 'is-closing');
      }
      this._clearInvalidFields();
      this._updateButtonText();
      }

      dispose() {
      this._generation = (this._generation || 0) + 1;
      this._statsRequestId = (this._statsRequestId || 0) + 1;
      if (this._form && this._onSubmit) this._form.removeEventListener('submit', this._onSubmit);
      if (this._input && this._onInput) this._input.removeEventListener('input', this._onInput);
      if (this._checkbox && this._onInput) this._checkbox.removeEventListener('change', this._onInput);
      if (this._dialogClose && this._onDialogClose) this._dialogClose.removeEventListener('click', this._onDialogClose);
      if (this._dialogLayer && this._onDialogBackdrop) this._dialogLayer.removeEventListener('click', this._onDialogBackdrop);
      if (this._onDialogKeydown) document.removeEventListener('keydown', this._onDialogKeydown);
      this._cancelKlaviyoWait();
      this._finishDialogClose(false);
      this._form = null;
      this._input = null;
      this._checkbox = null;
      this._button = null;
      this._buttonText = null;
      this._message = null;
      this._inlineSuccess = null;
      this._urgencyMessages = null;
      this._dialogLayer = null;
      this._dialog = null;
      this._dialogClose = null;
      this._isSubmitting = false;
      this._latestStatsTiers = [];
      this._activeTier = null;
      this._isSuccessLocked = false;
      }

    async _handleSubmit(event) {
      event.preventDefault();
      if (this._isSubmitting || this._isSuccessLocked) return;
      const generation = this._generation;
      const email = this._input ? this._input.value.trim() : '';
      if (!email) {
        this._showError(this.getAttribute('email-empty-message'), 'email');
        return;
      }

      this._isSubmitting = true;
      this._setLoading(true);
      this._hideMessages();

      try {
        const klaviyo = await this._getKlaviyoApi(generation);
        if (!this._isGenerationCurrent(generation)) return;
        if (!klaviyo) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }
        if (!klaviyo.validateEmail(email)) {
          this._showError(this.getAttribute('email-invalid-message'), 'email');
          return;
        }
        if (this.getAttribute('require-agreement') === 'true' && this._checkbox && !this._checkbox.checked) {
          this._showError(this.getAttribute('agreement-required-message'), 'agreement');
          return;
        }

        const groupConfig = this._readTierConfig();
        if (!groupConfig || !groupConfig.apiHost || !groupConfig.activityCode || !groupConfig.countryCode || !groupConfig.companyId || !this._hasRequiredTierConfig(groupConfig.tiers)) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }
        if (!window.$countSubscribe || !window.$countSubscribe.issueCoupon) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }

        const issueResult = await window.$countSubscribe.issueCoupon({
          apiHost: groupConfig.apiHost,
          activityCode: groupConfig.activityCode,
          countryCode: groupConfig.countryCode,
          email: email
        });
        if (!this._isGenerationCurrent(generation)) return;
        if (!issueResult || !issueResult.success || !issueResult.data) {
          this._showError(this._parseErrorMessage(issueResult && issueResult.error));
          return;
        }

        const coupon = issueResult.data;
        const couponCode = coupon.couponCode ? String(coupon.couponCode).trim() : '';
        const hasCouponIdentity = Boolean(coupon.klaviyoGroupKey || coupon.couponName);
        if (hasCouponIdentity && this._latestStatsTiers.length === 0) {
          await this._refreshStats();
          if (!this._isGenerationCurrent(generation)) return;
        }
        const tier = this._findTierForCoupon(coupon, groupConfig.tiers);
        if (!tier || !tier.listId || !tier.profilePropertyKey || !couponCode) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }

        const properties = {};
        properties[tier.profilePropertyKey] = couponCode;
        const klaviyoResult = await this._updateProfileAndSubscribe({
          email,
          apiKey: groupConfig.companyId,
          listId: tier.listId,
          properties,
          klaviyo,
          ga4: this._readGa4Config(),
          generation
        });
        if (!this._isGenerationCurrent(generation)) return;

        if (klaviyoResult && klaviyoResult.success) {
          this._recordFakeTierSubscription(tier, coupon.newlyIssued !== false);
          this._showSuccess();
          this._lockSuccessForm();
          this._openDialog();
          this._refreshStats();
        } else {
          this._showError(this._parseErrorMessage(klaviyoResult && klaviyoResult.error));
        }
      } catch (error) {
        if (this._isGenerationCurrent(generation)) {
          this._showError(this._parseErrorMessage(error && error.message));
        }
      } finally {
        if (this._isGenerationCurrent(generation)) {
          this._isSubmitting = false;
          this._setLoading(false);
        }
      }
    }

    _isGenerationCurrent(generation) {
      return this.isConnected && generation === this._generation;
    }

    _readTierConfig() {
      const scope = this._getTierScope();
      const scripts = scope ? Array.from(scope.querySelectorAll('[data-j68-tier-item-config]')) : [];
      if (scripts.length === 0) return null;
      const tiers = scripts.map((script) => {
        try {
          return JSON.parse(script.textContent || '{}');
        } catch (error) {
          return null;
        }
      }).filter(Boolean);
      return {
        apiHost: String(this.getAttribute('api-host') || '').trim(),
        activityCode: String(this.getAttribute('activity-code') || '').trim(),
        countryCode: String(this.getAttribute('country-code') || '').trim(),
        companyId: String(this.getAttribute('company-id') || '').trim(),
        tiers: tiers.map((tier) => this._normalizeTier(tier))
      };
    }

    _hasRequiredTierConfig(tiers) {
      return Array.isArray(tiers) && tiers.length > 0 && tiers.every((tier) => tier && tier.listId && tier.profilePropertyKey);
    }

    _readGa4Config() {
      const eventName = String(this.getAttribute('ga4-event') || '').trim();
      if (!eventName) return undefined;
      return {
        event: eventName,
        module: this.getAttribute('ga4-module') || '',
        btn: this.getAttribute('ga4-button') || ''
      };
    }

    _getKlaviyoApi(generation) {
      if (window.$klaviyo && window.$klaviyo.subscribe && window.$klaviyo.updateProfile && window.$klaviyo.validateEmail) {
        return Promise.resolve(window.$klaviyo);
      }
      this._cancelKlaviyoWait();
      return new Promise((resolve) => {
        const finish = (api) => {
          if (!this._klaviyoWait) return;
          window.clearTimeout(this._klaviyoWait.timeout);
          window.removeEventListener('ndev:klaviyo-api-ready', this._klaviyoWait.handleReady);
          this._klaviyoWait = null;
          resolve(api);
        };
        const handleReady = () => {
          const api = this._isGenerationCurrent(generation) && window.$klaviyo && window.$klaviyo.subscribe && window.$klaviyo.updateProfile && window.$klaviyo.validateEmail
            ? window.$klaviyo
            : null;
          finish(api);
        };
        const timeout = window.setTimeout(() => finish(null), 3000);
        this._klaviyoWait = { timeout, handleReady, promiseResolve: resolve };
        window.addEventListener('ndev:klaviyo-api-ready', handleReady);
      });
    }

    _cancelKlaviyoWait() {
      if (!this._klaviyoWait) return;
      const wait = this._klaviyoWait;
      window.clearTimeout(wait.timeout);
      window.removeEventListener('ndev:klaviyo-api-ready', wait.handleReady);
      this._klaviyoWait = null;
      wait.promiseResolve(null);
    }

    _normalizeTier(tier) {
      return {
        ...tier,
        listId: tier && tier.listId ? String(tier.listId).trim() : '',
        profilePropertyKey: tier && tier.profilePropertyKey ? String(tier.profilePropertyKey).trim() : '',
        tierId: tier && tier.tierId ? String(tier.tierId).trim() : '',
        progressMode: tier && tier.progressMode ? String(tier.progressMode).trim() : 'real',
        isActive: Boolean(tier && tier.isActive),
        progressPercent: this._clampPercent(Number(tier && tier.progressPercent ? tier.progressPercent : 0)),
        displayCapacity: Math.max(1, Number(tier && tier.displayCapacity ? tier.displayCapacity : 1)),
        remainingDisplayCount: Math.max(0, Number(tier && tier.remainingDisplayCount ? tier.remainingDisplayCount : 0)),
        remainingPercent: this._clampPercent(Number(tier && tier.remainingPercent ? tier.remainingPercent : 0)),
        showUrgency: Boolean(tier && tier.showUrgency),
        urgencyThresholdPercent: this._clampPercent(Number(tier && tier.urgencyThresholdPercent ? tier.urgencyThresholdPercent : 0))
      };
    }

    _getStorageKey(tier) {
      const tierId = tier && tier.tierId ? String(tier.tierId).trim() : 'unknown-tier';
      return `ndev:j68-subscribe:progress:${tierId}`;
    }

    _readFakeProgressState(tier) {
      try {
        const raw = window.localStorage ? window.localStorage.getItem(this._getStorageKey(tier)) : '';
        if (!raw) return { claimedCount: null };
        const data = JSON.parse(raw);
        return {
          claimedCount: Number.isFinite(Number(data.claimedCount)) ? Math.max(0, Math.floor(Number(data.claimedCount))) : null
        };
      } catch (error) {
        return { claimedCount: null };
      }
    }

    _writeFakeProgressState(tier, state) {
      try {
        if (!window.localStorage) return;
        window.localStorage.setItem(this._getStorageKey(tier), JSON.stringify({
          claimedCount: Math.max(0, Math.floor(Number(state && state.claimedCount ? state.claimedCount : 0)))
        }));
      } catch (error) {}
    }

    _getConfiguredFakeClaimedCount(tier) {
      const capacity = Math.max(1, Number(tier && tier.displayCapacity ? tier.displayCapacity : 1));
      const percent = this._clampPercent(Number(tier && tier.progressPercent ? tier.progressPercent : 0));
      return Math.min(capacity, Math.floor(capacity * (percent + Math.random()) / 100));
    }

    _resolveFakeProgressState(tier) {
      const state = this._readFakeProgressState(tier);
      const claimedCount = Math.max(this._getConfiguredFakeClaimedCount(tier), Number(state.claimedCount || 0));
      if (claimedCount !== state.claimedCount) this._writeFakeProgressState(tier, { claimedCount });
      return { claimedCount };
    }

    _recordFakeTierSubscription(tier, shouldIncrement) {
      if (!tier || tier.progressMode !== 'fake' || !shouldIncrement) return;
      const state = this._resolveFakeProgressState(tier);
      this._writeFakeProgressState(tier, { claimedCount: Number(state.claimedCount || 0) + 1 });
    }

    _getTierScope() {
      return this.closest('.ndev-j68-subscribe__subscribe') || this.closest('.ndev-j68-subscribe__content') || this.parentElement;
    }

    async _refreshStats() {
      const config = this._readTierConfig();
      if (!config || !config.apiHost || !config.activityCode || !config.countryCode || !window.$countSubscribe || !window.$countSubscribe.getStats) return;
      const requestId = ++this._statsRequestId;
      const generation = this._generation;
      const result = await window.$countSubscribe.getStats({
        apiHost: config.apiHost,
        activityCode: config.activityCode,
        countryCode: config.countryCode
      });
      if (!this._isGenerationCurrent(generation) || requestId !== this._statsRequestId) return;
      if (result && result.success && result.data) this._applyStats(result.data);
    }

    _applyStats(stats) {
      const config = this._readTierConfig();
      const statsTiers = stats && Array.isArray(stats.tiers) ? stats.tiers : [];
      if (!config || config.tiers.length === 0 || statsTiers.length === 0) {
        this._syncUrgencyFromConfig();
        return;
      }
      const activeStat = statsTiers.find((tier) => {
        const total = Number(tier && tier.total ? tier.total : 0);
        const issued = Number(tier && tier.issued ? tier.issued : 0);
        return total > 0 && issued < total;
      }) || statsTiers[statsTiers.length - 1];
      const activeIndex = Math.max(0, statsTiers.indexOf(activeStat));
      this._latestStatsTiers = statsTiers;
      this._activeTier = config.tiers[activeIndex] || null;
      config.tiers.forEach((tier, index) => {
        this._updateTierDom(tier.tierId, this._resolveTierView(tier, statsTiers[index] || null, index === activeIndex));
      });
      this._syncUrgencyFromConfig();
      this._updateButtonText();
    }

    _resolveTierView(tier, stat, isActive) {
      const total = Math.max(1, Number(stat && stat.total ? stat.total : tier.displayCapacity || 1));
      const issued = Math.max(0, Number(stat && stat.issued ? stat.issued : 0));
      let displayCapacity = total;
      let claimedDisplayCount = Math.min(issued, total);
      let progressPercent = this._clampPercent(Math.round(issued / total * 100));
      if (tier.progressMode === 'fake') {
        displayCapacity = tier.displayCapacity || total;
        if (isActive) {
          claimedDisplayCount = Math.min(displayCapacity, this._resolveFakeProgressState(tier).claimedCount);
          progressPercent = this._clampPercent(Math.round(claimedDisplayCount / displayCapacity * 100));
        } else {
          claimedDisplayCount = 0;
          progressPercent = 0;
        }
      }
      const remainingDisplayCount = Math.max(0, displayCapacity - claimedDisplayCount);
      const remainingPercent = this._clampPercent(100 - progressPercent);
      return {
        isActive,
        isFull: Boolean(stat && Number(stat.total || 0) > 0 && Number(stat.issued || 0) >= Number(stat.total || 0)),
        progressPercent,
        displayCapacity,
        claimedDisplayCount,
        remainingDisplayCount,
        remainingPercent,
        showUrgency: Boolean(tier.showUrgency && isActive && remainingPercent <= tier.urgencyThresholdPercent),
        urgencyThresholdPercent: tier.urgencyThresholdPercent
      };
    }

    _updateTierDom(tierId, view) {
      if (!tierId) return;
      const scope = this._getTierScope();
      const escapedId = window.CSS && CSS.escape ? CSS.escape(tierId) : tierId;
      const tierEl = scope ? scope.querySelector(`[data-tier-id="${escapedId}"]`) : null;
      if (!tierEl) return;
      tierEl.classList.toggle('is-active', view.isActive);
      tierEl.setAttribute('data-tier-active', view.isActive ? 'true' : 'false');
      tierEl.setAttribute('data-tier-full', view.isFull ? 'true' : 'false');
      tierEl.setAttribute('data-urgency-visible', view.showUrgency ? 'true' : 'false');
      tierEl.style.setProperty('--j68-tier-progress', `${view.progressPercent}%`);
      const statusNode = tierEl.querySelector('[data-tier-status-text]');
      if (statusNode) statusNode.textContent = this._resolveTierStatusText(view);
      const configScript = tierEl.querySelector('[data-j68-tier-item-config]');
      if (!configScript) return;
      try {
        const data = JSON.parse(configScript.textContent || '{}');
        configScript.textContent = JSON.stringify({
          ...data,
          ...view,
          showUrgency: Boolean(data.showUrgency),
          urgencyVisible: view.showUrgency
        });
      } catch (error) {}
    }

    _syncStatusesFromConfig() {
      const config = this._readTierConfig();
      if (!config) return;
      config.tiers.forEach((tier) => {
        const scope = this._getTierScope();
        const escapedId = window.CSS && CSS.escape ? CSS.escape(tier.tierId) : tier.tierId;
        const tierEl = scope && tier.tierId ? scope.querySelector(`[data-tier-id="${escapedId}"]`) : null;
        const statusNode = tierEl ? tierEl.querySelector('[data-tier-status-text]') : null;
        if (statusNode) statusNode.textContent = this._resolveTierStatusText(tier);
      });
    }

    _resolveTierStatusText(view) {
      const text = this._readStatusTextConfig();
      if (view && view.isFull) return text.full;
      if (view && view.isActive) return text.active;
      return text.pending;
    }

    _readStatusTextConfig() {
      const scope = this._getTierScope();
      const group = scope ? scope.querySelector('.ndev-j68-tier-group') : null;
      return {
        pending: (group && group.getAttribute('data-pending-status-text')) || 'NEXT TIER',
        active: (group && group.getAttribute('data-active-status-text')) || 'OPEN NOW',
        full: (group && group.getAttribute('data-full-status-text')) || 'FULL'
      };
    }

    _syncUrgencyFromConfig() {
      const config = this._readTierConfig();
      const activeTier = config ? config.tiers.find((tier) => tier.isActive) : null;
      if (!activeTier || !activeTier.showUrgency || !activeTier.urgencyVisible) {
        this._setUrgency(null);
        return;
      }
      this._setUrgency(activeTier);
    }

    _setUrgency(tier) {
      if (!this._urgencyMessages) return;
      if (!tier) {
        this._urgencyMessages.forEach((node) => {
          const wrap = node.closest('[data-urgency-message-wrap]');
          if (wrap) wrap.hidden = true;
          node.hidden = true;
          node.textContent = '';
        });
        return;
      }
      const text = (this.getAttribute('urgency-template') || '{remaining} of {total} spots left')
        .replace(/\{remaining\}/g, String(tier.remainingDisplayCount))
        .replace(/\{total\}/g, String(tier.displayCapacity))
        .replace(/\{percent\}/g, String(tier.remainingPercent));
      this._urgencyMessages.forEach((node) => {
        const wrap = node.closest('[data-urgency-message-wrap]');
        if (wrap) wrap.hidden = false;
        node.textContent = text;
        node.hidden = false;
      });
    }

    _formatButtonText(template, tier) {
      const reward = tier && tier.reward ? String(tier.reward) : '';
      return (template || this._defaultButtonText || '')
        .replace(/\{reward\}/g, reward)
        .replace(/\{amount\}/g, reward);
    }

    _updateButtonText() {
      if (!this._buttonText) return;
      if (this._isSubmitting) {
        this._buttonText.textContent = this.getAttribute('submitting-text');
      } else if (this._isSuccessLocked) {
        this._buttonText.textContent = this.getAttribute('finished-button-text') || this._defaultButtonText;
      } else {
        this._buttonText.textContent = this._formatButtonText(this._defaultButtonText, this._activeTier);
      }
    }

    _setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      this.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (this._button) this._button.disabled = this._isSuccessLocked || isLoading;
      this._updateButtonText();
    }

    _lockSuccessForm() {
      this._isSuccessLocked = true;
      this.classList.add('is-success-locked');
      if (this._input) this._input.disabled = true;
      if (this._checkbox) this._checkbox.disabled = true;
      if (this._button) this._button.disabled = true;
      this._updateButtonText();
    }

    _showError(message, field) {
      this.classList.add('is-error');
      this.classList.remove('is-success');
      this._setInvalidField(field);
      if (this._inlineSuccess) this._inlineSuccess.hidden = true;
      if (!this._message) return;
      this._message.setAttribute('role', 'alert');
      this._message.setAttribute('aria-live', 'assertive');
      this._message.textContent = message || this.getAttribute('error-message') || '';
      this._message.hidden = false;
      const target = field === 'email' ? this._input : field === 'agreement' ? this._checkbox : this._message;
      if (target) target.focus({ preventScroll: true });
    }

    _showSuccess() {
      this.classList.add('is-success');
      this.classList.remove('is-error');
      this._clearInvalidFields();
      if (this._message) {
        this._message.hidden = true;
        this._message.removeAttribute('role');
        this._message.setAttribute('aria-live', 'polite');
        this._message.replaceChildren();
      }
      if (this._inlineSuccess) this._inlineSuccess.hidden = false;
    }

    _hideMessages() {
      if (this._isSuccessLocked) return;
      this.classList.remove('is-error');
      this._clearInvalidFields();
      if (this._message) {
        this._message.hidden = true;
        this._message.removeAttribute('role');
        this._message.setAttribute('aria-live', 'polite');
        this._message.replaceChildren();
      }
    }

    _setInvalidField(field) {
      this._clearInvalidFields();
      if (field === 'email' && this._input) this._input.setAttribute('aria-invalid', 'true');
      if (field === 'agreement' && this._checkbox) this._checkbox.setAttribute('aria-invalid', 'true');
    }

    _clearInvalidFields() {
      if (this._input) this._input.setAttribute('aria-invalid', 'false');
      if (this._checkbox) this._checkbox.setAttribute('aria-invalid', 'false');
    }

    _parseErrorMessage(message) {
      const fallback = this.getAttribute('error-message') || 'Subscription failed. Please try again.';
      const already = this.getAttribute('email-already-registered-message') || 'This email is already registered.';
      const invalid = this.getAttribute('email-invalid-message') || 'This email is invalid.';
      const raw = message || fallback;
      if (window.$klaviyo && window.$klaviyo.parseErrorMessage) {
        return window.$klaviyo.parseErrorMessage({ message: raw }, { alreadyRegistered: already, invalid, default: fallback });
      }
      const lower = String(raw).toLowerCase();
      if (lower.includes('already') || lower.includes('exists')) return already;
      if (lower.includes('invalid')) return invalid;
      return raw;
    }

    async _updateProfileAndSubscribe(config) {
      const update = await config.klaviyo.updateProfile({
        email: config.email,
        apiKey: config.apiKey,
        properties: config.properties
      });
      if (!update || !update.success) return update || { success: false, error: this.getAttribute('error-message') };
      if (!this._isGenerationCurrent(config.generation)) return { success: false, aborted: true };
      const subscribe = await config.klaviyo.subscribe({
        email: config.email,
        apiKey: config.apiKey,
        listId: config.listId,
        ga4: config.ga4
      });
      const error = subscribe && subscribe.error ? String(subscribe.error).toLowerCase() : '';
      const duplicate = error.includes('already') || error.includes('exists');
      if (subscribe && !subscribe.success && !duplicate) return subscribe;
      return { success: true, subscribe, update };
    }

    _findTierForCoupon(coupon, tiers) {
      if (!Array.isArray(tiers) || tiers.length === 0) return null;
      const key = coupon && coupon.klaviyoGroupKey ? String(coupon.klaviyoGroupKey).trim() : '';
      const name = coupon && coupon.couponName ? String(coupon.couponName).trim() : '';
      const index = this._latestStatsTiers.findIndex((tier) => {
        const tierKey = tier && tier.klaviyoGroupKey ? String(tier.klaviyoGroupKey).trim() : '';
        const tierName = tier && tier.couponName ? String(tier.couponName).trim() : '';
        return (key && tierKey === key) || (name && tierName === name);
      });
      if (index >= 0 && tiers[index]) return tiers[index];
      console.warn('[J68 Subscribe] Unable to map coupon to tier by stats order.');
      return null;
    }

    _openDialog() {
      if (!this._dialogLayer || !this._dialog) return;
      if (this._dialogCloseTimer) window.clearTimeout(this._dialogCloseTimer);
      this._dialogCloseTimer = null;
      this._dialogLayer.hidden = false;
      this._dialogLayer.classList.remove('is-closing');
      lockBodyScroll(this);
      window.requestAnimationFrame(() => {
        if (!this._dialogLayer) return;
        this._dialogLayer.classList.add('is-open');
        this._dialog.focus({ preventScroll: true });
      });
    }

    _closeDialog() {
      if (!this._dialogLayer || this._dialogLayer.hidden) return;
      this._dialogLayer.classList.add('is-closing');
      this._dialogLayer.classList.remove('is-open');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this._dialogCloseTimer) window.clearTimeout(this._dialogCloseTimer);
      this._dialogCloseTimer = window.setTimeout(() => this._finishDialogClose(true), reduceMotion ? 0 : 220);
    }

    _finishDialogClose(restoreFocus) {
      if (this._dialogCloseTimer) window.clearTimeout(this._dialogCloseTimer);
      this._dialogCloseTimer = null;
      if (this._dialogLayer) {
        this._dialogLayer.hidden = true;
        this._dialogLayer.classList.remove('is-open', 'is-closing');
      }
      unlockBodyScroll(this);
      if (restoreFocus && this._inlineSuccess) this._inlineSuccess.focus({ preventScroll: true });
    }

    _handleDialogKeydown(event) {
      if (!this._dialogLayer || this._dialogLayer.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this._closeDialog();
        return;
      }
      if (event.key !== 'Tab' || !this._dialog) return;
      const focusable = Array.from(this._dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter((element) => !element.hidden);
      if (focusable.length === 0) {
        event.preventDefault();
        this._dialog.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === this._dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === this._dialog)) {
        event.preventDefault();
        first.focus();
      }
    }

    _clampPercent(value) {
      if (!Number.isFinite(value)) return 0;
      return Math.min(100, Math.max(0, value));
    }
    }

    customElements.define('ndev-j68-subscribe-form', NdevJ68SubscribeForm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-v50-all-purpose-frame-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-v50-all-purpose-frame-item')) {
    class NdevV50AllPurposeFrameItem extends BaseElement {
      init() {
        this.startTime = this.readNumber('start-time', 0);
        this.endTime = this.readNumber('end-time', 0);
        this.frameRoot = this.closest('ndev-v50-all-purpose-frame-animation');
        this.sectionRoot = this.closest('ndev-v50-all-purpose');
        this.duration = this.frameRoot ? Math.max(1, this.readFrameNumber('timeline-duration-ms', 11000)) : 11000;
        this.isVisible = false;
        this.onProgress = this.handleProgress.bind(this);

        if (!this.frameRoot || !this.sectionRoot || this.startTime >= this.endTime) return;
        this.sectionRoot.addEventListener('ndev-v50-frame-progress', this.onProgress);
      }

      dispose() {
        if (this.sectionRoot) {
          this.sectionRoot.removeEventListener('ndev-v50-frame-progress', this.onProgress);
        }
        this.classList.remove('is-visible');
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      readFrameNumber(name, fallback) {
        const value = Number(this.frameRoot.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      handleProgress(event) {
        const detail = event.detail || {};
        const progress = Number(detail.progress);
        const safeProgress = Number.isFinite(progress) ? progress : 0;
        const currentTime = Math.min(this.duration, Math.max(0, safeProgress * this.duration));
        this.setVisible(Boolean(detail.active) && currentTime >= this.startTime && currentTime <= this.endTime);
      }

      setVisible(visible) {
        if (visible === this.isVisible) return;
        this.isVisible = visible;
        this.classList.toggle('is-visible', visible);
      }
    }

    customElements.define('ndev-v50-all-purpose-frame-item', NdevV50AllPurposeFrameItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-v50-media-overlay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-v50-media-overlay')) {
    class NdevV50MediaOverlay extends BaseElement {
      init() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.preparedVideos = new WeakSet();
        this.isNearViewport = false;
        this.isInView = false;
        this.fallbackRaf = 0;
        this.preloadObserver = null;
        this.playbackObserver = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onPreloadIntersection = this.handlePreloadIntersection.bind(this);
        this.onPlaybackIntersection = this.handlePlaybackIntersection.bind(this);
        this.onVisibilityChange = this.syncPlayback.bind(this);
        this.onBreakpointChange = this.handleBreakpointChange.bind(this);
        this.onReducedMotionChange = this.syncPlayback.bind(this);
        this.onFallbackViewportChange = this.handleFallbackViewportChange.bind(this);

        this.videos.forEach((video) => {
          video.autoplay = false;
          video.loop = true;
          video.muted = true;
          video.playsInline = true;
          video.preload = 'none';
          video.pause();
        });

        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.addMediaListener(this._mq, this.onBreakpointChange);
        this.addMediaListener(this.reducedMotion, this.onReducedMotionChange);
        this.setupViewportTracking();
      }

      dispose() {
        if (this.preloadObserver) this.preloadObserver.disconnect();
        if (this.playbackObserver) this.playbackObserver.disconnect();
        if (this.fallbackRaf) cancelAnimationFrame(this.fallbackRaf);

        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        window.removeEventListener('scroll', this.onFallbackViewportChange);
        window.removeEventListener('resize', this.onFallbackViewportChange);
        this.removeMediaListener(this._mq, this.onBreakpointChange);
        this.removeMediaListener(this.reducedMotion, this.onReducedMotionChange);
        this.pauseAll();
      }

      setupViewportTracking() {
        if (!('IntersectionObserver' in window)) {
          window.addEventListener('scroll', this.onFallbackViewportChange, { passive: true });
          window.addEventListener('resize', this.onFallbackViewportChange);
          this.handleFallbackViewportChange();
          return;
        }

        this.preloadObserver = new IntersectionObserver(this.onPreloadIntersection, {
          root: null,
          rootMargin: '300px 0px',
          threshold: 0,
        });
        this.playbackObserver = new IntersectionObserver(this.onPlaybackIntersection, {
          root: null,
          rootMargin: '0px',
          threshold: 0.35,
        });
        this.preloadObserver.observe(this);
        this.playbackObserver.observe(this);
      }

      handlePreloadIntersection(entries) {
        const entry = entries[0];
        this.isNearViewport = Boolean(entry && entry.isIntersecting);
        if (this.isNearViewport) this.prepareVisibleVideo();
      }

      handlePlaybackIntersection(entries) {
        const entry = entries[0];
        this.isInView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio >= 0.35);
        this.syncPlayback();
      }

      handleFallbackViewportChange() {
        if (this.fallbackRaf) return;
        this.fallbackRaf = requestAnimationFrame(() => {
          this.fallbackRaf = 0;
          const rect = this.getBoundingClientRect();
          const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
          const visibleRatio = rect.height > 0 ? visibleHeight / rect.height : 0;
          this.isNearViewport = rect.bottom >= -300 && rect.top <= window.innerHeight + 300;
          this.isInView = visibleRatio >= 0.35;
          if (this.isNearViewport) this.prepareVisibleVideo();
          this.syncPlayback();
        });
      }

      handleBreakpointChange() {
        this.pauseAll();
        if (this.isNearViewport) this.prepareVisibleVideo();
        this.syncPlayback();
      }

      getVisibleVideo() {
        const selector = this._mq.matches
          ? '.ndev-v50-media-overlay__video.show-pc'
          : '.ndev-v50-media-overlay__video.show-mb';
        return this.querySelector(selector);
      }

      prepareVisibleVideo() {
        const video = this.getVisibleVideo();
        if (!video || this.preparedVideos.has(video)) return;
        this.preparedVideos.add(video);
        video.preload = 'metadata';
        video.load();
      }

      syncPlayback() {
        const visibleVideo = this.getVisibleVideo();
        this.videos.forEach((video) => {
          if (video !== visibleVideo) video.pause();
        });

        const shouldPlay =
          visibleVideo && this.isInView && !document.hidden && !this.reducedMotion.matches;
        if (!shouldPlay) {
          if (visibleVideo) visibleVideo.pause();
          return;
        }

        this.prepareVisibleVideo();
        try {
          const playPromise = visibleVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        } catch (error) {
          visibleVideo.pause();
        }
      }

      pauseAll() {
        this.videos.forEach((video) => video.pause());
      }

      addMediaListener(mediaQuery, listener) {
        if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', listener);
        else mediaQuery.addListener(listener);
      }

      removeMediaListener(mediaQuery, listener) {
        if (mediaQuery.removeEventListener) mediaQuery.removeEventListener('change', listener);
        else mediaQuery.removeListener(listener);
      }
    }

    customElements.define('ndev-v50-media-overlay', NdevV50MediaOverlay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-appearance-overview"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-appearance-overview';
    const ROOT_SELECTOR = '[data-ndev-x30-appearance-overview]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const overallEl = root.querySelector('[data-ndev-x30-appearance-overview-overall]');
      const endingEl = root.querySelector('[data-ndev-x30-appearance-overview-ending-wrap]');

      if (!overallEl || !endingEl) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 状态标记：ending 是否已显示
      let endingShown = false;

      // 显示 ending 的函数
      function showEnding() {
        if (endingShown) return;
        endingShown = true;
        endingEl.classList.add('is-visible');
        overallEl.classList.add('is-fading');
      }

      // 监听帧动画进度
      function handleProgress(event) {
        const percent = event.detail.percent;
        if (percent >= 98) {
          showEnding();
        }
      }

      // 绑定在 root 元素上，捕获所有冒泡上来的 ndev-sf-progress 事件
      root.addEventListener('ndev-sf-progress', handleProgress);

      // 额外监听 document 上的事件（防止事件冒泡被阻止的情况）
      function handleProgressGlobal(event) {
        if (root.contains(event.target)) {
          handleProgress(event);
        }
      }
      document.addEventListener('ndev-sf-progress', handleProgressGlobal);

      // 备用方案：轮询检查滚动进度
      // 当滚动到容器底部时，直接显示 ending
      let scrollCheckRaf = null;
      function checkScrollProgress() {
        if (endingShown) {
          scrollCheckRaf = null;
          return;
        }

        const rect = root.getBoundingClientRect();
        const containerHeight = root.offsetHeight;
        const scrolled = -rect.top; // 已滚过的距离
        const total = containerHeight - window.innerHeight; // 总可滚动距离

        if (total > 0) {
          const scrollPercent = (scrolled / total) * 100;
          if (scrollPercent >= 95) {
            showEnding();
            scrollCheckRaf = null;
            return;
          }
        }

        scrollCheckRaf = requestAnimationFrame(checkScrollProgress);
      }

      // 开始滚动检查
      function startScrollCheck() {
        if (scrollCheckRaf) return;
        scrollCheckRaf = requestAnimationFrame(checkScrollProgress);
      }

      // 监听滚动事件启动检查
      const handleScroll = function() {
        if (!endingShown) {
          startScrollCheck();
        }
      };
      window.addEventListener('scroll', handleScroll, { passive: true });

      // 初始化时也检查一次
      startScrollCheck();

      controllers.set(root, {
        root: root,
        destroy: function () {
          try {
            root.removeEventListener('ndev-sf-progress', handleProgress);
            document.removeEventListener('ndev-sf-progress', handleProgressGlobal);
            window.removeEventListener('scroll', handleScroll);
            if (scrollCheckRaf) {
              cancelAnimationFrame(scrollCheckRaf);
              scrollCheckRaf = null;
            }
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope?.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope?.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-appearance-thumb-swiper"] && !Shopify.designMode) return;
  try {
    class NdevX30AppearanceThumbSwiper extends BaseElement {
    createdCallback() {
      this.swiper = null;
      this.preloadedImages = [];
      this.autoplayObserver = null;
      this.progressRingVersion = 0;
      this.resizeTimeout = 0;
      this.retryTimer = 0;
      this.onColorClick = this.handleColorClick.bind(this);
      this.onArrowClick = this.handleArrowClick.bind(this);
      this.onThumbClick = this.handleThumbClick.bind(this);
      this.onFocusIn = this.handleFocusIn.bind(this);
      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onResize = this.handleResize.bind(this);
    }

    init() {
      this.dispose();
      if (typeof Swiper === 'undefined') return;

      this.swiperEl = this.querySelector('[data-x30-ats-swiper]');
      if (!this.swiperEl) return;

      this.slides = this.swiperEl.querySelectorAll('[data-ndev-x30-appearance-thumb-slide]');
      if (!this.slides.length) {
        this.retryTimer = window.setTimeout(() => this.init(), 50);
        return;
      }

      this.navPrev = this.querySelector('[data-x30-ats-prev]');
      this.navNext = this.querySelector('[data-x30-ats-next]');
      this.thumbsRoot = this.querySelector('[data-x30-ats-thumbs]');
      this.total = this.slides.length;
      this.loopEnabled = this.total > 1;
      this.autoplayEnabled = this.getAttribute('autoplay') === 'true' && this.loopEnabled;
      this.autoplaySpeed = parseInt(this.getAttribute('autoplay-speed'), 10) || 3000;
      this.autoplayStart = (this.getAttribute('autoplay-start') || 'immediate').trim();
      this.setAttribute('autoplay-active', this.autoplayEnabled ? 'true' : 'false');

      updateColorUi(this, getColor(this));

      const swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: this.loopEnabled,
        allowTouchMove: true,
        simulateTouch: true,
        breakpoints: {
          1024: {
            allowTouchMove: false,
            simulateTouch: false
          }
        },
        on: {
          init: () => {
            updateCounter(this, this.swiper, this.total);
            updateActiveThumb(this, this.swiper);
            updateIndicator(this);
          },
          slideChange: () => {
            updateCounter(this, this.swiper, this.total);
            updateActiveThumb(this, this.swiper);
            window.requestAnimationFrame(() => updateIndicator(this));
          },
          slideChangeTransitionEnd: () => {
            updateProgressRing(this);
          },
          autoplayStart: () => {
            restartProgressRing(this);
          },
          autoplayStop: () => {
            stopProgressRing(this);
          }
        }
      };

      if (this.autoplayEnabled) {
        swiperConfig.autoplay = {
          delay: this.autoplaySpeed,
          disableOnInteraction: false
        };
      }

      this.swiper = new Swiper(this.swiperEl, swiperConfig);

      this.preloadedImages = preloadImages(this.slides);
      renderThumbs(this, this.slides);
      updateCounter(this, this.swiper, this.total);
      updateActiveThumb(this, this.swiper);
      window.requestAnimationFrame(() => {
        if (!updateIndicator(this)) {
          const active = this.querySelector('[data-x30-ats-color-option][aria-checked="true"]');
          if (active) active.classList.add('is-active-fallback');
        }
      });

      this.addEventListener('click', this.onColorClick);
      this.addEventListener('click', this.onArrowClick);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('pointerdown', this.onPointerDown);
      if (this.thumbsRoot) this.thumbsRoot.addEventListener('click', this.onThumbClick);
      window.addEventListener('resize', this.onResize);
      setupAutoplayVisibility(this);
      updateProgressRing(this);
    }

    dispose() {
      this.removeEventListener('click', this.onColorClick);
      this.removeEventListener('click', this.onArrowClick);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('pointerdown', this.onPointerDown);
      if (this.thumbsRoot) this.thumbsRoot.removeEventListener('click', this.onThumbClick);
      window.removeEventListener('resize', this.onResize);
      if (this.resizeTimeout) window.clearTimeout(this.resizeTimeout);
      if (this.retryTimer) window.clearTimeout(this.retryTimer);
      if (this.swiper) {
        try {
          this.swiper.destroy(true, true);
        } catch (_) {}
      }
      if (this.autoplayObserver) {
        try {
          this.autoplayObserver.disconnect();
        } catch (_) {}
      }
      stopProgressRing(this);
      this.removeAttribute('autoplay-active');
      this.swiper = null;
      this.preloadedImages = [];
      this.autoplayObserver = null;
      this.progressRingVersion = 0;
      this.swiperEl = null;
      this.slides = null;
      this.thumbsRoot = null;
      this.resizeTimeout = 0;
      this.retryTimer = 0;
    }

    handleArrowClick(event) {
      let target = event.target;
      while (target && target !== this) {
        if (target.hasAttribute && target.hasAttribute('data-x30-ats-prev')) {
          pauseAutoplay(this);
          if (this.swiper && this.total > 1) this.swiper.slidePrev();
          return;
        }
        if (target.hasAttribute && target.hasAttribute('data-x30-ats-next')) {
          pauseAutoplay(this);
          if (this.swiper && this.total > 1) this.swiper.slideNext();
          return;
        }
        target = target.parentElement;
      }
    }

    handleColorClick(event) {
      let target = event.target;
      while (target && target !== this) {
        if (target.hasAttribute && target.hasAttribute('data-x30-ats-color-option')) {
          pauseAutoplay(this);
          setColor(this, target.getAttribute('data-x30-ats-color-option'));
          return;
        }
        target = target.parentElement;
      }
    }

    handleThumbClick(event) {
      if (!this.thumbsRoot) return;
      let target = event.target;
      while (target && target !== this.thumbsRoot) {
        if (target.hasAttribute && target.hasAttribute('data-x30-ats-thumb')) {
          pauseAutoplay(this);
          const index = parseInt(target.getAttribute('data-x30-ats-thumb'), 10);
          if (!Number.isNaN(index) && this.swiper) slideToRealIndex(this.swiper, index);
          return;
        }
        target = target.parentElement;
      }
    }

    handleResize() {
      if (this.resizeTimeout) window.clearTimeout(this.resizeTimeout);
      this.resizeTimeout = window.setTimeout(() => {
        updateIndicator(this);
        if (this.swiper && this.swiper.update) this.swiper.update();
      }, 150);
    }

    handleFocusIn() {
      pauseAutoplay(this);
    }

    handlePointerDown() {
      pauseAutoplay(this);
    }
  }

  function formatNumber(num) {
    return num < 10 ? '0' + num : '' + num;
  }

  function getColor(root) {
    const color = root.getAttribute('color');
    return color === 'black' ? 'black' : 'white';
  }

  function getSlideImage(slide, color, kind) {
    if (!slide) return '';
    const attr = 'data-' + color + '-' + kind + '-src';
    return slide.getAttribute(attr) || '';
  }

  function preloadImages(slides) {
    const seen = {};
    const images = [];
    for (let i = 0; i < slides.length; i++) {
      preloadSlideImages(slides[i], seen, images);
    }
    return images;
  }

  function restartProgressRing(root) {
    if (!root || !root.autoplayEnabled) return;
    if (root.autoplayStart === 'in_view' && !isRootVisible(root)) return;
    if (root.swiper && root.swiper.autoplay && !root.swiper.autoplay.running) return;
    const ring = root.querySelector('[data-x30-ats-progress-ring]');
    if (!ring || !ring.classList || !ring.parentNode) return;
    const nextRing = ring.cloneNode(true);
    nextRing.classList.remove('ndev-x30-appearance-thumb-swiper__progress-ring--anim');
    ring.parentNode.replaceChild(nextRing, ring);
    root.progressRingVersion = (root.progressRingVersion || 0) + 1;
    const version = root.progressRingVersion;
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (version !== root.progressRingVersion) return;
        if (!root.autoplayEnabled) return;
        if (root.autoplayStart === 'in_view' && !isRootVisible(root)) return;
        if (root.swiper && root.swiper.autoplay && !root.swiper.autoplay.running) return;
        nextRing.classList.add('ndev-x30-appearance-thumb-swiper__progress-ring--anim');
      });
    });
  }

  function stopProgressRing(root) {
    if (!root) return;
    root.progressRingVersion = (root.progressRingVersion || 0) + 1;
    const ring = root.querySelector('[data-x30-ats-progress-ring]');
    if (ring) ring.classList.remove('ndev-x30-appearance-thumb-swiper__progress-ring--anim');
  }

  function updateProgressRing(root) {
    if (!root || !root.autoplayEnabled) {
      stopProgressRing(root);
      return;
    }
    restartProgressRing(root);
  }

  function pauseAutoplay(root) {
    if (!root || !root.autoplayEnabled || !root.swiper || !root.swiper.autoplay) return;
    root.autoplayEnabled = false;
    root.setAttribute('autoplay-active', 'false');
    root.swiper.autoplay.stop();
    stopProgressRing(root);
  }

  function isRootVisible(root) {
    if (!root) return false;
    const rect = root.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const inViewport = rect.bottom > 0 && rect.right > 0 && rect.left < viewportWidth && rect.top < viewportHeight;
    if (!inViewport) return false;
    if (typeof root.checkVisibility === 'function') return root.checkVisibility();
    return true;
  }

  function setAutoplayByVisibility(root, visible) {
    if (!root || !root.autoplayEnabled || !root.swiper || !root.swiper.autoplay) return;
    if (visible) {
      root.swiper.autoplay.start();
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => restartProgressRing(root));
      });
    } else {
      root.swiper.autoplay.stop();
      stopProgressRing(root);
    }
  }

  function setupAutoplayVisibility(root) {
    if (!root || !root.autoplayEnabled || !root.swiper || !root.swiper.autoplay) {
      stopProgressRing(root);
      return;
    }

    if (root.autoplayStart === 'in_view') {
      root.swiper.autoplay.stop();
      setAutoplayByVisibility(root, isRootVisible(root));
      if (typeof IntersectionObserver === 'undefined') return;
      root.autoplayObserver = new IntersectionObserver(
        entries => {
          for (let i = 0; i < entries.length; i++) {
            if (entries[i].target !== root) continue;
            setAutoplayByVisibility(root, entries[i].isIntersecting && isRootVisible(root));
            break;
          }
        },
        { root: null, rootMargin: '0px', threshold: 0 }
      );
      root.autoplayObserver.observe(root);
      return;
    }

    updateProgressRing(root);
  }

  function preloadSlideImages(slide, seen, images) {
    const colors = ['black', 'white'];
    const kinds = ['pc', 'mb', 'thumb'];
    for (let colorIndex = 0; colorIndex < colors.length; colorIndex++) {
      for (let kindIndex = 0; kindIndex < kinds.length; kindIndex++) {
        const src = getSlideImage(slide, colors[colorIndex], kinds[kindIndex]);
        if (!src || seen[src]) continue;
        seen[src] = true;
        const img = new Image();
        img.src = src;
        images.push(img);
      }
    }
  }

  function updateColorUi(root, color) {
    const options = root.querySelectorAll('[data-x30-ats-color-option]');
    for (let i = 0; i < options.length; i++) {
      const optionColor = options[i].getAttribute('data-x30-ats-color-option');
      const active = optionColor === color;
      options[i].setAttribute('aria-checked', active ? 'true' : 'false');
      options[i].classList.toggle('is-active-fallback', active);
    }
  }

  function updateIndicator(root) {
    const switchers = root.querySelectorAll('[data-x30-ats-switcher]');
    let measured = false;

    for (let i = 0; i < switchers.length; i++) {
      const switcher = switchers[i];
      const indicator = switcher.querySelector('[data-x30-ats-indicator]');
      const active = switcher.querySelector('[data-x30-ats-color-option][aria-checked="true"]');
      if (!indicator || !active) continue;

      const switcherRect = switcher.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect();
      if (!switcherRect.width || !activeRect.width) continue;

      switcher.style.setProperty('--x30-ats-indicator-x', activeRect.left - switcherRect.left - 4 + 'px');
      switcher.style.setProperty('--x30-ats-indicator-width', activeRect.width + 'px');
      indicator.hidden = false;
      active.classList.remove('is-active-fallback');
      measured = true;
    }

    return measured;
  }

  function setColor(root, color) {
    if (color !== 'black' && color !== 'white') return;
    const previous = getColor(root);
    updateColorUi(root, color);
    window.requestAnimationFrame(() => updateIndicator(root));

    if (previous === color) {
      return;
    }

    root.setAttribute('color', color);
    resetAutoplayProgress(root);
  }

  function resetAutoplayProgress(root) {
    if (!root || !root.autoplayEnabled || !root.swiper || !root.swiper.autoplay) return;
    if (root.autoplayStart === 'in_view' && !isRootVisible(root)) {
      stopProgressRing(root);
      return;
    }
    root.swiper.autoplay.stop();
    root.swiper.autoplay.start();
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => restartProgressRing(root));
    });
  }

  function slideToRealIndex(swiper, realIndex) {
    if (!swiper) return;
    if (swiper.params && swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(realIndex);
      return;
    }
    if (swiper.params && swiper.params.loop && swiper.slides && swiper.slides.length) {
      const selector = '[data-swiper-slide-index="' + realIndex + '"]';
      const activeIndex = typeof swiper.activeIndex === 'number' ? swiper.activeIndex : 0;
      const slides = Array.prototype.slice.call(swiper.slides);
      let targetIndex = -1;
      let minDistance = Infinity;
      for (let i = 0; i < slides.length; i++) {
        if (!slides[i].matches || !slides[i].matches(selector)) continue;
        const distance = Math.abs(i - activeIndex);
        if (distance < minDistance) {
          minDistance = distance;
          targetIndex = i;
        }
      }
      if (targetIndex >= 0) {
        swiper.slideTo(targetIndex);
        return;
      }
    }
    swiper.slideTo(realIndex);
  }

  function updateCounter(root, swiper, total) {
    const currentEl = root.querySelector('[data-x30-ats-current]');
    const totalEl = root.querySelector('[data-x30-ats-total]');
    const current = swiper ? swiper.realIndex + 1 : 1;
    if (currentEl) currentEl.textContent = formatNumber(current);
    if (totalEl) totalEl.textContent = '/' + formatNumber(total);
  }

  function renderThumbs(root, slides) {
    const thumbsRoot = root.querySelector('[data-x30-ats-thumbs]');
    if (!thumbsRoot) return;
    thumbsRoot.innerHTML = '';

    for (let i = 0; i < slides.length; i++) {
      const blackSrc = getSlideImage(slides[i], 'black', 'thumb') || getSlideImage(slides[i], 'black', 'pc');
      const whiteSrc = getSlideImage(slides[i], 'white', 'thumb') || getSlideImage(slides[i], 'white', 'pc');
      const alt = slides[i].getAttribute('data-image-alt') || '';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ndev-x30-appearance-thumb-swiper__thumb';
      button.setAttribute('data-x30-ats-thumb', '' + i);
      button.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      if (blackSrc || whiteSrc) {
        appendThumbImage(button, blackSrc || whiteSrc, alt, 'black');
        appendThumbImage(button, whiteSrc || blackSrc, alt, 'white');
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'ndev-x30-appearance-thumb-swiper__thumb-placeholder';
        button.appendChild(placeholder);
      }
      thumbsRoot.appendChild(button);
    }
  }

  function appendThumbImage(root, src, alt, color) {
    if (!src) return;
    const img = document.createElement('img');
    img.className = 'ndev-x30-appearance-thumb-swiper__thumb-image';
    img.alt = alt;
    img.src = src;
    img.setAttribute('data-x30-ats-thumb-color', color);
    root.appendChild(img);
  }

  function updateActiveThumb(root, swiper) {
    const thumbs = root.querySelectorAll('[data-x30-ats-thumb]');
    const activeIndex = swiper ? swiper.realIndex : 0;
    for (let i = 0; i < thumbs.length; i++) {
      const active = i === activeIndex;
      thumbs[i].classList.toggle('is-active', active);
      thumbs[i].setAttribute('aria-current', active ? 'true' : 'false');
    }
  }

  if (!customElements.get('ndev-x30-appearance-thumb-swiper')) {
    customElements.define('ndev-x30-appearance-thumb-swiper', NdevX30AppearanceThumbSwiper);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-ermi-card-list"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-ermi-card-list';
    const ROOT_SELECTOR = '[data-ndev-x30-ermi-card-list]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 获取容器和卡片
      const cardsContainer = root.querySelector('.ndev-x30-ermi-card-list__cards');
      const thumbnailsContainer = root.querySelector('.ndev-x30-ermi-card-list__thumbnails');

      if (!cardsContainer || !thumbnailsContainer) return;

      const cards = cardsContainer.querySelectorAll('[data-ndev-ermi-card]');
      const thumbnails = thumbnailsContainer.querySelectorAll('[data-ndev-ermi-card]');

      // 清除所有激活状态
      function clearAllActived() {
        root.querySelectorAll('.actived').forEach(function (el) {
          el.classList.remove('actived');
        });
      }

      // 激活指定 card（双向同步）
      function activateCard(cardId) {
        clearAllActived();
        // 激活 __cards 中的 card
        const card = cardsContainer.querySelector(`[data-id="${cardId}"]`);
        if (card) card.classList.add('actived');
        // 激活 __thumbnails 中对应的 thumbnail
        const thumbnail = thumbnailsContainer.querySelector(`[data-id="${cardId}"]`);
        if (thumbnail) thumbnail.classList.add('actived');
      }

      // 处理鼠标进入（cards 悬浮）
      function handleCardsMouseEnter(e) {
        // 仅 PC 端生效
        if (window.innerWidth < 1024) return;
        const card = e.currentTarget;
        activateCard(card.dataset.id);
      }

      // 处理缩略图点击
      function handleThumbnailClick(e) {
        // 仅移动端生效
        if (window.innerWidth >= 1024) return;
        const thumbnail = e.currentTarget;
        activateCard(thumbnail.dataset.id);
      }

      // 绑定 cards 悬浮事件
      cards.forEach(function (card) {
        card.addEventListener('mouseenter', handleCardsMouseEnter);
      });

      // 绑定 thumbnails 点击事件
      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', handleThumbnailClick);
      });

      controllers.set(root, {
        root: root,
        cards: cards,
        thumbnails: thumbnails,
        handleCardsMouseEnter: handleCardsMouseEnter,
        handleThumbnailClick: handleThumbnailClick,
        destroy: function () {
          // 清理 cards 事件监听器
          if (this.cards) {
            this.cards.forEach(function (card) {
              card.removeEventListener('mouseenter', this.handleCardsMouseEnter);
            }.bind(this));
          }
          // 清理 thumbnails 点击事件监听器
          if (this.thumbnails) {
            this.thumbnails.forEach(function (thumbnail) {
              thumbnail.removeEventListener('click', this.handleThumbnailClick);
            }.bind(this));
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-everything-recognition-identity"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-everything-recognition-identity';
    const ROOT_SELECTOR = '[data-ndev-x30-everything-recognition-identity]';
    const IMAGE_SELECTOR = '[data-ndev-x30-identity-image]';
    const INIT_ATTR = 'data-' + NS + '-initialized';
    const PC_DONE_CLASS = 'pc-done';
    const MB_DONE_CLASS = 'mb-done';
    const MOBILE_BREAKPOINT = 1024;

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    // 滑出距离：100% 表示完全移出
    const SLIDE_OUT_DISTANCE = 110;

    /**
     * 计算图片在堆叠中的状态
     * @param {number} positionInStack - 在堆叠中的位置（0=最上面）
     * @param {number} offsetPercent - 堆叠偏移百分比
     * @param {number} scaleDecay - 缩放衰减系数
     * @param {number} remainingCount - 剩余图片数（包含正在滑出的）
     * @returns {Object} 状态对象 { translateY, scale, opacity, zIndex, overlayOpacity }
     */
    function computeStackPositionState(positionInStack, offsetPercent, scaleDecay, remainingCount) {
      const translateY = -((remainingCount - 1 - positionInStack) * offsetPercent);
      const scale = Math.pow(scaleDecay, positionInStack);
      const zIndex = remainingCount - positionInStack;
      let overlayOpacity = positionInStack === 0 ? 0 : 0.3 + positionInStack * 0.2;
      overlayOpacity = Math.min(overlayOpacity, 0.7);
      return { translateY: translateY, scale: scale, opacity: 1, zIndex: zIndex, overlayOpacity: overlayOpacity };
    }

    /**
     * 计算滑出图片的状态
     * @param {number} phaseProgress - 滑出进度 (0-1)
     * @param {number} offsetPercent - 堆叠偏移百分比
     * @param {number} scaleDecay - 缩放衰减系数
     * @param {number} remainingCount - 剩余图片数
     * @returns {Object} 状态对象
     */
    function computeSlideOutState(phaseProgress, offsetPercent, scaleDecay, remainingCount) {
      const baseState = computeStackPositionState(0, offsetPercent, scaleDecay, remainingCount);
      baseState.translateY = baseState.translateY - phaseProgress * SLIDE_OUT_DISTANCE;
      baseState.opacity = 1 - phaseProgress;
      return baseState;
    }

    /**
     * 计算已完全滑出图片的状态
     * @returns {Object} 状态对象
     */
    function computeSlidOutState() {
      return { translateY: -SLIDE_OUT_DISTANCE, scale: 1, opacity: 0, zIndex: 0, overlayOpacity: 0 };
    }

    function applyImageStyle(el, state) {
      if (!el || !el.style) return;
      el.style.transform = 'translateY(' + state.translateY + '%) scale(' + state.scale + ')';
      el.style.opacity = String(state.opacity);
      el.style.zIndex = String(state.zIndex);
      if (state.overlayOpacity !== undefined) {
        el.style.setProperty('--stack-overlay-opacity', state.overlayOpacity);
      }
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const nodeList = root.querySelector ? { 'scroll-container': root.querySelector('[node-name="scroll-container"]'), 'stack': root.querySelector('[node-name="stack"]'), 'stack-wrapper': root.querySelector('[node-name="stack-wrapper"]') } : {};
      const scrollContainer = nodeList['scroll-container'];
      const stack = nodeList['stack'];
      const stackWrapper = nodeList['stack-wrapper'];

      if (!scrollContainer || !stack) return;

      const imageEls = root.querySelectorAll(IMAGE_SELECTOR);
      const totalImages = imageEls.length;

      if (totalImages === 0) {
        controllers.set(root, { root: root, destroy: function() {} });
        return;
      }

      // 读取配置
      const initialWaitHeight = parseFloat(root.getAttribute('data-initial-wait-height')) || 50;
      const scrollHeightPerImage = parseFloat(root.getAttribute('data-scroll-height-per-image')) || 150;
      let offset = 14;
      let scaleDecay = 0.9;

      // 最后一张图片不滑出，所以总阶段数 = totalImages - 1
      const totalPhases = totalImages - 1;
      const totalScrollHeight = initialWaitHeight + totalPhases * scrollHeightPerImage;
      scrollContainer.style.height = totalScrollHeight + 'vh';

      // 获取图片高度并设置 stack 高度
      // 使用图片原始尺寸比例计算实际渲染高度，避免绝对定位元素 offsetHeight 不准确的问题

      // 获取当前显示的图片（PC 端选 pc-done，移动端选 mb-done）
      function getCurrentDisplayImage() {
        const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
        for (const imageEl of imageEls) {
          const imgs = imageEl.querySelectorAll('img');
          if (imgs.length === 0) continue;

          const targetClass = isMobile ? MB_DONE_CLASS : PC_DONE_CLASS;
          let targetImg = imageEl.querySelector('img.' + targetClass);

          // 兜底：如果找不到对应 class，使用第一个图片
          if (!targetImg && imgs.length > 0) {
            targetImg = imgs[0];
          }
          return targetImg;
        }
        return null;
      }

      function updateStackHeight() {
        const targetImg = getCurrentDisplayImage();

        if (targetImg && targetImg.complete && targetImg.naturalHeight > 0 && targetImg.naturalWidth > 0) {
          // 用图片原始比例计算实际渲染高度
          // 图片渲染宽度 = stack 的实际宽度（图片 width: 100%）
          const stackWidth = stack.offsetWidth;
          const imgHeight = stackWidth * targetImg.naturalHeight / targetImg.naturalWidth;

          const stackHeight = imgHeight + (totalImages - 1) * offset;
          stack.style.height = stackHeight + 'px';

          const translateYPercent = (totalImages - 1) * offset;
          const marginTopPx = translateYPercent * imgHeight / 100;
          if (window.innerWidth < 1024 && stackWrapper) {
            stackWrapper.style.marginTop = marginTopPx + 'px';
          } else if (stackWrapper) {
            stackWrapper.style.marginTop = '';
          }
        }
      }

      // 读取 CSS 变量 - 提前定义，因为 updateStackHeight 需要调用它
      function readCssVars() {
        const cs = getComputedStyle(root);
        offset = parseFloat(cs.getPropertyValue('--stack-offset')) || 14;
        scaleDecay = parseFloat(cs.getPropertyValue('--scale-decay')) || 0.9;
      }

      // 初始计算 - 使用 requestAnimationFrame 确保 DOM 布局完成
      requestAnimationFrame(updateStackHeight);

      // 监听所有图片加载完成（PC 和 MB 都监听，确保 resize 切换端时能正确计算）
      const loadedImgs = [];
      function onLoadUpdateStackHeight() {
        requestAnimationFrame(updateStackHeight);
      }

      for (const imageEl of imageEls) {
        const imgs = imageEl.querySelectorAll('img');
        for (const img of imgs) {
          if (!img.complete) {
            img.addEventListener('load', onLoadUpdateStackHeight);
            loadedImgs.push(img);
          }
        }
      }

      /**
       * 核心动画更新函数 - 纯函数式，基于滚动进度计算每张图片状态
       * 不使用状态变量追踪，完全可重放
       * 注意：依赖外部已读取的 CSS 变量 (offset, scaleDecay)
       */
      function updateAnimation() {

        const rect = scrollContainer.getBoundingClientRect();
        const scrollHeight = scrollContainer.offsetHeight;
        const viewportHeight = window.innerHeight;

        const scrolled = -rect.top;
        const scrollableDistance = scrollHeight - viewportHeight;
        const progress = Math.max(0, Math.min(1, scrolled / scrollableDistance));

        const waitRatio = initialWaitHeight / totalScrollHeight;

        // 等待期：所有图片在初始堆叠位置
        if (progress < waitRatio) {
          for (let i = 0; i < totalImages; i++) {
            const state = computeStackPositionState(i, offset, scaleDecay, totalImages);
            applyImageStyle(imageEls[i], state);
          }
          return;
        }

        // 计算动画进度
        let animProgress = (progress - waitRatio) / (1 - waitRatio);
        animProgress = Math.max(0, Math.min(1, animProgress));

        // 计算当前阶段和阶段进度
        const rawPhase = animProgress * totalPhases;
        const currentPhase = Math.min(Math.floor(rawPhase), totalPhases);
        const phaseProgress = rawPhase - currentPhase;

        // 根据滚动进度直接计算每张图片的状态
        for (let i = 0; i < totalImages; i++) {
          if (i < currentPhase) {
            // 图片已完全滑出
            applyImageStyle(imageEls[i], computeSlidOutState());
          } else if (i === currentPhase) {
            // 当前正在滑出的图片（最后一张不滑出）
            if (i < totalImages - 1) {
              const remainingCount = totalImages - currentPhase;
              const state = computeSlideOutState(phaseProgress, offset, scaleDecay, remainingCount);
              applyImageStyle(imageEls[i], state);
            } else {
              // 最后一张图片保持显示
              applyImageStyle(imageEls[i], { translateY: 0, scale: 1, opacity: 1, zIndex: 1, overlayOpacity: 0 });
            }
          } else {
            // 图片仍在堆叠中
            const remainingCount = totalImages - currentPhase;
            // positionInStack: 当前图片在堆叠中的位置
            // 图片 i 是堆叠中第 (i - currentPhase) 张
            const positionInStack = i - currentPhase;
            const state = computeStackPositionState(positionInStack, offset, scaleDecay, remainingCount);
            applyImageStyle(imageEls[i], state);
          }
        }
      }

      let ticking = false;
      let resizeTicking = false;

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function() {
            updateAnimation();
            ticking = false;
          });
          ticking = true;
        }
      }

      function onResize() {
        if (!resizeTicking) {
          requestAnimationFrame(function() {
            readCssVars();
            updateStackHeight();
            updateAnimation();
            resizeTicking = false;
          });
          resizeTicking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      // 初始化：读取 CSS 变量并启动动画
      readCssVars();
      updateAnimation();

      controllers.set(root, {
        root: root,
        destroy: function() {
          try {
            window.removeEventListener('scroll', onScroll, { passive: true });
            window.removeEventListener('resize', onResize, { passive: true });
            for (const img of loadedImgs) {
              img.removeEventListener('load', onLoadUpdateStackHeight);
            }
            scrollContainer.style.height = '';
            if (stackWrapper) {
              stackWrapper.style.marginTop = '';
            }
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let j = 0; j < list.length; j++) destroyOne(list[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function(event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-everything-recognition-maternity"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-maternity';
    const ROOT_SELECTOR = '[data-ndev-x30-maternity]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
    }

    function getVisibleVideo(root) {
      var selector = isMobile() ? '.mb-done video' : '.pc-done video';
      var video = root.querySelector(selector);
      return video || root.querySelector('video');
    }

    function destroyOne(root) {
      var controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      var nodeList = {
        videoWrapper: root.querySelector('[node-name="video-wrapper"]'),
        progress: root.querySelector('[node-name="progress"]'),
        progressBar: root.querySelector('[node-name="progress-bar"]'),
        volumeBtn: root.querySelector('[data-volume-btn]'),
        iconMuted: root.querySelector('.ndev-x30-maternity__volume-icon--muted'),
        iconUnmuted: root.querySelector('.ndev-x30-maternity__volume-icon--unmuted'),
        textMuted: root.querySelector('[data-btn-text-muted]'),
        textUnmuted: root.querySelector('[data-btn-text-unmuted]')
      };

      var video = null;
      var isMuted = true;

      // 更新图标和文案显示状态
      function updateDisplay() {
        if (isMuted) {
          // 静音状态：显示静音图标和静音文案
          if (nodeList.iconMuted) nodeList.iconMuted.style.display = '';
          if (nodeList.iconUnmuted) nodeList.iconUnmuted.style.display = 'none';
          if (nodeList.textMuted) nodeList.textMuted.style.display = '';
          if (nodeList.textUnmuted) nodeList.textUnmuted.style.display = 'none';
        } else {
          // 有声音状态：显示有声音图标和非静音文案
          if (nodeList.iconMuted) nodeList.iconMuted.style.display = 'none';
          if (nodeList.iconUnmuted) nodeList.iconUnmuted.style.display = '';
          if (nodeList.textMuted) nodeList.textMuted.style.display = 'none';
          if (nodeList.textUnmuted) nodeList.textUnmuted.style.display = '';
        }
      }

      // 初始化视频进度条
      function initProgress() {
        if (!nodeList.videoWrapper) return;

        video = getVisibleVideo(nodeList.videoWrapper);
        if (!video) return;

        // 监听视频时间更新
        if (nodeList.progress && nodeList.progressBar) {
          video.addEventListener('timeupdate', onTimeUpdate);
        }
      }

      function onTimeUpdate() {
        if (!video || !nodeList.progressBar || !nodeList.progress) return;

        if (video.duration > 0) {
          var progress = (video.currentTime / video.duration) * 100;
          nodeList.progressBar.style.width = progress + '%';
          nodeList.progress.setAttribute('aria-valuenow', Math.round(progress));
        }
      }

      // 音量切换
      function onVolumeClick(e) {
        e.preventDefault();

        // 获取当前可见的视频
        video = getVisibleVideo(nodeList.videoWrapper);
        if (!video) return;

        isMuted = !isMuted;

        if (isMuted) {
          video.muted = true;
        } else {
          video.muted = false;
          video.volume = 1;
        }

        // 更新按钮无障碍状态
        if (nodeList.volumeBtn) {
          nodeList.volumeBtn.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
        }

        // 更新图标和文案显示
        updateDisplay();
      }

      // 用户偏好减少动画检测
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion && nodeList.progressBar) {
        nodeList.progressBar.style.transition = 'none';
      }

      // 绑定按钮点击事件
      if (nodeList.volumeBtn) {
        nodeList.volumeBtn.addEventListener('click', onVolumeClick);
      }

      // 初始化图标和文案显示（默认静音状态）
      updateDisplay();

      // 延迟初始化进度条（等待视频加载）
      setTimeout(initProgress, 100);

      controllers.set(root, {
        root: root,
        destroy: function () {
          if (video) {
            video.removeEventListener('timeupdate', onTimeUpdate);
          }
          if (nodeList.volumeBtn) {
            nodeList.volumeBtn.removeEventListener('click', onVolumeClick);
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var j = 0; j < list.length; j++) destroyOne(list[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-everything-recognition-privacy"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-everything-recognition-privacy';
    const ROOT_SELECTOR = '[data-ndev-x30-everything-recognition-privacy]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function lerp(start, end, t) {
      return start + (end - start) * t;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root || root.hasAttribute(INIT_ATTR)) return;

      root.setAttribute(INIT_ATTR, '1');

      const scrollContainer = root.querySelector('[data-scroll-container]');
      const media = root.querySelector('[data-media]');
      const text = root.querySelector('[data-text]');

      if (!scrollContainer || !media) return;

      let cssVarsCache = null;

      function getCssVars() {
        if (cssVarsCache) return cssVarsCache;
        const computedStyle = getComputedStyle(root);
        cssVarsCache = {
          enterScaleStart: parseFloat(computedStyle.getPropertyValue('--enter-scale-start')) || 0.9,
          enterRadiusStart: parseFloat(computedStyle.getPropertyValue('--enter-radius-start')) || 48,
          blurMax: parseFloat(computedStyle.getPropertyValue('--blur-max')) || 100,
        };
        return cssVarsCache;
      }

      function clearStyles() {
        if (media) {
          media.style.transform = '';
          media.style.borderRadius = '';
          media.style.filter = '';
          media.style.opacity = '';
        }
        if (text) {
          text.style.transform = '';
          text.style.opacity = '';
        }
      }

      function applyAnimation(progress) {
        const { enterProgress, stickyProgress, exitProgress } = progress;
        const cssVars = getCssVars();
        const { enterScaleStart, enterRadiusStart, blurMax } = cssVars;

        // 进场动画
        if (enterProgress < 1) {
          const scale = lerp(enterScaleStart, 1, enterProgress);
          const radius = lerp(enterRadiusStart, 0, enterProgress);
          media.style.transform = `scale(${scale})`;
          media.style.borderRadius = `${radius}px`;
        } else {
          media.style.transform = 'scale(1)';
          media.style.borderRadius = '0px';
        }

        // 背景模糊：sticky 进度 0-0.5
        const blurProgress = clamp(stickyProgress * 2, 0, 1);
        const blur = lerp(0, blurMax, blurProgress);
        media.style.filter = `blur(${blur}px)`;

        // 文字出现：sticky 进度 0.5-0.75
        let textY = 100;
        let textOpacity = 0;

        if (stickyProgress >= 0.5 && stickyProgress < 0.75) {
          const textProgress = (stickyProgress - 0.5) / 0.25;
          textY = lerp(100, 0, textProgress);
          textOpacity = lerp(0, 1, textProgress);
        } else if (stickyProgress >= 0.75) {
          textY = 0;
          textOpacity = 1;
        }

        if (text) {
          text.style.transform = `translate(-50%, calc(-50% + ${textY}%))`;
          text.style.opacity = String(textOpacity);
        }

        // 离场透明度
        if (exitProgress > 0) {
          const opacity = lerp(1, 0, exitProgress);
          media.style.opacity = String(opacity);
        } else {
          media.style.opacity = '1';
        }
      }

      let ticking = false;

      function onScroll() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(function () {
          ticking = false;

          const rect = scrollContainer.getBoundingClientRect();
          const containerHeight = scrollContainer.offsetHeight;
          const viewportHeight = window.innerHeight;

          const scrollableDistance = containerHeight - viewportHeight;

          if (scrollableDistance <= 0) {
            applyAnimation({ enterProgress: 0, stickyProgress: 0, exitProgress: 0 });
            return;
          }

          // scrollTop: sticky 元素顶边距离视口顶边的距离
          const scrollTop = -rect.top;

          // 进场进度：scrollTop 从 -viewportHeight 到 0
          // -viewportHeight = 元素底部刚进入视口底部
          // 0 = 元素顶部到达视口顶部（sticky 生效）
          let enterProgress = 0;
          if (scrollTop <= -viewportHeight) {
            // 元素还在视口下方，未开始进场
            enterProgress = 0;
          } else if (scrollTop < 0) {
            // 进场中：从 0 渐变到 1
            enterProgress = 1 + scrollTop / viewportHeight;
          } else {
            // sticky 已生效
            enterProgress = 1;
          }

          // Sticky 进度：scrollTop >= 0
          let stickyProgress = 0;
          if (scrollTop >= 0 && scrollTop <= scrollableDistance) {
            stickyProgress = clamp(scrollTop / scrollableDistance, 0, 1);
          } else if (scrollTop > scrollableDistance) {
            stickyProgress = 1;
          }

          // 离场进度：scrollTop > scrollableDistance
          let exitProgress = 0;
          if (scrollTop > scrollableDistance) {
            exitProgress = clamp((scrollTop - scrollableDistance) / viewportHeight, 0, 1);
          }

          applyAnimation({ enterProgress, stickyProgress, exitProgress });
        });
      }

      function onResize() {
        cssVarsCache = null;
        onScroll();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      onScroll();

      controllers.set(root, {
        root: root,
        destroy: function () {
          try {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
            clearStyles();
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-glowing"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var NS = 'ndev-x30-glowing';
    var ROOT_SELECTOR = '[data-ndev-x30-glowing]';
    var INIT_ATTR = 'data-' + NS + '-initialized';

    var registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    var controllers = window[registryKey][NS];

    function queryCards(track) {
      return track ? track.querySelectorAll('.ndev-x30-glowing-card') : [];
    }

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    /** 与 CSS stroke-dasharray 一致：r=18 时周长约 113.1 */
    var PROGRESS_RING_LENGTH = 113.1;

    function readTrackTranslateX(track) {
      try {
        var s = window.getComputedStyle(track).transform;
        if (!s || s === 'none') return 0;
        var m = new DOMMatrixReadOnly(s);
        return m.m41;
      } catch (eTx) {
        return 0;
      }
    }

    /** frame 内容区（与 clientWidth 一致）：勿用 fr.width 当可视宽度（border-box），与 offsetWidth 比较会错位 */
    function getFrameContentBox(frame) {
      var fr = frame.getBoundingClientRect();
      var st = window.getComputedStyle(frame);
      var bl = parseFloat(st.borderLeftWidth) || 0;
      var br = parseFloat(st.borderRightWidth) || 0;
      var pl = parseFloat(st.paddingLeft) || 0;
      var pr = parseFloat(st.paddingRight) || 0;
      var W = frame.clientWidth;
      if (W <= 0 && fr.width > 0) {
        W = Math.max(0, fr.width - bl - br - pl - pr);
      }
      var left = fr.left + bl + pl;
      return { left: left, width: W, right: left + W, mid: left + W / 2 };
    }

    /**
     * 计算轨道最终 translateX（px）。
     * 可视宽度：frame.clientWidth；对齐/夹紧：内容区 left/right（含 border+padding）。
     * 轨道总宽：track.offsetWidth（布局宽度，不受 transform 影响），不用 scrollWidth 与父 clientWidth 混比。
     */
    function computeTrackTranslateX(frame, track, card) {
      var box = getFrameContentBox(frame);
      var W = box.width;
      if (W <= 0) return 0;
      var cr = card.getBoundingClientRect();
      var tr = track.getBoundingClientRect();
      var T = track.offsetWidth;
      var txCur = readTrackTranslateX(track);

      var d = box.mid - (cr.left + cr.width / 2);

      var dCardLo = box.left - cr.left;
      var dCardHi = box.right - cr.right;
      d = Math.max(dCardLo, Math.min(d, dCardHi));

      if (T > W + 0.5) {
        var dTrackLo = box.right - tr.right;
        var dTrackHi = box.left - tr.left;
        d = Math.max(dTrackLo, Math.min(dTrackHi, d));
      }

      return txCur + d;
    }

    function destroyOne(root) {
      var controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);

      var frame = root.querySelector('[data-ndev-x30-glowing-frame]');
      var track = root.querySelector('[data-ndev-x30-glowing-track]');
      if (!frame || !track) return;

      var cards = queryCards(track);
      if (!cards.length) return;

      var paginationEl = root.querySelector('[data-ndev-x30-glowing-pagination]');
      var paginationCurrentEl = paginationEl
        ? paginationEl.querySelector('[data-ndev-x30-glowing-pagination-current]')
        : null;
      var paginationTotalEl = paginationEl
        ? paginationEl.querySelector('[data-ndev-x30-glowing-pagination-total]')
        : null;
      var paginationPrevBtn = paginationEl
        ? paginationEl.querySelector('.ndev-x30-glowing__pagination-button--prev')
        : null;
      var paginationNextBtn = paginationEl
        ? paginationEl.querySelector('.ndev-x30-glowing__pagination-button--next')
        : null;
      var ringHost = paginationNextBtn
        ? paginationNextBtn.querySelector('[data-ndev-x30-glowing-ring-host]')
        : null;
      var hidePaginationOnePage = root.getAttribute('data-hide-pagination-one-page') !== 'false';

      root.setAttribute(INIT_ATTR, '1');

      var index = 0;
      var timer = null;
      var ro = null;
      var io = null;
      var reducedMotion = false;
      var resumeTimer = null;
      var inViewKickTimer = null;
      var ringRafId = null;

      try {
        reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      var autoplayOn = root.getAttribute('data-autoplay') === 'true' && !reducedMotion;
      var autoplayMs = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 3000;
      var autoplayInView = (root.getAttribute('data-autoplay-start') || 'immediate').trim() === 'in_view';

      if (autoplayOn && ringHost) {
        while (ringHost.firstChild) {
          ringHost.removeChild(ringHost.firstChild);
        }
        var ringSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        ringSvg.setAttribute('class', 'ndev-x30-glowing__progress-ring-svg');
        ringSvg.setAttribute('viewBox', '0 0 40 40');
        var ringCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        ringCircle.setAttribute('class', 'ndev-x30-glowing__progress-ring');
        ringCircle.setAttribute('cx', '20');
        ringCircle.setAttribute('cy', '20');
        ringCircle.setAttribute('r', '18');
        ringSvg.appendChild(ringCircle);
        ringHost.appendChild(ringSvg);
      }

      function getProgressRing() {
        return paginationEl ? paginationEl.querySelector('.ndev-x30-glowing__progress-ring') : null;
      }

      function stopProgressRingAnim() {
        if (ringRafId !== null) {
          cancelAnimationFrame(ringRafId);
          ringRafId = null;
        }
      }

      function setRingDashOffset(ring, value) {
        if (!ring || !ring.style) return;
        ring.style.strokeDashoffset = String(value);
      }

      function resetProgressRingIdle(ring) {
        if (!ring) return;
        stopProgressRingAnim();
        setRingDashOffset(ring, PROGRESS_RING_LENGTH);
      }

      function startProgressRingAnim(ring) {
        if (!ring || !autoplayOn) return;
        stopProgressRingAnim();
        var duration = autoplayMs;
        if (duration <= 0) return;
        setRingDashOffset(ring, PROGRESS_RING_LENGTH);
        var t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
        function step(now) {
          var t1 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
          var elapsed = t1 - t0;
          if (elapsed >= duration) {
            setRingDashOffset(ring, 0);
            ringRafId = null;
            return;
          }
          setRingDashOffset(ring, PROGRESS_RING_LENGTH * (1 - elapsed / duration));
          ringRafId = requestAnimationFrame(step);
        }
        ringRafId = requestAnimationFrame(step);
      }

      function refreshPaginationVisibility() {
        if (!paginationEl) return;
        var lock = hidePaginationOnePage && cards.length <= 1;
        paginationEl.classList.toggle('ndev-x30-glowing__pagination--lock', lock);
        try {
          paginationEl.setAttribute('aria-hidden', lock ? 'true' : 'false');
        } catch (eRing) {}
      }

      function updatePaginationNumbers() {
        if (!paginationCurrentEl || !paginationTotalEl) return;
        paginationCurrentEl.textContent = formatPageNum(index + 1);
        paginationTotalEl.textContent = '/' + formatPageNum(cards.length);
      }

      /** 多页时首尾循环：首张可点「上一张」到末张，末张可点「下一张」到首张，故不禁用按钮 */
      function updatePaginationDisabled() {
        if (!paginationPrevBtn || !paginationNextBtn) return;
        var lock = cards.length <= 1;
        paginationPrevBtn.disabled = lock;
        paginationNextBtn.disabled = lock;
      }

      function setClasses(n) {
        var prevIdx = index;
        index = n;
        for (var c = 0; c < cards.length; c++) {
          cards[c].classList.toggle('actived', c === n);
        }
        updatePaginationNumbers();
        updatePaginationDisabled();
        if (autoplayOn && prevIdx !== n) {
          startProgressRingAnim(getProgressRing());
        }
      }

      function scrollToCard(n, smooth) {
        var card = cards[n];
        if (!card) return;
        var tx = computeTrackTranslateX(frame, track, card);
        var useMotion = smooth && !reducedMotion;
        if (useMotion) {
          track.classList.remove('ndev-x30-glowing__track--instant');
        } else {
          track.classList.add('ndev-x30-glowing__track--instant');
        }
        track.style.transform = 'translate3d(' + tx + 'px,0,0)';
        if (!useMotion) {
          void track.offsetWidth;
          track.classList.remove('ndev-x30-glowing__track--instant');
        }
      }

      function setActive(i, instant) {
        if (!cards.length) return;
        var n = ((i % cards.length) + cards.length) % cards.length;
        setClasses(n);
        scrollToCard(n, !instant);
      }

      function next() {
        setActive(index + 1);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startTimer() {
        stopTimer();
        if (!autoplayOn || cards.length < 2) return;
        timer = setInterval(next, autoplayMs);
        startProgressRingAnim(getProgressRing());
      }

      function inViewport() {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
      }

      function pauseInteraction() {
        stopTimer();
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
        resetProgressRingIdle(getProgressRing());
      }

      function scheduleResume() {
        if (!autoplayOn) return;
        resumeTimer = setTimeout(function () {
          resumeTimer = null;
          if (autoplayInView && !inViewport()) return;
          startTimer();
        }, 2200);
      }

      function bindResize() {
        if (typeof ResizeObserver === 'undefined') {
          window.addEventListener('resize', relayout);
          return;
        }
        ro = new ResizeObserver(relayout);
        ro.observe(frame);
      }

      function unbindResize() {
        if (ro) {
          ro.disconnect();
          ro = null;
        }
        window.removeEventListener('resize', relayout);
      }

      function relayout() {
        scrollToCard(index, false);
      }

      bindResize();

      function setupAutoplay() {
        if (!autoplayOn) return;
        root.addEventListener('touchstart', pauseInteraction, { passive: true });
        root.addEventListener('touchend', scheduleResume, { passive: true });
        if (autoplayInView && typeof IntersectionObserver !== 'undefined') {
          io = new IntersectionObserver(
            function (entries) {
              var ok = entries.some(function (en) {
                return en.isIntersecting;
              });
              if (ok) {
                startTimer();
              } else {
                stopTimer();
                resetProgressRingIdle(getProgressRing());
              }
            },
            { root: null, threshold: 0 }
          );
          io.observe(root);
          inViewKickTimer = setTimeout(function () {
            inViewKickTimer = null;
            if (inViewport()) startTimer();
          }, 50);
        } else {
          startTimer();
        }
      }

      function onCardClick(e) {
        var target = e.target;
        while (target && target !== track) {
          if (target.classList && target.classList.contains('ndev-x30-glowing-card')) {
            for (var i = 0; i < cards.length; i++) {
              if (cards[i] === target) {
                setActive(i);
                startTimer();
                return;
              }
            }
          }
          target = target.parentElement;
        }
      }

      function onPaginationClick(e) {
        if (!paginationEl) return;
        var target = e.target;
        while (target && target !== paginationEl) {
          if (target.classList && target.classList.contains('ndev-x30-glowing__pagination-button--prev')) {
            pauseInteraction();
            setActive(index - 1);
            scheduleResume();
            return;
          }
          if (target.classList && target.classList.contains('ndev-x30-glowing__pagination-button--next')) {
            pauseInteraction();
            setActive(index + 1);
            scheduleResume();
            return;
          }
          target = target.parentElement;
        }
      }

      refreshPaginationVisibility();
      updatePaginationNumbers();
      updatePaginationDisabled();
      track.addEventListener('click', onCardClick);
      if (paginationEl) {
        paginationEl.addEventListener('click', onPaginationClick);
      }

      function kick() {
        setActive(0, true);
        setupAutoplay();
      }

      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(kick);
      } else {
        kick();
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          stopTimer();
          stopProgressRingAnim();
          if (resumeTimer) clearTimeout(resumeTimer);
          if (inViewKickTimer) clearTimeout(inViewKickTimer);
          unbindResize();
          track.removeEventListener('click', onCardClick);
          if (paginationEl) {
            paginationEl.removeEventListener('click', onPaginationClick);
          }
          if (autoplayOn) {
            root.removeEventListener('touchstart', pauseInteraction);
            root.removeEventListener('touchend', scheduleResume);
          }
          try {
            track.classList.add('ndev-x30-glowing__track--instant');
            track.style.transform = '';
            track.classList.remove('ndev-x30-glowing__track--instant');
          } catch (eTrack) {}
          if (io) {
            io.disconnect();
            io = null;
          }
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e2) {}
        }
      });
    }

    function initAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var j = 0; j < list.length; j++) destroyOne(list[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-mopping-compare-button"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-mopping-compare-button';
    const ROOT_SELECTOR = '[data-ndev-x30-mopping-compare-button]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      var btnEl = root.querySelector('.' + NS + '__btn');
      var dialogEl = root.querySelector('.ndev-x30-compare-dialog');
      var isClosing = false;

      if (!btnEl || !dialogEl) return;

      // 从 CSS 变量读取 PC/M 位置配置
      var style = getComputedStyle(root);
      var positionPc = style.getPropertyValue('--dialog-position-pc').trim() || 'center';
      var positionMb = style.getPropertyValue('--dialog-position-mb').trim() || 'center';

      // 使用 matchMedia 精确监听断点切换
      var mediaQuery = window.matchMedia('(max-width: 1023px)');

      function updateDialogPosition() {
        var position = mediaQuery.matches ? positionMb : positionPc;
        dialogEl.setAttribute('data-position', position);
      }

      updateDialogPosition();
      mediaQuery.addEventListener('change', updateDialogPosition);

      // 统一关闭方法：带退场动画后调用 close()
      function closeWithAnimation() {
        if (isClosing || !dialogEl.open) return;
        isClosing = true;
        dialogEl.classList.add('closing');
        dialogEl.addEventListener('animationend', function handler(e) {
          if (e.target !== dialogEl) return;
          dialogEl.removeEventListener('animationend', handler);
          dialogEl.classList.remove('closing');
          isClosing = false;
          dialogEl.close();
        });
      }

      // 打开弹窗
      function handleBtnClick(e) {
        if (btnEl && (e.target === btnEl || btnEl.contains(e.target))) {
          e.preventDefault();
          e.stopPropagation();
          dialogEl.showModal();
        }
      }

      // 点击蒙版关闭
      function handleDialogClick(e) {
        var rect = dialogEl.getBoundingClientRect();
        if (e.clientY < rect.top || e.clientY > rect.bottom ||
            e.clientX < rect.left || e.clientX > rect.right) {
          closeWithAnimation();
        }
      }

      // 拦截 lu2-dialog 关闭按钮，统一用 close()
      function handleHide(e) {
        e.preventDefault();
        closeWithAnimation();
      }

      // 拦截 ESC，统一用 close()
      function handleCancel(e) {
        e.preventDefault();
        closeWithAnimation();
      }

      root.addEventListener('click', handleBtnClick);
      dialogEl.addEventListener('click', handleDialogClick);
      dialogEl.addEventListener('hide', handleHide);
      dialogEl.addEventListener('cancel', handleCancel);

      controllers.set(root, {
        root: root,
        destroy: function () {
          root.removeEventListener('click', handleBtnClick);
          dialogEl.removeEventListener('click', handleDialogClick);
          dialogEl.removeEventListener('hide', handleHide);
          dialogEl.removeEventListener('cancel', handleCancel);
          mediaQuery.removeEventListener('change', updateDialogPosition);
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-mopping-overview"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-mopping-overview';
    const ROOT_SELECTOR = '[data-ndev-x30-mopping-overview]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    // 每个 slide 的滚动高度配置 (vh)
    // 第一个 slide: 250vh (100vh 完整展示 + 150vh 停留)
    // 其他 slide: 150vh
    const FIRST_SLIDE_VH = 250;
    const OTHER_SLIDE_VH = 150;

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      if (root.hasAttribute(INIT_ATTR)) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const slides = root.querySelectorAll('.ndev-x30-mopping-overview-slide');
      const totalSlides = slides.length;

      if (totalSlides === 0) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 计算每个 slide 的滚动高度和累计高度
      const slideHeights = [];
      const cumulativeHeights = [0]; // 累计高度起点
      let totalHeight = 0;

      for (let i = 0; i < totalSlides; i++) {
        const vh = (i === 0) ? FIRST_SLIDE_VH : OTHER_SLIDE_VH;
        slideHeights.push(vh);
        totalHeight += vh;
        cumulativeHeights.push(totalHeight);
      }

      // 设置容器总高度
      root.style.height = totalHeight + 'vh';
      slides[0].classList.add('is-active');

      let currentSlide = 0;
      let ticking = false;

      function updateSlide() {
        const rect = root.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const scrollableHeight = root.offsetHeight - viewportHeight;
        const scrolled = Math.max(0, -rect.top);
        const scrollProgress = scrolled / scrollableHeight;

        // 计算当前应该显示的 slide
        let newSlide = 0;
        for (let i = 0; i < totalSlides; i++) {
          const slideStart = cumulativeHeights[i] / totalHeight;
          const slideEnd = cumulativeHeights[i + 1] / totalHeight;

          if (scrollProgress >= slideStart && scrollProgress < slideEnd) {
            // 在当前 slide 范围内
            const progressInSlide = (scrollProgress - slideStart) / (slideEnd - slideStart);
            // 当滚动到 slide 的 80% 时切换到下一个
            if (progressInSlide >= 0.8 && i < totalSlides - 1) {
              newSlide = i + 1;
            } else {
              newSlide = i;
            }
            break;
          }
          newSlide = i;
        }

        // 确保最后一个 slide 正确显示
        if (scrollProgress >= 0.99) {
          newSlide = totalSlides - 1;
        }

        newSlide = Math.max(0, Math.min(newSlide, totalSlides - 1));

        if (newSlide !== currentSlide) {
          slides[currentSlide].classList.remove('is-active');
          slides[newSlide].classList.add('is-active');
          currentSlide = newSlide;
        }
      }

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateSlide();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      updateSlide();

      controllers.set(root, {
        root: root,
        destroy: function () {
          window.removeEventListener('scroll', onScroll, { passive: true });
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-sweep-coverage"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-sweep-coverage';
    const ROOT_SELECTOR = '[data-ndev-x30-sweep-coverage]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    // 工具函数
    function lerp(start, end, t) {
      return start + (end - start) * t;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 获取节点
      const scrollContainer = root.querySelector('[node-name="scroll-container"]');
      const bg = root.querySelector('[node-name="bg"]');
      const maskTop = root.querySelector('[node-name="mask-top"]');
      const maskBottom = root.querySelector('[node-name="mask-bottom"]');
      const line = root.querySelector('[node-name="line"]');
      // PC/M 端标题
      const titlePc = root.querySelector('[node-name="title"]');
      const titleMb = root.querySelector('[node-name="title-mb"]');
      const footer = root.querySelector('[node-name="footer"]');

      if (!scrollContainer) return;

      // 缓存 CSS 变量值，仅在 resize 时更新
      let cssVarsCache = null;

      function getCssVars() {
        if (cssVarsCache) return cssVarsCache;
        const computedStyle = getComputedStyle(root);
        const finalWidthVw = parseFloat(computedStyle.getPropertyValue('--final-width')) || 56.67;
        const finalMaxWidth = parseFloat(computedStyle.getPropertyValue('--final-max-width')) || 960;

        // 计算实际宽度（考虑 max-width 限制）
        const vwWidth = finalWidthVw / 100 * window.innerWidth;
        const actualWidth = Math.min(vwWidth, finalMaxWidth);
        const actualWidthPercent = actualWidth / window.innerWidth * 100;

        // 计算图片左边缘位置（居中）
        const leftOffsetPercent = (100 - actualWidthPercent) / 2;

        cssVarsCache = {
          finalWidthPercent: actualWidthPercent,
          leftOffsetPercent: leftOffsetPercent,
          finalRadius: parseFloat(computedStyle.getPropertyValue('--final-radius')) || 24,
          contentOffset: parseFloat(computedStyle.getPropertyValue('--content-offset')) || 32,
          aspectRatio: parseFloat(computedStyle.getPropertyValue('--aspect-ratio')) || 1.777
        };
        return cssVarsCache;
      }

      // 计算图片高度占视口的比例
      function getImageHeightRatio(finalWidthPercent, aspectRatio) {
        // finalWidthPercent 是百分比，如 56.67 表示 56.67%
        // 图片高度/视口高度 = (图片宽度 * 图片宽高比) / 视口高度
        // = (finalWidthPercent/100 * viewportWidth / aspectRatio) / viewportHeight
        // = finalWidthPercent/100 / aspectRatio * (viewportWidth/viewportHeight)
        const vwToVhRatio = window.innerWidth / window.innerHeight;
        return (finalWidthPercent / 100) / aspectRatio * vwToVhRatio;
      }

      // 重置所有样式到初始状态
      function resetStyles() {
        if (line) {
          line.style.transform = 'translateX(-100%)';
          line.style.opacity = '1';
        }
        if (bg) {
          bg.style.opacity = '0';
          bg.style.width = '100%';
          bg.style.borderRadius = '0';
          bg.style.left = '0';
        }
        if (maskTop) maskTop.style.height = '50vh';
        if (maskBottom) maskBottom.style.height = '50vh';
        // PC 端标题
        if (titlePc) {
          titlePc.style.opacity = '0';
          titlePc.style.left = '100%';
          titlePc.style.top = 'calc(50% - 32px)';
          titlePc.style.transform = 'translateX(-100%) translateY(-100%)';
        }
        // 移动端标题
        if (titleMb) {
          titleMb.style.opacity = '0';
          titleMb.style.left = '100%';
          titleMb.style.top = 'calc(50% - 32px)';
          titleMb.style.transform = 'translateX(-100%) translateY(-100%)';
        }
        if (footer) {
          footer.style.opacity = '0';
          footer.style.left = '100%';
          footer.style.top = 'calc(50% + 32px)';
          footer.style.transform = 'translateX(-100%) translateY(0)';
        }
      }

      // 应用动画状态
      function applyAnimation(fps) {
        const cssVars = getCssVars();
        const { finalWidthPercent, leftOffsetPercent, finalRadius, contentOffset, aspectRatio } = cssVars;
        const viewportHeight = window.innerHeight;

        // 计算图片高度占视口的比例（用于多个阶段）
        const imageHeightRatio = getImageHeightRatio(finalWidthPercent, aspectRatio);

        // 根据进度计算各属性的最终值（确保每个阶段都完整设置所有属性）
        let lineTransform, lineOpacity;
        let bgOpacity, bgWidth, bgRadius, bgLeft;
        let maskHeight;
        let titleOpacity, titleLeft, titleTop, titleTransform;
        let footerOpacity, footerLeft, footerTop, footerTransform;

        // Phase 1: 线条延伸 + 标题/底部区域淡入并移动 (0-25%)
        if (fps <= 0.25) {
          const t = fps / 0.25;

          // 线条：从左延伸到右
          const lineTranslate = lerp(100, 0, t);
          lineTransform = `translateX(-${lineTranslate}%)`;
          lineOpacity = 1;

          // 背景：隐藏
          bgOpacity = 0;
          bgWidth = 100;
          bgRadius = 0;
          bgLeft = 0;

          // 遮罩：全屏
          maskHeight = 50;

          // 标题：从右往左淡入
          titleOpacity = lerp(0, 1, t);
          titleLeft = lerp(100, leftOffsetPercent, t);
          titleTop = 'calc(50% - 32px)';
          const titleTranslateX = lerp(-100, 0, t);
          titleTransform = `translateX(${titleTranslateX}%) translateY(-100%)`;

          // 底部区域：从右往左淡入
          footerOpacity = lerp(0, 1, t);
          footerLeft = lerp(100, leftOffsetPercent, t);
          footerTop = 'calc(50% + 32px)';
          const footerTranslateX = lerp(-100, 0, t);
          footerTransform = `translateX(${footerTranslateX}%) translateY(0)`;
        }

        // Phase 2: 线条透明 + 背景显现 (25-50%)
        else if (fps <= 0.5) {
          const t = (fps - 0.25) / 0.25;

          // 线条：淡出
          lineTransform = 'translateX(0)';
          lineOpacity = lerp(1, 0, t);

          // 背景：淡入
          bgOpacity = lerp(0, 1, t);
          bgWidth = 100;
          bgRadius = 0;
          bgLeft = 0;

          // 遮罩：全屏
          maskHeight = 50;

          // 标题：保持最终位置
          titleOpacity = 1;
          titleLeft = leftOffsetPercent;
          titleTop = 'calc(50% - 32px)';
          titleTransform = 'translateX(0) translateY(-100%)';

          // 底部区域：保持最终位置
          footerOpacity = 1;
          footerLeft = leftOffsetPercent;
          footerTop = 'calc(50% + 32px)';
          footerTransform = 'translateX(0) translateY(0)';
        }

        // Phase 3: 遮罩开幕 + 背景缩放 + 标题移动到图片上方 (50-85%)
        else if (fps <= 0.85) {
          const t = clamp((fps - 0.5) / 0.35, 0, 1);

          // 线条：完全透明
          lineTransform = 'translateX(0)';
          lineOpacity = 0;

          // 背景：缩放到最终尺寸
          bgOpacity = 1;
          bgWidth = lerp(100, finalWidthPercent, t);
          bgRadius = lerp(0, finalRadius, t);
          bgLeft = lerp(0, leftOffsetPercent, t);

          // 遮罩：减小到图片边缘
          const maskFinalHeight = 50 - imageHeightRatio * 50;
          maskHeight = lerp(50, maskFinalHeight, t);

          // 内容偏移（标题和底部区域共用）
          const contentOffsetVh = contentOffset / viewportHeight * 100;

          // 标题：从线条上方移动到图片上方
          titleOpacity = 1;
          titleLeft = leftOffsetPercent;
          const imageTopVh = 50 - imageHeightRatio * 50;
          const titleFinalPx = (imageTopVh - contentOffsetVh) / 100 * viewportHeight;
          const titleStartPx = viewportHeight / 2 - 32;
          titleTop = lerp(titleStartPx, titleFinalPx, t);
          titleTransform = 'translateX(0) translateY(-100%)';

          // 底部区域：从线条下方移动到图片下方
          footerOpacity = 1;
          footerLeft = leftOffsetPercent;
          const imageBottomVh = 50 + imageHeightRatio * 50;
          const footerFinalPx = (imageBottomVh + contentOffsetVh) / 100 * viewportHeight;
          const footerStartPx = viewportHeight / 2 + 32;
          footerTop = lerp(footerStartPx, footerFinalPx, t);
          footerTransform = 'translateX(0) translateY(0)';
        }

        // Phase 4: 保持最终状态 (85-100%)
        else {
          // 线条：完全透明
          lineTransform = 'translateX(0)';
          lineOpacity = 0;

          // 背景：最终尺寸
          bgOpacity = 1;
          bgWidth = finalWidthPercent;
          bgRadius = finalRadius;
          bgLeft = leftOffsetPercent;

          // 遮罩：最终高度
          const maskFinalHeight = 50 - imageHeightRatio * 50;
          maskHeight = maskFinalHeight;

          // 内容偏移（标题和底部区域共用）
          const contentOffsetVh = contentOffset / viewportHeight * 100;

          // 标题：最终位置
          titleOpacity = 1;
          titleLeft = leftOffsetPercent;
          const imageTopVh = 50 - imageHeightRatio * 50;
          titleTop = (imageTopVh - contentOffsetVh) / 100 * viewportHeight;
          titleTransform = 'translateX(0) translateY(-100%)';

          // 底部区域：最终位置
          footerOpacity = 1;
          footerLeft = leftOffsetPercent;
          const imageBottomVh = 50 + imageHeightRatio * 50;
          footerTop = (imageBottomVh + contentOffsetVh) / 100 * viewportHeight;
          footerTransform = 'translateX(0) translateY(0)';
        }

        // 统一应用所有样式（确保每个属性都有明确值）
        if (line) {
          line.style.transform = lineTransform;
          line.style.opacity = String(lineOpacity);
        }
        if (bg) {
          bg.style.opacity = String(bgOpacity);
          bg.style.width = `${bgWidth}%`;
          bg.style.borderRadius = `${bgRadius}px`;
          bg.style.left = `${bgLeft}%`;
        }
        if (maskTop) maskTop.style.height = `${maskHeight}vh`;
        if (maskBottom) maskBottom.style.height = `${maskHeight}vh`;
        // PC 端标题
        if (titlePc) {
          titlePc.style.opacity = String(titleOpacity);
          titlePc.style.left = `${titleLeft}%`;
          titlePc.style.top = typeof titleTop === 'number' ? `${titleTop}px` : titleTop;
          titlePc.style.transform = titleTransform;
        }
        // 移动端标题
        if (titleMb) {
          titleMb.style.opacity = String(titleOpacity);
          titleMb.style.left = `${titleLeft}%`;
          titleMb.style.top = typeof titleTop === 'number' ? `${titleTop}px` : titleTop;
          titleMb.style.transform = titleTransform;
        }
        if (footer) {
          footer.style.opacity = String(footerOpacity);
          footer.style.left = `${footerLeft}%`;
          footer.style.top = typeof footerTop === 'number' ? `${footerTop}px` : footerTop;
          footer.style.transform = footerTransform;
        }
      }

      // 滚动处理
      let ticking = false;

      function onScroll() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(function() {
          ticking = false;

          const rect = scrollContainer.getBoundingClientRect();
          const containerHeight = scrollContainer.offsetHeight;
          const viewportHeight = window.innerHeight;

          // 计算滚动进度
          // 当元素顶部到达视口顶部时，progress = 0
          // 当元素底部到达视口底部时，progress = 1
          const scrollRange = containerHeight - viewportHeight;

          if (scrollRange <= 0) {
            applyAnimation(0);
            return;
          }

          // scrollTop: 元素已经滚过了多少（负值表示还在视口下方）
          const scrollTop = -rect.top;
          const progress = clamp(scrollTop / scrollRange, 0, 1);

          applyAnimation(progress);
        });
      }

      function onResize() {
        cssVarsCache = null; // 清除缓存，重新读取 CSS 变量
        onScroll();
      }

      // 绑定事件
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      // 初始化
      resetStyles();
      onScroll();

      // 存储控制器
      controllers.set(root, {
        root: root,
        destroy: function() {
          try {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
            resetStyles();
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    // 初始化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify 生命周期
    document.addEventListener('shopify:section:load', function(event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-sweep-overview"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-sweep-overview';
    const ROOT_SELECTOR = '[data-' + NS + ']';
    const SCENE_SELECTOR = '[data-ndev-x30-sweep-overview-scene]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const scenes = root.querySelectorAll(SCENE_SELECTOR);
      const sceneCount = scenes.length;

      if (sceneCount === 0) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 高度分布逻辑：
      // - 总滚动高度：400vh（可通过 CSS 变量配置）
      // - 首尾各预留 50vh 缓冲，共 100vh
      // - 剩余高度由所有场景平分
      // - 第一个场景额外获得 50vh，用于平滑进入过渡
      const ENTER_EXIT_BUFFER_VH = 100;
      const FIRST_SCENE_EXTRA_VH = 50;

      const heightStyle = getComputedStyle(root).getPropertyValue('--height').trim();
      let totalVh = 400;
      if (heightStyle) {
        const match = heightStyle.match(/(\d+)/);
        if (match) totalVh = parseInt(match[1], 10) || totalVh;
      }

      const scenesDurationVh = totalVh - ENTER_EXIT_BUFFER_VH;
      const baseSceneDurationVh = scenesDurationVh / sceneCount;
      const firstSceneDurationVh = baseSceneDurationVh + FIRST_SCENE_EXTRA_VH;
      const otherSceneDurationVh = baseSceneDurationVh;

      let ticking = false;
      let lastActiveIndex = -1;
      let pendingTimers = [];
      let lastScrollTop = 0;

      /**
       * 清理未完成的动画定时器
       */
      function clearPendingTimers() {
        pendingTimers.forEach(function (id) {
          clearTimeout(id);
        });
        pendingTimers = [];
      }

      /**
       * 清理场景的动画状态类
       */
      function clearAnimationStates(scene) {
        scene.classList.remove(
          'is-leaving-up', 'is-leaving-down',
          'is-entering-up', 'is-entering-down',
          'is-entered'
        );
      }

      /**
       * 清理所有场景的动画状态（快速滚动时使用）
       */
      function clearAllAnimationStates() {
        scenes.forEach(function (scene) {
          clearAnimationStates(scene);
        });
      }

      // 初始化：激活第一个场景，并标记为已进场（跳过进场动画）
      scenes[0].classList.add('is-active', 'is-entered');
      lastActiveIndex = 0;

      /**
       * 计算像素高度（基于当前视口）
       */
      function getHeights() {
        const viewportHeight = window.innerHeight;
        return {
          firstSceneHeightPx: (firstSceneDurationVh / 100) * viewportHeight,
          perSceneHeightPx: (otherSceneDurationVh / 100) * viewportHeight
        };
      }

      function updateActiveScene() {
        const heights = getHeights();
        const rect = root.getBoundingClientRect();
        const scrollTop = -rect.top;

        // 计算当前应该激活的场景索引
        let activeIndex = 0;
        if (scrollTop >= heights.firstSceneHeightPx) {
          const remainingScroll = scrollTop - heights.firstSceneHeightPx;
          const sceneIndex = Math.floor(remainingScroll / heights.perSceneHeightPx) + 1;
          activeIndex = Math.min(sceneIndex, sceneCount - 1);
        }

        if (activeIndex !== lastActiveIndex) {
          // 清理未完成的动画定时器和状态
          clearPendingTimers();
          clearAllAnimationStates();

          const oldScene = scenes[lastActiveIndex];
          const newScene = scenes[activeIndex];
          const isScrollingDown = scrollTop > lastScrollTop;

          // 离场动画
          oldScene.classList.add(isScrollingDown ? 'is-leaving-up' : 'is-leaving-down');

          // 150ms 后触发 opacity 过渡 + 进场动画（同时开始）
          pendingTimers.push(setTimeout(function () {
            oldScene.classList.remove('is-active');
            newScene.classList.add('is-active');
            // 进场动画和 opacity 过渡同时触发，跳变在 opacity=0 时不可见
            newScene.classList.add(isScrollingDown ? 'is-entering-down' : 'is-entering-up');

            // 150ms 后清理动画类，标记进场完成
            pendingTimers.push(setTimeout(function () {
              clearAnimationStates(newScene);
              newScene.classList.add('is-entered');
            }, 150));
          }, 150));

          lastActiveIndex = activeIndex;
          lastScrollTop = scrollTop;
        }
      }

      let resizeTicking = false;

      function onResize() {
        if (!resizeTicking) {
          requestAnimationFrame(function () {
            resizeTicking = false;
          });
          resizeTicking = true;
        }
      }

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateActiveScene();
            ticking = false;
          });
          ticking = true;
        }
      }

      updateActiveScene();
      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });

      controllers.set(root, {
        root: root,
        destroy: function () {
          clearPendingTimers();
          window.removeEventListener('resize', onResize, { passive: true });
          window.removeEventListener('scroll', onScroll, { passive: true });
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-sweep-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-sweep-tabs';
    const ROOT_SELECTOR = '[data-' + NS + ']';
    const INIT_ATTR = 'data-' + NS + '-initialized';
    const PROGRESS_BAR_SELECTOR = '[class*="__progress-bar"]';
    const PROGRESS_RING_SELECTOR = '[class*="__progress-ring-circle"]';
    const PROGRESS_SELECTOR = '[class*="__progress"]';
    const CSS_VAR_DURATION = '--autoplay-duration';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    // Tab 状态管理
    const tabStates = new Map();
    let lastUpdateTime = 0;
    const THROTTLE_INTERVAL = 100;

    function isMobile() {
      return window.innerWidth < 1024;
    }

    function safePause(video, resetProgress) {
      if (!video) return;
      try { video.pause(); } catch (e) {}
      if (resetProgress) {
        try { video.currentTime = 0; } catch (e) {}
      }
    }

    function safePlay(video) {
      if (!video) return;
      try {
        if (!video.muted) video.muted = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function updateProgressBar(tab, progress) {
      const state = tabStates.get(tab);
      if (!state) return;

      const { progressBar, progressRing } = state;
      const mobile = isMobile();

      // 指示器样式 - 垂直进度条
      if (progressBar) {
        progressBar.style.setProperty('--progress-bar-height', progress + '%');
      }

      // 手风琴样式 - 环形进度条（仅 PC 端）
      if (progressRing && !mobile) {
        const circumference = 113.1;
        const offset = circumference - (progress / 100) * circumference;
        progressRing.style.setProperty('--progress-ring-offset', offset);
      }
    }

    function resetProgressBar(tab) {
      const state = tabStates.get(tab);
      if (!state) return;

      const { progressBar, progressRing } = state;
      if (progressBar) progressBar.style.setProperty('--progress-bar-height', '0%');
      if (progressRing) progressRing.style.setProperty('--progress-ring-offset', '113.1');
    }

    function setupVideoListeners(tab, state) {
      const { video, mediaKind } = state;
      if (!video || mediaKind !== 'video' || state.isListening) return;

      const handleTimeUpdate = function () {
        if (!video.duration) return;
        const now = Date.now();
        if (now - lastUpdateTime < THROTTLE_INTERVAL) return;
        lastUpdateTime = now;

        const progress = (video.currentTime / video.duration) * 100;
        updateProgressBar(tab, progress);
      };

      const handleEnded = function () {
        const tabs = Array.from(tab.parentElement.querySelectorAll('ui-tab'));
        const currentIndex = tabs.indexOf(tab);
        const nextIndex = (currentIndex + 1) % tabs.length;
        tabs[nextIndex].click();
      };

      video.addEventListener('timeupdate', handleTimeUpdate);
      video.addEventListener('ended', handleEnded);

      state.isListening = true;
      state.timeUpdateHandler = handleTimeUpdate;
      state.endedHandler = handleEnded;
    }

    function removeVideoListeners(state) {
      if (!state.video || !state.isListening) return;
      if (state.timeUpdateHandler) state.video.removeEventListener('timeupdate', state.timeUpdateHandler);
      if (state.endedHandler) state.video.removeEventListener('ended', state.endedHandler);
      state.isListening = false;
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const tabs = root.querySelectorAll('ui-tab');
      if (tabs.length === 0) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      let activeTab = null;
      let autoplayTimer = null;
      let lastIsMobile = isMobile();

      // 初始化每个 Tab 的状态
      tabs.forEach(function (tab) {
        const mediaKind = tab.getAttribute('data-media-kind') || 'image';
        const targetId = tab.getAttribute('target');
        const panel = targetId ? document.getElementById(targetId) : null;
        const video = panel ? panel.querySelector('video') : null;
        const progressBar = tab.querySelector(PROGRESS_BAR_SELECTOR);
        const progressRing = tab.querySelector(PROGRESS_RING_SELECTOR);

        tabStates.set(tab, {
          mediaKind: mediaKind,
          video: video,
          panel: panel,
          progressBar: progressBar,
          progressRing: progressRing,
          isListening: false
        });

        if (tab.hasAttribute('open')) activeTab = tab;
      });

      function shouldAutoplay() {
        const autoplayPc = root.getAttribute('data-autoplay-pc') !== 'false';
        const autoplayMb = root.getAttribute('data-autoplay-mb') === 'true';
        return isMobile() ? autoplayMb : autoplayPc;
      }

      function shouldAnimateProgress() {
        const animatePc = root.getAttribute('data-progress-animation-pc') !== 'false';
        const animateMb = root.getAttribute('data-progress-animation-mb') === 'true';
        return isMobile() ? animateMb : animatePc;
      }

      function getDuration(tab) {
        const state = tabStates.get(tab);
        if (state && state.video && state.video.duration) {
          return state.video.duration * 1000;
        }
        const progress = tab.querySelector(PROGRESS_SELECTOR);
        if (!progress) return 5000;
        const style = getComputedStyle(progress);
        const val = style.getPropertyValue(CSS_VAR_DURATION).trim();
        return parseInt(val || '5000', 10);
      }

      function startAutoplay() {
        stopAutoplay();
        if (!activeTab) return;
        const state = tabStates.get(activeTab);
        if (state && state.mediaKind === 'video') return; // 视频模式不用定时器

        if (!shouldAutoplay()) return;
        const duration = getDuration(activeTab);
        autoplayTimer = setTimeout(function () {
          const tabsArray = Array.prototype.slice.call(tabs);
          const currentIndex = tabsArray.indexOf(activeTab);
          const nextIndex = (currentIndex + 1) % tabsArray.length;
          tabs[nextIndex].click();
        }, duration);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function resetAnimation(el) {
        el.style.animation = 'none';
        void el.offsetHeight;
        el.style.animation = '';
      }

      function handleShow(e) {
        const tab = e.target;
        const state = tabStates.get(tab);
        if (!state) return;

        // 清理上一个 Tab
        if (activeTab && activeTab !== tab) {
          const prevState = tabStates.get(activeTab);
          if (prevState) {
            if (prevState.video) {
              safePause(prevState.video, prevState.mediaKind === 'video' ? false : true);
            }
            resetProgressBar(activeTab);
          }
        }

        activeTab = tab;

        // 更新移动端描述
        const tabIndex = Array.prototype.indexOf.call(tabs, tab);
        const mobileDescs = root.querySelectorAll('.ndev-x30-sweep-tabs__mobile-desc');
        mobileDescs.forEach(function(desc, index) {
          desc.classList.toggle('active', index === tabIndex);
        });

        // 根据媒体类型决定行为
        if (state.mediaKind === 'video' && state.video) {
          stopAutoplay();
          setupVideoListeners(tab, state);
          safePlay(state.video);
        } else {
          // 图片模式
          if (shouldAnimateProgress()) {
            const progressRing = tab.querySelector(PROGRESS_RING_SELECTOR);
            if (progressRing) {
              progressRing.classList.remove('ndev-x30-sweep-tabs-accordion__progress-ring-circle--anim');
              void progressRing.offsetWidth;
              progressRing.classList.add('ndev-x30-sweep-tabs-accordion__progress-ring-circle--anim');
            }
            const progressBar = tab.querySelector(PROGRESS_BAR_SELECTOR);
            if (progressBar) resetAnimation(progressBar);
          }
          startAutoplay();
        }
      }

      function handleResize() {
        const currentIsMobile = isMobile();
        if (currentIsMobile !== lastIsMobile) {
          lastIsMobile = currentIsMobile;
          startAutoplay();
        }
      }

      let resizeTimer = null;
      function handleResizeThrottled() {
        if (resizeTimer) return;
        resizeTimer = setTimeout(function () {
          resizeTimer = null;
          handleResize();
        }, 100);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('show', handleShow);
      });

      window.addEventListener('resize', handleResizeThrottled);

      // 初始化
      if (activeTab) {
        const state = tabStates.get(activeTab);
        if (state && state.mediaKind === 'video' && state.video) {
          setupVideoListeners(activeTab, state);
          safePlay(state.video);
        } else {
          if (shouldAnimateProgress()) {
            const progressRing = activeTab.querySelector(PROGRESS_RING_SELECTOR);
            if (progressRing) {
              progressRing.classList.add('ndev-x30-sweep-tabs-accordion__progress-ring-circle--anim');
            }
          }
          startAutoplay();
        }
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          stopAutoplay();
          if (resizeTimer) clearTimeout(resizeTimer);
          tabs.forEach(function (tab) {
            tab.removeEventListener('show', handleShow);
            const state = tabStates.get(tab);
            if (state) removeVideoListeners(state);
          });
          window.removeEventListener('resize', handleResizeThrottled);
          tabStates.clear();
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        },
      });
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-video-fps-item"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-video-fps-item';
    const ROOT_SELECTOR = '[data-ndev-x30-video-fps-item]';
    const FPS_ROOT_SELECTOR = '[data-ndev-sf]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      if (root.hasAttribute(INIT_ATTR)) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const startTime = parseFloat(root.dataset.startTime) || 0;
      const endTime = parseFloat(root.dataset.endTime) || 0;

      if (startTime >= endTime) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 找到父级帧动画容器
      const fpsRoot = root.closest(FPS_ROOT_SELECTOR);
      if (!fpsRoot) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      let isVisible = false;

      function onProgress(event) {
        const detail = event.detail || {};
        const progress = detail.progress || 0;
        const duration = detail.duration || 0;

        if (duration <= 0) return;

        const currentTime = progress * duration;
        const shouldShow = currentTime >= startTime && currentTime <= endTime;

        if (shouldShow !== isVisible) {
          isVisible = shouldShow;
          root.classList.toggle('is-visible', shouldShow);
        }
      }

      fpsRoot.addEventListener('ndev-sf-progress', onProgress);

      controllers.set(root, {
        root: root,
        fpsRoot: fpsRoot,
        destroy: function () {
          fpsRoot.removeEventListener('ndev-sf-progress', onProgress);
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
          root.classList.remove('is-visible');
        }
      });
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-white-subscribe-form"] && !Shopify.designMode) return;
  try {
    class NdevX30WhiteSubscribeForm extends BaseElement {
    init() {
      this._form = this.querySelector('form');
      this._input = this.querySelector('input[type="email"]');
      this._checkbox = this.querySelector('input[type="checkbox"]');
      this._button = this.querySelector('button[type="submit"]');
      this._buttonText = this.querySelector('.ndev-x30-white-subscribe-form__button-text');
      this._message = this.querySelector('[data-message]');
      this._urgencyMessages = Array.from(this.querySelectorAll('[data-urgency-message]'));
      this._defaultButtonText = this._buttonText ? this._buttonText.textContent : '';
      this._onSubmit = this._handleSubmit.bind(this);
      this._onInput = this._hideMessages.bind(this);
      this._isSubmitting = false;
      this._statsRequestId = 0;
      this._latestStatsTiers = [];
      this._activeTier = null;
      this._isSuccessLocked = false;

      if (this._form) {
        this._form.addEventListener('submit', this._onSubmit);
      }
      if (this._input) {
        this._input.addEventListener('input', this._onInput);
      }
      if (this._checkbox) {
        this._checkbox.addEventListener('change', this._onInput);
      }

      this._syncUrgencyFromConfig();
      this._syncStatusesFromConfig();
      this._refreshStats();
    }

    dispose() {
      if (this._form && this._onSubmit) {
        this._form.removeEventListener('submit', this._onSubmit);
      }
      if (this._input && this._onInput) {
        this._input.removeEventListener('input', this._onInput);
      }
      if (this._checkbox && this._onInput) {
        this._checkbox.removeEventListener('change', this._onInput);
      }
      this._form = null;
      this._input = null;
      this._checkbox = null;
      this._button = null;
      this._buttonText = null;
      this._message = null;
      this._urgencyMessages = null;
      this._onSubmit = null;
      this._onInput = null;
      this._isSubmitting = false;
      this._latestStatsTiers = [];
      this._activeTier = null;
      this._isSuccessLocked = false;
    }

    async _handleSubmit(event) {
      event.preventDefault();
      if (this._isSubmitting || this._isSuccessLocked) return;

      const email = this._input ? this._input.value.trim() : '';
      if (!email) {
        this._showError(this.getAttribute('email-empty-message'), 'email');
        return;
      }

      this._setLoading(true);
      this._hideMessages();
      this._isSubmitting = true;

      try {
        const klaviyo = await this._getKlaviyoApi();

        if (!klaviyo) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }

        if (!klaviyo.validateEmail(email)) {
          this._showError(this.getAttribute('email-invalid-message'), 'email');
          return;
        }

        const requireAgreement = this.getAttribute('require-agreement') === 'true';
        if (requireAgreement && this._checkbox && !this._checkbox.checked) {
          this._showAgreementError();
          return;
        }

        const groupConfig = this._readTierConfig();
        if (!groupConfig || !groupConfig.apiHost || !groupConfig.activityCode || !groupConfig.countryCode || !groupConfig.companyId) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }
        if (!this._hasRequiredTierConfig(groupConfig.tiers)) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }

        if (
          !window.$countSubscribe ||
          !window.$countSubscribe.issueCoupon
        ) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }

        const issueResult = await window.$countSubscribe.issueCoupon({
          apiHost: groupConfig.apiHost,
          activityCode: groupConfig.activityCode,
          countryCode: groupConfig.countryCode,
          email: email
        });

        if (!issueResult || !issueResult.success || !issueResult.data) {
          this._showError(this._parseErrorMessage(issueResult && issueResult.error));
          return;
        }

        const coupon = issueResult.data;
        const klaviyoGroupKey = coupon.klaviyoGroupKey ? String(coupon.klaviyoGroupKey).trim() : '';
        const couponName = coupon.couponName ? String(coupon.couponName).trim() : '';
        const couponCode = coupon.couponCode ? String(coupon.couponCode).trim() : '';
        if ((klaviyoGroupKey || couponName) && (!Array.isArray(this._latestStatsTiers) || this._latestStatsTiers.length === 0)) {
          await this._refreshStats();
        }
        const tier = this._findTierForCoupon(coupon, groupConfig.tiers);

        if (!tier || !tier.listId || !tier.profilePropertyKey || !couponCode) {
          this._showError(this.getAttribute('missing-config-message'));
          return;
        }

        const properties = {};
        properties[tier.profilePropertyKey] = couponCode;

        const klaviyoResult = await this._updateProfileAndSubscribe({
          email: email,
          apiKey: groupConfig.companyId,
          listId: tier.listId,
          properties: properties,
          klaviyo: klaviyo,
          ga4: this._readGa4Config()
        });

        if (klaviyoResult && klaviyoResult.success) {
          this._recordFakeTierSubscription(tier, email, coupon.newlyIssued !== false);
          this._showSuccess();
          this._lockSuccessForm();
          this._refreshStats();
        } else {
          this._showError(this._parseErrorMessage(klaviyoResult && klaviyoResult.error));
        }
      } catch (error) {
        this._showError(this._parseErrorMessage(error && error.message));
      } finally {
        this._isSubmitting = false;
        this._setLoading(false);
      }
    }

    _readTierConfig() {
      const scope = this._getTierScope();
      const tierScripts = scope ? Array.from(scope.querySelectorAll('[data-x30-white-tier-item-config]')) : [];

      if (tierScripts.length === 0) return null;

      const tiers = tierScripts
        .map((script) => {
          try {
            return JSON.parse(script.textContent || '{}');
          } catch (error) {
            return null;
          }
        })
        .filter(Boolean);

      return {
        apiHost: String(this.getAttribute('api-host') || '').trim(),
        activityCode: String(this.getAttribute('activity-code') || '').trim(),
        countryCode: String(this.getAttribute('country-code') || '').trim(),
        companyId: String(this.getAttribute('company-id') || '').trim(),
        tiers: tiers.map((tier) => this._normalizeTier(tier))
      };
    }

    _hasRequiredTierConfig(tiers) {
      return Array.isArray(tiers) && tiers.length > 0 && tiers.every((tier) => {
        return tier && tier.listId && tier.profilePropertyKey;
      });
    }

    _readGa4Config() {
      const eventName = String(this.getAttribute('ga4-event') || '').trim();
      if (!eventName) return undefined;

      return {
        event: eventName,
        module: this.getAttribute('ga4-module') || '',
        btn: this.getAttribute('ga4-button') || ''
      };
    }

    _getKlaviyoApi() {
      if (window.$klaviyo && window.$klaviyo.subscribe && window.$klaviyo.updateProfile && window.$klaviyo.validateEmail) {
        return Promise.resolve(window.$klaviyo);
      }

      return new Promise((resolve) => {
        const timeout = window.setTimeout(() => {
          window.removeEventListener('ndev:klaviyo-api-ready', handleReady);
          resolve(null);
        }, 3000);

        const handleReady = () => {
          window.clearTimeout(timeout);
          window.removeEventListener('ndev:klaviyo-api-ready', handleReady);
          if (window.$klaviyo && window.$klaviyo.subscribe && window.$klaviyo.updateProfile && window.$klaviyo.validateEmail) {
            resolve(window.$klaviyo);
          } else {
            resolve(null);
          }
        };

        window.addEventListener('ndev:klaviyo-api-ready', handleReady);
      });
    }

    _normalizeTier(tier) {
      const progressPercent = this._clampPercent(Number(tier && tier.progressPercent ? tier.progressPercent : 0));
      const displayCapacity = Math.max(1, Number(tier && tier.displayCapacity ? tier.displayCapacity : 0));
      return {
        ...tier,
        listId: tier && tier.listId ? String(tier.listId).trim() : '',
        profilePropertyKey: tier && tier.profilePropertyKey ? String(tier.profilePropertyKey).trim() : '',
        tierId: tier && tier.tierId ? String(tier.tierId).trim() : '',
        progressMode: tier && tier.progressMode ? String(tier.progressMode).trim() : 'real',
        isActive: Boolean(tier && tier.isActive),
        progressPercent: progressPercent,
        displayCapacity: displayCapacity,
        remainingDisplayCount: Math.max(0, Number(tier && tier.remainingDisplayCount ? tier.remainingDisplayCount : 0)),
        remainingPercent: this._clampPercent(Number(tier && tier.remainingPercent ? tier.remainingPercent : 0)),
        showUrgency: Boolean(tier && tier.showUrgency),
        urgencyThresholdPercent: this._clampPercent(Number(tier && tier.urgencyThresholdPercent ? tier.urgencyThresholdPercent : 0))
      };
    }

    _normalizeEmail(email) {
      return String(email || '').trim().toLowerCase();
    }

    _getStorageKey(tier) {
      const activityCode = String(this.getAttribute('activity-code') || 'x30').trim() || 'x30';
      const countryCode = String(this.getAttribute('country-code') || 'eu').trim() || 'eu';
      const tierId = tier && tier.tierId ? String(tier.tierId).trim() : 'unknown-tier';
      return `ndev:x30-white-subscribe:${activityCode}:${countryCode}:${tierId}`;
    }

    _readFakeProgressState(tier) {
      const fallback = {
        baseClaimedCount: null,
        emails: []
      };

      try {
        const raw = window.localStorage ? window.localStorage.getItem(this._getStorageKey(tier)) : '';
        if (!raw) return fallback;

        const data = JSON.parse(raw);
        const emails = Array.isArray(data.emails)
          ? data.emails.map((email) => this._normalizeEmail(email)).filter(Boolean)
          : [];
        const baseClaimedCount = Number.isFinite(Number(data.baseClaimedCount))
          ? Math.max(0, Math.floor(Number(data.baseClaimedCount)))
          : null;

        return {
          baseClaimedCount,
          emails: Array.from(new Set(emails))
        };
      } catch (error) {
        return fallback;
      }
    }

    _writeFakeProgressState(tier, state) {
      try {
        if (!window.localStorage) return;
        window.localStorage.setItem(this._getStorageKey(tier), JSON.stringify({
          baseClaimedCount: Math.max(0, Math.floor(Number(state && state.baseClaimedCount ? state.baseClaimedCount : 0))),
          emails: Array.isArray(state && state.emails) ? state.emails : []
        }));
      } catch (error) {}
    }

    _getConfiguredFakeClaimedCount(tier) {
      const displayCapacity = Math.max(1, Number(tier && tier.displayCapacity ? tier.displayCapacity : 1));
      const progressPercent = this._clampPercent(Number(tier && tier.progressPercent ? tier.progressPercent : 0));
      const randomExtraPercent = Math.random();
      return Math.min(displayCapacity, Math.floor(displayCapacity * (progressPercent + randomExtraPercent) / 100));
    }

    _resolveFakeProgressState(tier) {
      const state = this._readFakeProgressState(tier);
      const configuredClaimedCount = this._getConfiguredFakeClaimedCount(tier);
      const nextBaseClaimedCount = Math.max(configuredClaimedCount, Number(state.baseClaimedCount || 0));
      const nextState = {
        baseClaimedCount: nextBaseClaimedCount,
        emails: state.emails
      };

      if (nextBaseClaimedCount !== state.baseClaimedCount) {
        this._writeFakeProgressState(tier, nextState);
      }

      return nextState;
    }

    _recordFakeTierSubscription(tier, email, shouldIncrement) {
      if (!tier || tier.progressMode !== 'fake') return;

      const normalizedEmail = this._normalizeEmail(email);
      if (!normalizedEmail) return;

      const state = this._resolveFakeProgressState(tier);
      const persistedEmailSet = new Set(state.emails);
      let baseClaimedCount = Number(state.baseClaimedCount || 0);

      if (shouldIncrement && !persistedEmailSet.has(normalizedEmail)) {
        baseClaimedCount += 1;
      }
      persistedEmailSet.add(normalizedEmail);

      this._writeFakeProgressState(tier, {
        baseClaimedCount,
        emails: Array.from(persistedEmailSet)
      });
    }

    _getTierScope() {
      return this.closest('.ndev-x30-white-subscribe__subscribe') || this.closest('.ndev-x30-white-subscribe__content') || this.parentElement;
    }

    async _refreshStats() {
      const config = this._readTierConfig();
      if (!config || !config.apiHost || !config.activityCode || !config.countryCode || !window.$countSubscribe || !window.$countSubscribe.getStats) {
        return;
      }

      const requestId = ++this._statsRequestId;
      const result = await window.$countSubscribe.getStats({
        apiHost: config.apiHost,
        activityCode: config.activityCode,
        countryCode: config.countryCode
      });

      if (requestId !== this._statsRequestId) {
        return;
      }

      if (!result || !result.success || !result.data) {
        return;
      }

      this._applyStats(result.data);
    }

    _applyStats(stats) {
      const config = this._readTierConfig();
      const statsTiers = stats && Array.isArray(stats.tiers) ? stats.tiers : [];
      if (!config || !Array.isArray(config.tiers) || config.tiers.length === 0 || statsTiers.length === 0) {
        this._syncUrgencyFromConfig();
        return;
      }

      const activeStat = statsTiers.find((tier) => {
        const total = Number(tier && tier.total ? tier.total : 0);
        const issued = Number(tier && tier.issued ? tier.issued : 0);
        return total > 0 && issued < total;
      }) || statsTiers[statsTiers.length - 1];
      const activeIndex = Math.max(0, statsTiers.indexOf(activeStat));

      this._latestStatsTiers = statsTiers;
      this._activeTier = config.tiers[activeIndex] || null;

      config.tiers.forEach((tier, index) => {
        const stat = statsTiers[index] || null;
        const isActive = index === activeIndex;
        const view = this._resolveTierView(tier, stat, isActive);
        this._updateTierDom(tier.tierId, view);
      });

      this._syncUrgencyFromConfig();
      this._updateButtonText();
    }

    _resolveTierView(tier, stat, isActive) {
      const total = Math.max(1, Number(stat && stat.total ? stat.total : tier.displayCapacity || 1));
      const issued = Math.max(0, Number(stat && stat.issued ? stat.issued : 0));
      let progressPercent = 0;
      let displayCapacity = total;
      let claimedDisplayCount = 0;

      if (tier.progressMode === 'fake') {
        displayCapacity = tier.displayCapacity || total;
        if (isActive) {
          const fakeState = this._resolveFakeProgressState(tier);
          claimedDisplayCount = Math.min(displayCapacity, Math.max(0, Math.floor(Number(fakeState.baseClaimedCount || 0))));
          progressPercent = this._clampPercent(Math.round(claimedDisplayCount / displayCapacity * 100));
        } else {
          progressPercent = 0;
          claimedDisplayCount = 0;
        }
      } else {
        progressPercent = this._clampPercent(Math.round(issued / total * 100));
        claimedDisplayCount = Math.min(issued, total);
      }

      const remainingDisplayCount = Math.max(0, displayCapacity - claimedDisplayCount);
      const remainingPercent = this._clampPercent(100 - progressPercent);
      const isFull = Boolean(stat && Number(stat.total || 0) > 0 && Number(stat.issued || 0) >= Number(stat.total || 0));

      return {
        isActive: isActive,
        isFull: isFull,
        progressPercent: progressPercent,
        displayCapacity: displayCapacity,
        claimedDisplayCount: claimedDisplayCount,
        remainingDisplayCount: remainingDisplayCount,
        remainingPercent: remainingPercent,
        showUrgency: Boolean(tier.showUrgency && isActive && remainingPercent <= tier.urgencyThresholdPercent),
        urgencyThresholdPercent: tier.urgencyThresholdPercent
      };
    }

    _updateTierDom(tierId, view) {
      if (!tierId) return;
      const scope = this._getTierScope();
      const tierEl = scope ? scope.querySelector(`[data-tier-id="${window.CSS && CSS.escape ? CSS.escape(tierId) : tierId}"]`) : null;
      if (!tierEl) return;

      tierEl.classList.toggle('is-active', view.isActive);
      tierEl.setAttribute('data-tier-active', view.isActive ? 'true' : 'false');
      tierEl.setAttribute('data-tier-full', view.isFull ? 'true' : 'false');
      tierEl.setAttribute('data-urgency-visible', view.showUrgency ? 'true' : 'false');
      tierEl.style.setProperty('--x30-tier-progress', `${view.progressPercent}%`);

      const statusNode = tierEl.querySelector('[data-tier-status-text]');
      if (statusNode) {
        statusNode.textContent = this._resolveTierStatusText(view);
      }

      const configScript = tierEl.querySelector('[data-x30-white-tier-item-config]');
      if (!configScript) return;

      try {
        const data = JSON.parse(configScript.textContent || '{}');
        const nextData = {
          ...data,
          isActive: view.isActive,
          isFull: view.isFull,
          progressPercent: view.progressPercent,
          displayCapacity: view.displayCapacity,
          claimedDisplayCount: view.claimedDisplayCount,
          remainingDisplayCount: view.remainingDisplayCount,
          remainingPercent: view.remainingPercent,
          showUrgency: Boolean(data.showUrgency),
          urgencyVisible: view.showUrgency,
          urgencyThresholdPercent: view.urgencyThresholdPercent
        };
        configScript.textContent = JSON.stringify(nextData);
      } catch (error) {}
    }

    _syncStatusesFromConfig() {
      const config = this._readTierConfig();
      if (!config || !Array.isArray(config.tiers)) return;

      config.tiers.forEach((tier) => {
        const view = {
          isActive: Boolean(tier && tier.isActive),
          isFull: Boolean(tier && tier.isFull)
        };
        const scope = this._getTierScope();
        const tierEl = scope && tier.tierId ? scope.querySelector(`[data-tier-id="${window.CSS && CSS.escape ? CSS.escape(tier.tierId) : tier.tierId}"]`) : null;
        const statusNode = tierEl ? tierEl.querySelector('[data-tier-status-text]') : null;
        if (statusNode) statusNode.textContent = this._resolveTierStatusText(view);
      });
    }

    _resolveTierStatusText(view) {
      const textConfig = this._readStatusTextConfig();
      if (view && view.isFull) return textConfig.full;
      if (view && view.isActive) return textConfig.active;
      return textConfig.pending;
    }

    _readStatusTextConfig() {
      const scope = this._getTierScope();
      const group = scope ? scope.querySelector('.ndev-x30-white-tier-group') : null;
      return {
        pending: (group && group.getAttribute('data-pending-status-text')) || 'NEXT TIER',
        active: (group && group.getAttribute('data-active-status-text')) || 'OPEN NOW',
        full: (group && group.getAttribute('data-full-status-text')) || 'FULL'
      };
    }

    _syncUrgencyFromConfig() {
      const config = this._readTierConfig();
      if (!config || !Array.isArray(config.tiers)) {
        this._setUrgency(null);
        return;
      }

      const tiers = config.tiers.map((tier) => ({
        ...tier,
        isActive: Boolean(tier && tier.isActive),
        showUrgency: Boolean(tier && tier.showUrgency),
        urgencyVisible: Boolean(tier && tier.urgencyVisible),
        remainingDisplayCount: Number(tier && tier.remainingDisplayCount ? tier.remainingDisplayCount : 0),
        displayCapacity: Number(tier && tier.displayCapacity ? tier.displayCapacity : 0),
        remainingPercent: Number(tier && tier.remainingPercent ? tier.remainingPercent : 0),
        urgencyThresholdPercent: Number(tier && tier.urgencyThresholdPercent ? tier.urgencyThresholdPercent : 0)
      }));
      const activeTier = tiers.find((tier) => tier.isActive);

      if (!activeTier || !activeTier.showUrgency || !activeTier.urgencyVisible) {
        this._setUrgency(null);
        return;
      }

      this._setUrgency(activeTier);
    }

    _setUrgency(tier) {
      if (!this._urgencyMessages || this._urgencyMessages.length === 0) return;
      if (!tier) {
        this._urgencyMessages.forEach((node) => {
          const wrap = node.closest('[data-urgency-message-wrap]');
          if (wrap) wrap.hidden = true;
          node.hidden = true;
          node.textContent = '';
        });
        return;
      }

      const template = this.getAttribute('urgency-template') || '{remaining} of {total} spots left';
      const text = template
        .replace(/\{remaining\}/g, String(tier.remainingDisplayCount))
        .replace(/\{total\}/g, String(tier.displayCapacity))
        .replace(/\{percent\}/g, String(tier.remainingPercent));
      this._urgencyMessages.forEach((node) => {
        const wrap = node.closest('[data-urgency-message-wrap]');
        if (wrap) wrap.hidden = false;
        node.textContent = text;
        node.hidden = false;
      });
    }

    _formatButtonText(template, tier) {
      const reward = tier && tier.reward ? String(tier.reward) : '';
      const fallback = template || this._defaultButtonText || '';
      return fallback
        .replace(/\{reward\}/g, reward)
        .replace(/\{amount\}/g, reward);
    }

    _updateButtonText() {
      if (!this._buttonText) return;

      if (this._isSubmitting) {
        this._buttonText.textContent = this.getAttribute('submitting-text');
        return;
      }

      if (this._isSuccessLocked) {
        this._buttonText.textContent = this.getAttribute('finished-button-text') || this._defaultButtonText;
        return;
      }

      this._buttonText.textContent = this._formatButtonText(this._defaultButtonText, this._activeTier);
    }

    _setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      if (this._button) {
        this._button.disabled = this._isSuccessLocked || isLoading;
      }
      this._updateButtonText();
    }

    _lockSuccessForm() {
      this._isSuccessLocked = true;
      this.classList.add('is-success-locked');
      if (this._input) this._input.disabled = true;
      if (this._checkbox) this._checkbox.disabled = true;
      if (this._button) this._button.disabled = true;
      if (this._buttonText) {
        this._buttonText.textContent = this.getAttribute('finished-button-text') || this._defaultButtonText;
      }
    }

    _showError(message, field) {
      this.classList.add('is-error');
      this.classList.remove('is-success');
      this._setInvalidField(field);
      if (!this._message) return;
      this._message.classList.add('is-error');
      this._message.classList.remove('is-success');
      this._message.setAttribute('role', 'alert');
      this._message.setAttribute('aria-live', 'assertive');
      this._message.textContent = message || this.getAttribute('error-message') || '';
      this._message.hidden = false;
    }

    _showAgreementError() {
      this._showError(this.getAttribute('agreement-required-message'), 'agreement');
    }

    _showSuccess() {
      this.classList.add('is-success');
      this.classList.remove('is-error');
      this._clearInvalidFields();
      if (this._message) {
        this._message.hidden = true;
        this._message.classList.remove('is-error', 'is-success');
        this._message.removeAttribute('role');
        this._message.setAttribute('aria-live', 'polite');
        this._message.replaceChildren();
      }
    }

    _hideMessages() {
      this.classList.remove('is-error', 'is-success');
      this._clearInvalidFields();
      if (this._message) {
        this._message.hidden = true;
        this._message.classList.remove('is-error', 'is-success');
        this._message.removeAttribute('role');
        this._message.setAttribute('aria-live', 'polite');
        this._message.replaceChildren();
      }
    }

    _setInvalidField(field) {
      this._clearInvalidFields();
      if (field === 'email' && this._input) {
        this._input.setAttribute('aria-invalid', 'true');
      }
      if (field === 'agreement' && this._checkbox) {
        this._checkbox.setAttribute('aria-invalid', 'true');
      }
    }

    _clearInvalidFields() {
      if (this._input) {
        this._input.setAttribute('aria-invalid', 'false');
      }
      if (this._checkbox) {
        this._checkbox.setAttribute('aria-invalid', 'false');
      }
    }

    _parseErrorMessage(message) {
      const fallback = this.getAttribute('error-message') || 'Subscription failed. Please try again.';
      const alreadyRegistered = this.getAttribute('email-already-registered-message') || 'This email is already registered.';
      const invalid = this.getAttribute('email-invalid-message') || 'This email is invalid.';
      const rawMessage = message || fallback;
      const lowerMessage = String(rawMessage).toLowerCase();

      if (window.$klaviyo && window.$klaviyo.parseErrorMessage) {
        return window.$klaviyo.parseErrorMessage(
          { message: rawMessage },
          {
            alreadyRegistered: alreadyRegistered,
            invalid: invalid,
            default: fallback
          }
        );
      }

      if (lowerMessage.includes('already') || lowerMessage.includes('exists')) return alreadyRegistered;
      if (lowerMessage.includes('invalid')) return invalid;
      return rawMessage || fallback;
    }

    async _updateProfileAndSubscribe(config) {
      const updateResult = await config.klaviyo.updateProfile({
        email: config.email,
        apiKey: config.apiKey,
        properties: config.properties
      });

      if (!updateResult || !updateResult.success) {
        return updateResult || {
          success: false,
          error: this.getAttribute('error-message')
        };
      }

      const subscribeResult = await config.klaviyo.subscribe({
        email: config.email,
        apiKey: config.apiKey,
        listId: config.listId,
        ga4: config.ga4
      });
      const subscribeError = subscribeResult && subscribeResult.error ? String(subscribeResult.error).toLowerCase() : '';
      const isDuplicate = subscribeError.includes('already') || subscribeError.includes('exists');

      if (subscribeResult && !subscribeResult.success && !isDuplicate) {
        return subscribeResult;
      }

      return {
        success: true,
        subscribe: subscribeResult,
        update: updateResult
      };
    }

    _findTierForCoupon(coupon, tiers) {
      if (!Array.isArray(tiers) || tiers.length === 0) return null;

      const klaviyoGroupKey = coupon && coupon.klaviyoGroupKey ? String(coupon.klaviyoGroupKey).trim() : '';
      const couponName = coupon && coupon.couponName ? String(coupon.couponName).trim() : '';
      const statsTiers = Array.isArray(this._latestStatsTiers) ? this._latestStatsTiers : [];
      const index = statsTiers.findIndex((tier) => {
        const statGroupKey = tier && tier.klaviyoGroupKey ? String(tier.klaviyoGroupKey).trim() : '';
        const statCouponName = tier && tier.couponName ? String(tier.couponName).trim() : '';
        return (klaviyoGroupKey && statGroupKey === klaviyoGroupKey) || (couponName && statCouponName === couponName);
      });

      if (index >= 0 && tiers[index]) return tiers[index];
      console.warn('[X30 White Subscribe] Unable to map coupon to tier by stats order.', {
        klaviyoGroupKey,
        couponName,
        statsTiers
      });
      return null;
    }

    _clampPercent(value) {
      if (!Number.isFinite(value)) return 0;
      return Math.min(100, Math.max(0, value));
    }
  }

  if (!customElements.get('ndev-x30-white-subscribe-form')) {
    customElements.define('ndev-x30-white-subscribe-form', NdevX30WhiteSubscribeForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_page-banner-button"] && !Shopify.designMode) return;
  try {
    class NdevPageBannerButton extends BaseElement {
    init() {
      this.dispose();
      this.listeners = [];
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.on(this, 'click', (event) => this.handleClick(event));
    }

    dispose() {
      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];
    }

    on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    handleClick(event) {
      const anchor = event.target && event.target.closest
        ? event.target.closest('a.page-banner__btn')
        : null;
      if (!anchor || !this.contains(anchor)) return;

      const actionType = this.getAttribute('action-type');
      if (actionType === 'scroll') {
        event.preventDefault();
        const sectionIndex = parseInt(this.getAttribute('scroll-to-section'), 10) || 1;
        const sections = Array.from(document.querySelectorAll('#main-content .shopify-section'));
        const targetSection = sections[sectionIndex - 1];
        if (targetSection) {
          targetSection.scrollIntoView({
            behavior: this.motionQuery.matches ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      } else if (actionType === 'spin') {
        event.preventDefault();
        const spinLink = this.getAttribute('spin-link');
        if (spinLink) {
          window.location.href = spinLink;
          return;
        }
        const spinTrigger = document.getElementById('crazyrocket-launch-icon');
        if (spinTrigger) spinTrigger.click();
      }
      // url：原生跳转；popup_video：由 _ndev-page-banner-button-assets 在锚点上接管
    }
  }

  if (!customElements.get('ndev-page-banner-button')) {
    customElements.define('ndev-page-banner-button', NdevPageBannerButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_page-banner-slide"] && !Shopify.designMode) return;
  try {
    class NdevPageBannerSlide extends BaseElement {
    init() {
      this.dispose();
      this.listeners = [];
      this.mobileQuery = window.matchMedia('(max-width: 1023px)');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = !('IntersectionObserver' in window);

      this.attributeObserver = new MutationObserver(() => this.syncMedia());
      this.attributeObserver.observe(this, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'inert']
      });

      if ('IntersectionObserver' in window) {
        this.inViewObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const wasInView = this.inView;
          this.inView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
          if (wasInView !== this.inView) this.syncMedia();
        }, { threshold: [0, 0.01] });
        this.inViewObserver.observe(this);
      }

      this.on(document, 'visibilitychange', () => this.syncMedia());
      this.onMediaQuery(this.mobileQuery, () => this.syncMedia());
      this.onMediaQuery(this.motionQuery, () => this.syncMedia());

      if (this.hasAttribute('data-slide-href')) {
        this.on(this, 'click', (event) => this.handleClick(event));
        this.on(this, 'keydown', (event) => this.handleKeydown(event));
      }

      this.syncMedia();
    }

    dispose() {
      if (this.attributeObserver) this.attributeObserver.disconnect();
      this.attributeObserver = null;
      if (this.inViewObserver) this.inViewObserver.disconnect();
      this.inViewObserver = null;

      if (this.mediaQueryListeners) {
        this.mediaQueryListeners.forEach(({ query, handler }) => {
          if (query.removeListener) query.removeListener(handler);
        });
      }
      this.mediaQueryListeners = [];

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];

      this.querySelectorAll('.page-banner__bg-video').forEach((video) => {
        try { video.pause(); } catch (error) {}
      });
    }

    on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    onMediaQuery(query, handler) {
      if (!query) return;
      this.mediaQueryListeners = this.mediaQueryListeners || [];
      if (query.addEventListener) {
        query.addEventListener('change', handler);
      } else if (query.addListener) {
        query.addListener(handler);
      }
      this.mediaQueryListeners.push({ query, handler });
    }

    isActiveSlide() {
      return this.getAttribute('aria-hidden') !== 'true';
    }

    syncMedia() {
      if (!this.isConnected) return;
      // Swiper loop 克隆节点：活性属性是克隆瞬间的快照，媒体播放沿用原控制器契约（克隆不播放）
      const isDuplicate = Boolean(this.closest('.swiper-slide-duplicate'));
      const shouldPlay = !isDuplicate
        && this.isActiveSlide()
        && this.inView
        && !document.hidden
        && !this.motionQuery.matches;

      this.querySelectorAll('.page-banner__bg-video').forEach((video) => {
        const mobile = this.mobileQuery.matches;
        const visibleBranch = mobile
          ? video.classList.contains('show-mb')
          : video.classList.contains('show-pc');

        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        if (!shouldPlay || !visibleBranch) {
          try { video.pause(); } catch (error) {}
          return;
        }

        if (video.preload === 'none' && video.readyState === 0) {
          try { video.load(); } catch (error) {}
        }

        try {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        } catch (error) {}
      });
    }

    handleClick(event) {
      if (!this.hasAttribute('data-slide-href')) return;
      if (!this.isActiveSlide()) return;
      const controller = this.closest('ndev-page-banner');
      if (controller && controller.swiper && controller.swiper.allowClick === false) return;
      if (this.isInteractiveTarget(event.target)) return;
      this.navigate();
    }

    handleKeydown(event) {
      if (!this.hasAttribute('data-slide-href')) return;
      const controller = this.closest('ndev-page-banner');
      if (controller && controller.swiper && controller.swiper.allowClick === false) return;
      if (this.isInteractiveTarget(event.target)) return;
      const key = event.key || event.code;
      if (!(key === 'Enter' || key === ' ' || key === 'Spacebar')) return;
      event.preventDefault();
      this.navigate();
    }

    isInteractiveTarget(target) {
      if (!target || !target.closest) return false;
      return Boolean(
        target.closest(
          'a, button, input, textarea, select, option, label, summary, dialog, [role="button"], [data-page-banner-no-slide-link]'
        )
      );
    }

    navigate() {
      const href = this.getAttribute('data-slide-href');
      if (!href) return;
      if (this.getAttribute('data-slide-target') === '_blank') window.open(href, '_blank', 'noopener');
      else window.location.href = href;
    }
  }

  if (!customElements.get('ndev-page-banner-slide')) {
    customElements.define('ndev-page-banner-slide', NdevPageBannerSlide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_page-banner-subscribe-form"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ndev-page-banner-subscribe')) return;

    class PageBannerSubscribe extends BaseElement {
      init() {
        this.dispose();
        this.generation = (this.generation || 0) + 1;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.button = this.querySelector('button[type="submit"]');
        this.buttonText = this.querySelector('.page-banner__subscribe-button-text');
        this.message = this.querySelector('[data-message]');
        this.success = this.querySelector('[data-inline-success]');
        this.successDialog = document.getElementById(`${this.id}-success-dialog`);
        this.dialogTitle = this.successDialog?.querySelector('.page-banner__subscribe-dialog-title') || null;
        this.defaultButtonText = this.buttonText ? this.buttonText.textContent : '';
        this.submitting = false;
        this.successLocked = false;
        this.klaviyoWait = null;
        this.onSubmit = this.handleSubmit.bind(this);
        this.onInput = this.hideMessages.bind(this);
        this.resetUi();
        this.form?.addEventListener('submit', this.onSubmit);
        this.input?.addEventListener('input', this.onInput);
        this.checkbox?.addEventListener('change', this.onInput);
      }

      dispose() {
        this.generation = (this.generation || 0) + 1;
        this.form?.removeEventListener('submit', this.onSubmit);
        this.input?.removeEventListener('input', this.onInput);
        this.checkbox?.removeEventListener('change', this.onInput);
        this.cancelKlaviyoWait();
        if (this.successDialog && typeof this.successDialog.close === 'function') this.successDialog.close();
        this.form = this.input = this.checkbox = this.button = this.buttonText = this.message = this.success = null;
        this.successDialog = this.dialogTitle = null;
        this.submitting = false;
        this.successLocked = false;
      }

      resetUi() {
        this.classList.remove('is-loading', 'is-error', 'is-success');
        this.setAttribute('aria-busy', 'false');
        if (this.input) this.input.disabled = false;
        if (this.checkbox) this.checkbox.disabled = false;
        if (this.button) this.button.disabled = false;
        if (this.message) {
          this.message.hidden = true;
          this.message.textContent = '';
        }
        if (this.success) this.success.hidden = true;
        this.clearInvalidFields();
        this.updateButtonText();
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.submitting || this.successLocked) return;
        const generation = this.generation;
        const email = this.input?.value.trim() || '';
        if (!email) {
          this.showError(this.getAttribute('email-empty-message'), 'email');
          return;
        }
        this.submitting = true;
        this.setLoading(true);
        this.hideMessages();
        try {
          const klaviyo = await this.getKlaviyoApi(generation);
          if (!this.isCurrent(generation)) return;
          if (!klaviyo || !this.getAttribute('company-id') || !this.getAttribute('list-id')) {
            this.showError(this.getAttribute('missing-config-message'));
            return;
          }
          if (!klaviyo.validateEmail(email)) {
            this.showError(this.getAttribute('email-invalid-message'), 'email');
            return;
          }
          if (this.getAttribute('require-agreement') === 'true' && this.checkbox && !this.checkbox.checked) {
            this.showError(this.getAttribute('agreement-required-message'), 'agreement');
            return;
          }
          const result = await klaviyo.subscribe({
            email,
            apiKey: this.getAttribute('company-id'),
            listId: this.getAttribute('list-id'),
            emitSuccess: false,
          });
          if (!this.isCurrent(generation)) return;
          const error = result?.error ? String(result.error).toLowerCase() : '';
          if (!result?.success && !(error.includes('already') || error.includes('exists'))) {
            this.showError(this.parseError(result?.error));
            return;
          }
          this.showSuccess();
          this.lockSuccess();
          this.openSuccessDialog(generation);
        } catch (error) {
          if (this.isCurrent(generation)) this.showError(this.parseError(error?.message));
        } finally {
          if (this.isCurrent(generation)) {
            this.submitting = false;
            this.setLoading(false);
          }
        }
      }

      isCurrent(generation) {
        return this.isConnected && generation === this.generation;
      }
      setLoading(value) {
        this.classList.toggle('is-loading', value);
        this.setAttribute('aria-busy', value ? 'true' : 'false');
        if (this.button) this.button.disabled = value || this.successLocked;
        if (this.buttonText)
          this.buttonText.textContent = value
            ? this.getAttribute('submitting-text')
            : this.successLocked
            ? this.getAttribute('finished-button-text')
            : this.defaultButtonText;
      }
      updateButtonText() {
        if (this.buttonText) this.buttonText.textContent = this.defaultButtonText;
      }
      lockSuccess() {
        this.successLocked = true;
        if (this.input) this.input.disabled = true;
        if (this.checkbox) this.checkbox.disabled = true;
        if (this.button) this.button.disabled = true;
        if (this.buttonText)
          this.buttonText.textContent = this.getAttribute('finished-button-text') || this.defaultButtonText;
      }
      hideMessages() {
        if (this.successLocked) return;
        this.classList.remove('is-error');
        this.clearInvalidFields();
        if (this.message) {
          this.message.hidden = true;
          this.message.textContent = '';
        }
      }
      clearInvalidFields() {
        this.input?.setAttribute('aria-invalid', 'false');
        this.checkbox?.setAttribute('aria-invalid', 'false');
      }
      showError(message, field) {
        this.classList.add('is-error');
        this.clearInvalidFields();
        if (field === 'email') this.input?.setAttribute('aria-invalid', 'true');
        if (field === 'agreement') this.checkbox?.setAttribute('aria-invalid', 'true');
        if (this.message) {
          this.message.textContent = message || this.getAttribute('error-message') || '';
          this.message.hidden = false;
          this.message.setAttribute('role', 'alert');
          this.message.setAttribute('aria-live', 'assertive');
        }
        const target = field === 'email' ? this.input : field === 'agreement' ? this.checkbox : this.message;
        target?.focus({ preventScroll: true });
      }
      showSuccess() {
        this.classList.add('is-success');
        this.classList.remove('is-error');
        this.clearInvalidFields();
        if (this.message) {
          this.message.hidden = true;
          this.message.textContent = '';
        }
        if (this.success) {
          this.success.hidden = false;
          this.success.focus({ preventScroll: true });
        }
      }
      parseError(message) {
        const fallback = this.getAttribute('error-message') || 'Subscription failed. Please try again.';
        const already = this.getAttribute('email-already-registered-message') || 'This email is already registered.';
        const invalid = this.getAttribute('email-invalid-message') || 'This email is invalid.';
        const raw = message || fallback;
        if (window.$klaviyo?.parseErrorMessage)
          return window.$klaviyo.parseErrorMessage(
            { message: raw },
            {
              alreadyRegistered: already,
              invalid,
              default: fallback,
            }
          );
        const lower = String(raw).toLowerCase();
        if (lower.includes('already') || lower.includes('exists')) return already;
        if (lower.includes('invalid')) return invalid;
        return raw;
      }
      getKlaviyoApi(generation) {
        if (window.$klaviyo?.subscribe && window.$klaviyo?.validateEmail) return Promise.resolve(window.$klaviyo);
        this.cancelKlaviyoWait();
        return new Promise((resolve) => {
          const ready = () => finish(this.isCurrent(generation) ? window.$klaviyo : null);
          const finish = (api) => {
            if (!this.klaviyoWait) return;
            clearTimeout(this.klaviyoWait.timeout);
            window.removeEventListener('ndev:klaviyo-api-ready', ready);
            this.klaviyoWait = null;
            resolve(api);
          };
          const timeout = setTimeout(() => finish(null), 10000);
          this.klaviyoWait = { timeout, ready, resolve };
          window.addEventListener('ndev:klaviyo-api-ready', ready);
        });
      }
      cancelKlaviyoWait() {
        if (!this.klaviyoWait) return;
        const wait = this.klaviyoWait;
        clearTimeout(wait.timeout);
        window.removeEventListener('ndev:klaviyo-api-ready', wait.ready);
        this.klaviyoWait = null;
        wait.resolve(null);
      }
      openSuccessDialog(generation) {
        const modal = this.successDialog;
        if (!modal) return;
        const open = () => {
          if (!this.isCurrent(generation) || typeof modal.open !== 'function') return;
          modal.open();
          window.requestAnimationFrame(() => {
            if (this.isCurrent(generation)) this.dialogTitle?.focus({ preventScroll: true });
          });
        };
        if (typeof modal.open === 'function') {
          open();
          return;
        }
        if (window.customElements && customElements.whenDefined) {
          customElements.whenDefined('ndev-modal').then(open).catch(() => {});
        }
      }
    }

    customElements.define('ndev-page-banner-subscribe', PageBannerSubscribe);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-accessories')) {
    class ProductBuyBoxAccessories extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._selected = {};

        this._onRootVariantChange = (e) => {
          if (e.detail.available) {
            this._restoreCards();
          } else {
            this._disableAllCards();
          }
        };

        this._onCheckboxChange = (e) => {
          const detail = e.detail || {};
          const target = detail.element || e.target;
          const card = target.closest('.product-buy-box-accessories__card');
          if (!card || !this.contains(card)) return;
          this._handleCheckbox(card, target.checked);
        };

        this._onQuantityChange = (e) => {
          const detail = e.detail || {};
          const el = detail.selector || e.target;
          const card = el.closest('.product-buy-box-accessories__card');
          if (!card || !this.contains(card)) return;
          if (detail.newQuantity !== undefined) {
            this._handleQuantity(card, detail.newQuantity);
          }
        };

        this._onCardClick = (e) => {
          const card = e.target.closest('.product-buy-box-accessories__card');
          if (!card || !this.contains(card)) return;
          if (card.classList.contains('is-disabled')) return;
          if (e.target.closest('.ndev-checkbox-wrapper')) return;
          if (e.target.closest('.ndev-quantity-selector')) return;

          const chk = card.querySelector('.ndev-checkbox-input');
          if (chk && !chk.disabled) {
            chk.checked = !chk.checked;
            chk.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };

        this.addEventListener('click', this._onCardClick);
        this.addEventListener('checkbox:change', this._onCheckboxChange);
        this.addEventListener('quantity:change', this._onQuantityChange);
        this._root?.addEventListener('product-buy-box:variant-change', this._onRootVariantChange);

        const rootAvailable = this.getAttribute('data-root-variant-available');
        if (rootAvailable === 'false') {
          this._disableAllCards();
        }

        this._emitSourceChange();
      }

      dispose() {
        this.removeEventListener('click', this._onCardClick);
        this.removeEventListener('checkbox:change', this._onCheckboxChange);
        this.removeEventListener('quantity:change', this._onQuantityChange);
        this._root?.removeEventListener('product-buy-box:variant-change', this._onRootVariantChange);
      }

      _disableAllCards() {
        const cards = this.querySelectorAll('.product-buy-box-accessories__card');
        for (let i = 0; i < cards.length; i++) {
          const card = cards[i];
          card.classList.add('is-disabled');
          card.classList.remove('is-selected');
          const chk = card.querySelector('.ndev-checkbox-input');
          if (chk) {
            chk.checked = false;
            chk.disabled = true;
          }
          this._setCheckboxDisabled(card, true);
          this._setQuantityValue(card, 0);
          this._setQuantityDisabled(card, true);
        }
        this._selected = {};
        this._emitSourceChange();
      }

      _restoreCards() {
        const cards = this.querySelectorAll('.product-buy-box-accessories__card');
        for (let i = 0; i < cards.length; i++) {
          const card = cards[i];
          const cardAvailable = card.getAttribute('data-available');
          if (cardAvailable !== 'false') {
            card.classList.remove('is-disabled');
            const chk = card.querySelector('.ndev-checkbox-input');
            if (chk) chk.disabled = false;
            this._setCheckboxDisabled(card, false);
            this._setQuantityDisabled(card, false);
          } else {
            card.classList.add('is-disabled');
            card.classList.remove('is-selected');
            const chk = card.querySelector('.ndev-checkbox-input');
            if (chk) {
              chk.checked = false;
              chk.disabled = true;
            }
            this._setCheckboxDisabled(card, true);
            this._setQuantityValue(card, 0);
            this._setQuantityDisabled(card, true);
          }
        }
      }

      _setCheckboxDisabled(card, disabled) {
        const wrapper = card.querySelector('.ndev-checkbox-wrapper');
        if (wrapper) wrapper.classList.toggle('is-disabled', disabled);
      }

      _setQuantityDisabled(card, disabled) {
        const qty = card.querySelector('.ndev-quantity-selector');
        if (!qty) return;
        const input = qty.querySelector('.ndev-quantity-selector__input');
        const buttons = qty.querySelectorAll('.ndev-quantity-selector__btn');
        if (input) input.disabled = disabled;
        buttons.forEach((btn) => {
          btn.disabled = disabled || this._isQuantityButtonAtLimit(qty, btn);
        });
      }

      _setQuantityValue(card, value) {
        const qty = card.querySelector('.ndev-quantity-selector');
        if (!qty) return;
        const input = qty.querySelector('.ndev-quantity-selector__input');
        if (!input) return;
        input.value = value;
        input.defaultValue = value;
        this._syncQuantityButtons(qty);
      }

      _syncQuantityButtons(qty) {
        const buttons = qty.querySelectorAll('.ndev-quantity-selector__btn');
        buttons.forEach((btn) => {
          btn.disabled = this._isQuantityButtonAtLimit(qty, btn);
        });
      }

      _isQuantityButtonAtLimit(qty, btn) {
        const input = qty.querySelector('.ndev-quantity-selector__input');
        if (!input) return false;
        const value = parseInt(input.value, 10) || 0;
        const min = parseInt(qty.getAttribute('data-min'), 10);
        const max = parseInt(qty.getAttribute('data-max'), 10);
        if (btn.getAttribute('data-action') === 'decrease') {
          return !isNaN(min) && value <= min;
        }
        return !isNaN(max) && value >= max;
      }

      _handleCheckbox(card, checked) {
        if (card.classList.contains('is-disabled')) return;
        const variantId = card.getAttribute('data-variant-id');
        const price = parseInt(card.getAttribute('data-price')) || 0;

        if (checked) {
          const qtyInput = card.querySelector('.ndev-quantity-selector__input');
          let qty = qtyInput ? (parseInt(qtyInput.value) || 0) : 1;
          if (qty <= 0) {
            qty = 1;
            this._setQuantityValue(card, qty);
          }
          this._selected[variantId] = { variantId, price, quantity: qty };
          card.classList.add('is-selected');
        } else {
          this._setQuantityValue(card, 0);
          delete this._selected[variantId];
          card.classList.remove('is-selected');
        }
        this._emitSourceChange();
      }

      _handleQuantity(card, qty) {
        if (card.classList.contains('is-disabled')) return;
        const variantId = card.getAttribute('data-variant-id');
        const price = parseInt(card.getAttribute('data-price')) || 0;
        const chk = card.querySelector('.ndev-checkbox-input');

        if (qty > 0) {
          this._selected[variantId] = { variantId, price, quantity: qty };
          card.classList.add('is-selected');
          if (chk && !chk.checked) {
            chk.checked = true;
          }
        } else {
          delete this._selected[variantId];
          card.classList.remove('is-selected');
          if (chk && chk.checked) {
            chk.checked = false;
          }
        }
        this._emitSourceChange();
      }

      _emitSourceChange() {
        let total = 0;
        const items = [];
        const variantIds = Object.keys(this._selected);
        for (let i = 0; i < variantIds.length; i++) {
          const s = this._selected[variantIds[i]];
          total += s.price * s.quantity;
          items.push({
            variantId: s.variantId,
            quantity: s.quantity,
            properties: {}
          });
        }

        if (!this._root) return;
        this._root.dispatchEvent(new CustomEvent('product-buy-box:source-change', {
          bubbles: true,
          composed: true,
          detail: {
            source: 'accessories',
            total,
            items
          }
        }));
      }
    }
    customElements.define('product-buy-box-accessories', ProductBuyBoxAccessories);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-buy-buttons')) {
    class ProductBuyBoxBuyButtons extends BaseElement {
      init() {
        this._available = this.getAttribute('initial-available') === 'true';
        this._root = this.closest('product-buy-box');
        this._itemsEl = this.querySelector('.product-buy-box-buy-buttons__items');

        this._onVariantChange = (e) => {
          this._available = e.detail.available;
          this._renderState();
        };

        this._onKlaviyoClick = (e) => {
          const klaviyoEl = e.target.closest('[data-cta-klaviyo]');
          if (!klaviyoEl || this._available) return;
          e.preventDefault();
          e.stopPropagation();
          const eventName = klaviyoEl.getAttribute('data-cta-klaviyo-event');
          if (eventName && typeof $narwal !== 'undefined') {
            $narwal.emit(eventName);
          }
        };

        this._onCartCapture = (e) => {
          const button = e.target.closest('.ndev-button__btn[data-btn-purpose="cart"]');
          if (!button) return;

          const root = this._root;
          const cartItems = root && typeof root.getCartItems === 'function' ? root.getCartItems() : null;
          if (!cartItems || !cartItems.length) return;

          e.preventDefault();
          e.stopPropagation();

          const buyNow = button.getAttribute('data-cart-buy-now') === 'true';
          if (typeof $360 !== 'undefined' && typeof $360.addToCartMultiple === 'function') {
            if (cartItems.length > 1) {
              $360.addToCartMultiple({
                products: cartItems,
                button
              }, null, buyNow);
            } else if (typeof $360.addToCart === 'function') {
              const item = cartItems[0];
              $360.addToCart({
                qty: item.qty || 1,
                variantId: item.varId,
                properties: item.properties,
                sellingPlan: item.sellingPlan,
                button
              }, null, e, buyNow);
            }
          }
        };

        this._root?.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.addEventListener('click', this._onKlaviyoClick, true);
        this.addEventListener('click', this._onCartCapture, true);

        this._sortItems();
        this._renderState();
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.removeEventListener('click', this._onKlaviyoClick, true);
        this.removeEventListener('click', this._onCartCapture, true);
      }

      _sortItems() {
        if (!this._itemsEl) return;
        const items = [...this._itemsEl.children];
        items.sort(function (a, b) {
          const aOrder = parseInt(a.getAttribute('data-cta-order')) || 9999;
          const bOrder = parseInt(b.getAttribute('data-cta-order')) || 9999;
          return aOrder - bOrder;
        });
        items.forEach(function (item) {
          this._itemsEl.appendChild(item);
        }.bind(this));
      }

      _renderState() {
        if (!this._itemsEl) return;
        const wrappers = this._itemsEl.querySelectorAll('[data-cta-show-when]');
        wrappers.forEach(function (wrapper) {
          const showWhen = wrapper.getAttribute('data-cta-show-when');
          if (showWhen === 'available') {
            wrapper.hidden = !this._available;
          } else if (showWhen === 'unavailable') {
            wrapper.hidden = this._available;
          }
        }.bind(this));
      }
    }

    customElements.define('product-buy-box-buy-buttons', ProductBuyBoxBuyButtons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-description')) {
    class ProductBuyBoxDescription extends BaseElement {
      init() {
        this._btn = this.querySelector('.product-buy-box-description__toggle');
        this._onClick = () => this._toggle();
        this._btn?.addEventListener('click', this._onClick);
      }

      dispose() {
        this._btn?.removeEventListener('click', this._onClick);
      }

      _toggle() {
        const isExpanded = this.classList.toggle('is-expanded');
        this._btn?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }
    }
    customElements.define('product-buy-box-description', ProductBuyBoxDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-early-bird"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-early-bird')) {
    class ProductBuyBoxEarlyBird extends BaseElement {
      init() {
        this._onCountdownExpired = () => this._syncExpiredState();
        this.addEventListener('ndev:countdown-expired', this._onCountdownExpired);
        this._syncExpiredState();
      }

      dispose() {
        this.removeEventListener('ndev:countdown-expired', this._onCountdownExpired);
      }

      _syncExpiredState() {
        if (this.getAttribute('hide-on-expire') !== 'true') return;
        const countdown = this.querySelector('.ndev-countdown-timer');
        if (!countdown || !countdown.hasAttribute('expired')) return;

        this.classList.add('is-hidden');
        this.setAttribute('hidden', '');
        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('inert', '');
      }
    }

    customElements.define('product-buy-box-early-bird', ProductBuyBoxEarlyBird);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-feature-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-feature-item')) {
    class ProductBuyBoxFeatureItem extends BaseElement {
      init() {
        this._trigger = this.querySelector('.product-buy-box-feature-item__trigger');
        this._overlay = this.querySelector('.product-buy-box-feature-item__overlay');
        this._modal = this.querySelector('.product-buy-box-feature-item__modal');
        this._closeButton = this.querySelector('.product-buy-box-feature-item__close');

        this._onTriggerClick = () => this.open();
        this._onTriggerKeydown = (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.open();
          }
        };
        this._onCloseClick = () => this.close();
        this._onKeydown = (event) => {
          if (!this.classList.contains('is-modal-open')) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }

          if (event.key !== 'Tab' || !this._modal) return;

          const focusable = this._focusableElements();
          if (!focusable.length) {
            event.preventDefault();
            this._modal.focus({ preventScroll: true });
            return;
          }

          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (document.activeElement === this._modal) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus({ preventScroll: true });
          } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus({ preventScroll: true });
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus({ preventScroll: true });
          }
        };

        if (this._trigger && this._modal) {
          this._trigger.addEventListener('click', this._onTriggerClick);
          this._trigger.addEventListener('keydown', this._onTriggerKeydown);
        }
        if (this._overlay) this._overlay.addEventListener('click', this._onCloseClick);
        if (this._closeButton) this._closeButton.addEventListener('click', this._onCloseClick);
        document.addEventListener('keydown', this._onKeydown);
      }

      dispose() {
        if (this._trigger) {
          this._trigger.removeEventListener('click', this._onTriggerClick);
          this._trigger.removeEventListener('keydown', this._onTriggerKeydown);
        }
        if (this._overlay) this._overlay.removeEventListener('click', this._onCloseClick);
        if (this._closeButton) this._closeButton.removeEventListener('click', this._onCloseClick);
        document.removeEventListener('keydown', this._onKeydown);
      }

      open() {
        document.querySelectorAll('product-buy-box-feature-item.is-modal-open').forEach((item) => {
          if (item !== this && typeof item.close === 'function') item.close();
        });

        this._previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.classList.add('is-modal-open');
        if (this._modal) this._modal.focus({ preventScroll: true });
      }

      close() {
        this.classList.remove('is-modal-open');
        document.body.style.overflow = this._previousOverflow || '';
        if (this._trigger) this._trigger.focus({ preventScroll: true });
      }

      _focusableElements() {
        if (!this._modal) return [];
        return [...this._modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((el) => el.offsetParent !== null);
      }
    }

    customElements.define('product-buy-box-feature-item', ProductBuyBoxFeatureItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-feature-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-feature-list')) {
    class ProductBuyBoxFeatureList extends BaseElement {
      init() {
        this._items = Array.from(this.querySelectorAll('product-buy-box-feature-item'));
        this._actions = this.querySelector('.product-buy-box-feature-list__actions');
        this._moreButton = this.querySelector('.product-buy-box-feature-list__toggle--more');
        this._hideButton = this.querySelector('.product-buy-box-feature-list__toggle--hide');
        this._collapsedCount = parseInt(this.getAttribute('data-collapsed-count'), 10) || 4;

        this._onMoreClick = () => this.expand();
        this._onHideClick = () => this.collapse();

        if (this._moreButton) this._moreButton.addEventListener('click', this._onMoreClick);
        if (this._hideButton) this._hideButton.addEventListener('click', this._onHideClick);

        this._refresh();
      }

      dispose() {
        if (this._moreButton) this._moreButton.removeEventListener('click', this._onMoreClick);
        if (this._hideButton) this._hideButton.removeEventListener('click', this._onHideClick);
      }

      _refresh() {
        const shouldCollapse = this._items.length > this._collapsedCount;
        this.classList.toggle('is-collapsible', shouldCollapse);
        if (this._actions) this._actions.hidden = !shouldCollapse;

        this._items.forEach((item, index) => {
          item.classList.toggle('is-collapsed', shouldCollapse && index >= this._collapsedCount);
        });
      }

      expand() {
        this.classList.add('is-expanded');
        this._setExpandedState(true);
        if (this._hideButton) this._hideButton.hidden = false;
      }

      collapse() {
        this.classList.remove('is-expanded');
        this._setExpandedState(false);
        if (this._hideButton) this._hideButton.hidden = true;
        if (window.matchMedia('(max-width: 1023px)').matches) {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
        }
      }

      _setExpandedState(isExpanded) {
        const value = isExpanded ? 'true' : 'false';
        if (this._moreButton) this._moreButton.setAttribute('aria-expanded', value);
        if (this._hideButton) this._hideButton.setAttribute('aria-expanded', value);
      }
    }

    customElements.define('product-buy-box-feature-list', ProductBuyBoxFeatureList);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-final-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-final-price')) {
    class ProductBuyBoxFinalPrice extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._amountEl = this.querySelector('[data-price-amount]');
        this._onTotalUpdate = (e) => this._updatePrice(e.detail);
        this._root?.addEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      _formatMoney(cents) {
        return $360.formatMoney(cents);
      }

      _updatePrice(detail) {
        if (!this._amountEl || !detail || detail.totalPrice == null) return;
        this._amountEl.textContent = this._formatMoney(detail.totalPrice);
      }
    }
    customElements.define('product-buy-box-final-price', ProductBuyBoxFinalPrice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-price')) {
    class ProductBuyBoxPrice extends BaseElement {
      init() {
        this._onVariantChange = (e) => this._update(e.detail);
        this.closest('product-buy-box')?.addEventListener('product-buy-box:variant-change', this._onVariantChange);
      }

      dispose() {
        this.closest('product-buy-box')?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
      }

      _formatMoney(cents) {
        return $360.formatMoney(cents);
      }

      _setTextContent(el, value) {
        if (!el) return;
        el.querySelectorAll('.ndev-text__content').forEach((node) => {
          node.textContent = value;
        });
      }

      _resolvePriceNodes(container) {
        return {
          sale: container.querySelector('.ndev-price__sale'),
          compare: container.querySelector('.ndev-price__compare'),
          discount: container.querySelector('.ndev-price__discount')
        };
      }

      _update(detail) {
        const price = detail.price;
        const compare = detail.compareAtPrice || 0;
        const container = this.querySelector('.ndev-price__container');
        if (!container) return;

        const nodes = this._resolvePriceNodes(container);
        const hasCompare = compare > price;

        if (nodes.sale) {
          this._setTextContent(nodes.sale, this._formatMoney(price));
        }

        if (nodes.compare) {
          if (hasCompare) {
            nodes.compare.hidden = false;
            this._setTextContent(nodes.compare, this._formatMoney(compare));
          } else {
            nodes.compare.hidden = true;
          }
        }

        if (nodes.discount) {
          if (hasCompare) {
            nodes.discount.hidden = false;
            const diff = compare - price;
            const discountText = this._formatMoney(diff).replace(/\.00$/, '');
            nodes.discount.querySelectorAll('.ndev-product-tag__text').forEach((node) => {
              node.textContent = discountText;
            });
          } else {
            nodes.discount.hidden = true;
          }
        }

        const root = this.closest('product-buy-box');
        if (root) {
          root.dispatchEvent(new CustomEvent('ndev-standard-installment:price-change', {
            bubbles: true,
            detail: { price: price }
          }));
        }
      }
    }
    customElements.define('product-buy-box-price', ProductBuyBoxPrice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-media-gallery')) {
    class ProductBuyBoxMediaGallery extends BaseElement {
      init() {
        this._mapEl = this.querySelector('[data-product-buy-box-media-map]');
        this._mediaMap = this._mapEl ? JSON.parse(this._mapEl.textContent) : {};
        this._featuredMediaEl = this.querySelector('[data-product-buy-box-variant-featured-media]');
        this._featuredMediaByVariant = this._featuredMediaEl ? JSON.parse(this._featuredMediaEl.textContent) : {};
        this._variantGroupEl = this.querySelector('[data-product-buy-box-variant-group]');
        this._variantGroupByVariant = this._variantGroupEl ? JSON.parse(this._variantGroupEl.textContent) : {};
        this._swiperEls = [...this.querySelectorAll('.product-buy-box-media-gallery__swiper')];
        this._swiperEl = this.querySelector('.product-buy-box-media-gallery__swiper--image');
        this._mediaEls = [...this.querySelectorAll('[media-category]')];
        this._categoryButtons = [...this.querySelectorAll('[media-category-trigger]')];
        this._swipers = {};
        this._zoomLens = this.querySelector('.product-buy-box-media-gallery__zoom-lens');
        this._zoomLensArea = this.querySelector('.product-buy-box-media-gallery__zoom-lens-area');
        this._zoomImage = this.querySelector('.product-buy-box-media-gallery__zoom-image');
        this._zoomPanel = this.querySelector('.product-buy-box-media-gallery__zoom-panel');
        this._paginationEl = this.querySelector('.product-buy-box-media-gallery__pagination');
        this._hasGrouping = this.getAttribute('has-grouping') === 'true';
        this._groupOptionIndex = this._hasGrouping ? Number(this.getAttribute('group-option-index')) || 0 : -1;
        this._activeOptionValue = this._hasGrouping ? this.getAttribute('initial-option-value') || '' : '';
        if (this._hasGrouping) {
          this._swiperEl = this.querySelector(
            '.product-buy-box-media-gallery__swiper[data-category="' + this._activeOptionValue + ':image"]'
          );
          this._thumbs = [
            ...this.querySelectorAll(
              '.product-buy-box-media-gallery__pagination-track[data-option-value="' +
                this._activeOptionValue +
                '"] .product-buy-box-media-gallery__pagination-item'
            ),
          ];
          this._slides = this._swiperEl
            ? [...this._swiperEl.querySelectorAll('.product-buy-box-media-gallery__slide')]
            : [];
          this._setZoomLens(this._swiperEl);
        } else {
          this._thumbs = [...this.querySelectorAll('.product-buy-box-media-gallery__pagination-item')];
          this._slides = this._swiperEl
            ? [...this._swiperEl.querySelectorAll('.product-buy-box-media-gallery__slide')]
            : [];
        }
        this._initialSlide = Number(this.getAttribute('initial-slide')) || 0;
        this._initialVariantId = Number(this.getAttribute('initial-variant-id')) || null;
        this._activeVariantId = this._initialVariantId;
        this._activeCategory = this.getAttribute('active-category') || 'image';
        this._isDragging = false;
        this._hoverZoomEnabled = this.getAttribute('hover-zoom-enabled') === 'true';
        this._clickPreviewEnabled = this.getAttribute('click-preview-enabled') === 'true';
        this._discountBadgeMode = this.getAttribute('discount-badge-mode') || 'savings';
        this._canHoverZoom = window.matchMedia('(min-width: 1024px)');

        this._onVariantChange = (e) => {
          this._activeVariantId = e.detail.variantId;
          if (this._hasGrouping) {
            this._handleGroupedVariantChange(e.detail);
          } else {
            this._goToVariantImage(e.detail);
          }
        };
        this.closest('product-buy-box')?.addEventListener('product-buy-box:variant-change', this._onVariantChange);

        this._bindThumbnails();
        this._bindCategoryControls();
        this._bindNavControls();
        this._bindClickPreview();
        this._initPaginationDrag();
        this._initHoverZoom();
        this._initSwiper();
        this._syncCategoryAvailability();
      }

      dispose() {
        clearInterval(this._swiperWait);
        this.closest('product-buy-box')?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this._thumbs.forEach((thumb) => thumb.removeEventListener('click', thumb._pbbClick));
        if (this._paginationEl) {
          this._paginationEl.removeEventListener('mousedown', this._onPaginationDragStart);
          this._paginationEl.removeEventListener('mousemove', this._onPaginationDragMove);
          this._paginationEl.removeEventListener('mouseup', this._onPaginationDragEnd);
          this._paginationEl.removeEventListener('mouseleave', this._onPaginationDragEnd);
        }
        this._unbindImageSwiperEvents(this._swiperEl);
        this._categoryButtons.forEach((button) => button.removeEventListener('click', button._pbbClick));
        this.querySelector('.product-buy-box-media-gallery__nav--prev')?.removeEventListener(
          'click',
          this._onPrevClick
        );
        this.querySelector('.product-buy-box-media-gallery__nav--next')?.removeEventListener(
          'click',
          this._onNextClick
        );
        Object.values(this._swipers).forEach((swiper) => {
          swiper.destroy(true, true);
        });
        this._swipers = {};
        this._swiper = null;
        this._swiperEls.forEach((swiperEl) => {
          if (swiperEl?.swiper) swiperEl.swiper = null;
        });
      }

      _unbindImageSwiperEvents(el) {
        if (!el) return;
        el.removeEventListener('mouseenter', this._onZoomEnter);
        el.removeEventListener('mousemove', this._onZoomMove);
        el.removeEventListener('mouseleave', this._onZoomLeave);
        el.removeEventListener('pointerdown', this._onPreviewPointerDown);
        el.removeEventListener('click', this._onPreviewClick);
      }

      _setZoomLens(swiperEl) {
        this._zoomLens = swiperEl?.querySelector('.product-buy-box-media-gallery__zoom-lens') || null;
        this._zoomLensArea = swiperEl?.querySelector('.product-buy-box-media-gallery__zoom-lens-area') || null;
      }

      _bindCategoryControls() {
        this._categoryButtons.forEach((button) => {
          button._pbbClick = () => this._setActiveCategory(button.getAttribute('media-category-trigger'));
          button.addEventListener('click', button._pbbClick);
        });
      }

      _bindNavControls() {
        this.querySelector('.product-buy-box-media-gallery__nav--prev')?.addEventListener('click', this._onPrevClick);
        this.querySelector('.product-buy-box-media-gallery__nav--next')?.addEventListener('click', this._onNextClick);
      }

      _bindClickPreview() {
        if (!this._clickPreviewEnabled || !this._swiperEl) return;
        this.classList.add('product-buy-box-media-gallery--click-preview');
        this._swiperEl.addEventListener('pointerdown', this._onPreviewPointerDown);
        this._swiperEl.addEventListener('click', this._onPreviewClick);
      }

      _onPrevClick = () => {
        this._getSwiper()?.slidePrev();
      };

      _onNextClick = () => {
        this._getSwiper()?.slideNext();
      };

      _onPreviewPointerDown = (e) => {
        this._previewPointer = { x: e.clientX, y: e.clientY };
      };

      _onPreviewClick = (e) => {
        if (this._activeCategory !== 'image') return;
        if (e.target.closest('.product-buy-box-media-gallery__nav')) return;
        if (this._previewPointer) {
          const dx = Math.abs(e.clientX - this._previewPointer.x);
          const dy = Math.abs(e.clientY - this._previewPointer.y);
          if (dx > 5 || dy > 5) return;
        }

        const slide = this._getZoomSlide();
        const src = slide?.getAttribute('slide-src');
        if (!src) return;

        const img = slide.querySelector('.product-buy-box-media-gallery__slide-img');
        const wrapper = document.createElement('div');
        wrapper.className = 'product-buy-box-media-gallery__preview';

        const preview = document.createElement('img');
        preview.className = 'product-buy-box-media-gallery__preview-img';
        preview.src = src;
        preview.alt = img?.getAttribute('alt') || '';
        wrapper.appendChild(preview);

        this.closest('product-buy-box')?.dispatchEvent(
          new CustomEvent('product-buy-box:media-preview-open', {
            bubbles: true,
            composed: true,
            detail: {
              content: wrapper,
            },
          })
        );
      };

      _setActiveCategory(category) {
        if (!category || category === this._activeCategory) return;
        if (!this._hasMediaForCategory(category)) return;
        this._onZoomLeave();
        this._activeCategory = category;
        this.setAttribute('active-category', category);

        this._mediaEls.forEach((el) => {
          const catMatch = el.getAttribute('media-category') === category;
          if (this._hasGrouping && el.hasAttribute('data-option-value')) {
            el.classList.toggle(
              'is-active',
              catMatch && el.getAttribute('data-option-value') === this._activeOptionValue
            );
          } else {
            el.classList.toggle('is-active', catMatch);
          }
        });
        this._categoryButtons.forEach((button) => {
          button.classList.toggle('is-active', button.getAttribute('media-category-trigger') === category);
        });

        requestAnimationFrame(() => {
          this._getSwiper(category)?.update();
        });
      }

      _hasMediaForCategory(category) {
        if (!this._hasGrouping || category === 'model') {
          return this._mediaEls.some((el) => el.getAttribute('media-category') === category);
        }
        return this._mediaEls.some(
          (el) =>
            el.getAttribute('media-category') === category &&
            el.getAttribute('data-option-value') === this._activeOptionValue
        );
      }

      _syncCategoryAvailability() {
        this._categoryButtons.forEach((button) => {
          const category = button.getAttribute('media-category-trigger');
          button.hidden = !this._hasMediaForCategory(category);
        });
        if (!this._hasMediaForCategory(this._activeCategory)) {
          this._setActiveCategory('image');
        }
      }

      _syncActiveCategoryFromMediaId(mediaId) {
        if (!mediaId) return;
        const slide = this._slides.find((item) => String(item.getAttribute('media-id')) === String(mediaId));
        if (slide) {
          this._setActiveCategory('image');
        }
      }

      _initSwiper() {
        if (!this._swiperEls.length) return;

        if (window.Swiper) {
          this._createSwipers();
          return;
        }

        let tries = 0;
        this._swiperWait = setInterval(() => {
          tries += 1;
          if (window.Swiper) {
            clearInterval(this._swiperWait);
            this._createSwipers();
          } else if (tries > 100) {
            clearInterval(this._swiperWait);
          }
        }, 50);
      }

      _createSwipers() {
        this._swiperEls.forEach((swiperEl) => this._createSwiper(swiperEl));
        if (this._hasGrouping) {
          this._swiper = this._swipers[this._activeOptionValue + ':image'] || null;
        } else {
          this._swiper = this._swipers.image || null;
        }
      }

      _createSwiper(swiperEl) {
        if (!swiperEl) return;
        const category = swiperEl.getAttribute('data-category') || 'image';
        if (this._swipers[category]) return;
        if (swiperEl.swiper) {
          this._adoptSwiper(swiperEl, category);
          return;
        }
        const root = this;
        const mediaCategory = category.split(':').pop();

        this._swipers[category] = new window.Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 1,
          initialSlide: mediaCategory === 'image' ? this._initialSlide : 0,
          observer: true,
          observeParents: true,
          noSwipingClass: 'swiper-no-swiping',
          on: {
            init(swiper) {
              if (
                mediaCategory === 'image' &&
                (!root._hasGrouping || category === root._activeOptionValue + ':image')
              ) {
                root._syncPagination(swiper.activeIndex);
                root._updateBadges();
              }
            },
            slideChange(swiper) {
              if (
                mediaCategory === 'image' &&
                (!root._hasGrouping || category === root._activeOptionValue + ':image')
              ) {
                root._syncPagination(swiper.activeIndex);
                root._updateBadges();
                root._syncZoomToActiveSlide();
                if (root.classList.contains('is-zooming') && root._lastZoomEvent) {
                  root._onZoomMove(root._lastZoomEvent);
                }
              }
            },
          },
        });
      }

      _adoptSwiper(swiperEl, category) {
        const swiper = swiperEl?.swiper;
        if (!swiper) return;

        this._swipers[category] = swiper;
        const root = this;
        const mediaCategory = category.split(':').pop();
        const isActiveImage = () =>
          mediaCategory === 'image' && (!root._hasGrouping || category === root._activeOptionValue + ':image');

        swiper.on('slideChange', () => {
          if (!isActiveImage()) return;
          root._syncPagination(swiper.activeIndex);
          root._updateBadges();
          root._syncZoomToActiveSlide();
          if (root.classList.contains('is-zooming') && root._lastZoomEvent) {
            root._onZoomMove(root._lastZoomEvent);
          }
        });

        if (isActiveImage()) {
          this._syncPagination(swiper.activeIndex);
          this._updateBadges();
        }
      }

      _getSwiper(category = this._activeCategory) {
        if (this._hasGrouping) {
          return this._swipers[this._activeOptionValue + ':' + category] || null;
        }
        return this._swipers[category] || null;
      }

      _goToSlide(index) {
        this._onZoomLeave();
        this._setActiveCategory('image');
        const swiper = this._getSwiper('image');
        if (swiper) {
          swiper.slideTo(index);
          this._syncPagination(index);
          this._updateBadges();
          return;
        }
        this._syncPagination(index);
        this._updateBadges();
      }

      _getFeaturedSlideIndex(mediaId) {
        if (!mediaId) return -1;
        return this._slides.findIndex((slide) =>
          String(slide.getAttribute('media-id')) === String(mediaId) ||
          String(slide.getAttribute('featured-media-id')) === String(mediaId)
        );
      }

      _updateBadges() {
        const badgesRoot = this.querySelector('.product-buy-box-media-gallery__badges');
        if (!badgesRoot) return;

        const swiper = this._getSwiper('image');
        const slideIndex = swiper != null ? swiper.activeIndex : this._initialSlide;
        const activeVariantId = String(this._activeVariantId || this._initialVariantId || '');
        const showSavings = this._discountBadgeMode === 'savings';
        const showOff = this._discountBadgeMode === 'off';

        badgesRoot.querySelectorAll('[data-badge-kind="savings"]').forEach((badge) => {
          const variantId = badge.getAttribute('variant-id');
          const featuredIndex = this._getFeaturedSlideIndex(badge.getAttribute('featured-media-id'));
          const show = showSavings && variantId === activeVariantId && featuredIndex >= 0 && slideIndex === featuredIndex;
          badge.hidden = !show;
        });

        badgesRoot.querySelectorAll('[data-badge-kind="off"]').forEach((badge) => {
          const variantId = badge.getAttribute('variant-id');
          const featuredMediaId = badge.getAttribute('featured-media-id');
          const featuredIndex = this._getFeaturedSlideIndex(featuredMediaId);
          const onFeaturedSlide = !featuredMediaId || featuredIndex < 0 || slideIndex === featuredIndex;
          const show = showOff && variantId === activeVariantId && onFeaturedSlide;
          badge.hidden = !show;
        });
      }

      _getFeaturedMediaIdForVariant(variantId) {
        return this._featuredMediaByVariant?.[String(variantId)] || null;
      }

      _bindThumbnails() {
        this._thumbs.forEach((thumb) => {
          thumb._pbbClick = (e) => {
            if (this._isDragging) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            this._goToSlide(Number(thumb.getAttribute('thumb-index')));
          };
          thumb.addEventListener('click', thumb._pbbClick);
        });
      }

      _syncPagination(index) {
        this._thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
        });
        this._scrollPaginationToCenter(index);
      }

      _scrollPaginationToCenter(index) {
        const container = this._paginationEl;
        const item = this._thumbs[index];
        if (!container || !item) return;

        const containerRect = container.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const offset = itemRect.left - containerRect.left - (containerRect.width - itemRect.width) / 2;
        const nextLeft = container.scrollLeft + offset;
        const maxLeft = container.scrollWidth - container.clientWidth;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        container.scrollTo({
          left: Math.max(0, Math.min(nextLeft, maxLeft)),
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      _initPaginationDrag() {
        if (!this._paginationEl) return;
        this._paginationEl.addEventListener('mousedown', this._onPaginationDragStart);
        this._paginationEl.addEventListener('mousemove', this._onPaginationDragMove);
        this._paginationEl.addEventListener('mouseup', this._onPaginationDragEnd);
        this._paginationEl.addEventListener('mouseleave', this._onPaginationDragEnd);
      }

      _initHoverZoom() {
        if (!this._hoverZoomEnabled || !this._swiperEl) return;
        this._swiperEl.addEventListener('mouseenter', this._onZoomEnter);
        this._swiperEl.addEventListener('mousemove', this._onZoomMove);
        this._swiperEl.addEventListener('mouseleave', this._onZoomLeave);
      }

      _getZoomSlide() {
        const swiper = this._getSwiper('image');
        if (swiper && this._slides[swiper.activeIndex]) {
          return this._slides[swiper.activeIndex];
        }

        return (
          this.querySelector('.swiper-slide-active.product-buy-box-media-gallery__slide') ||
          this._slides[this._initialSlide] ||
          this._slides[0] ||
          null
        );
      }

      _onZoomEnter = (e) => {
        if (!this._canHoverZoom.matches) return;
        if (!this._syncZoomToActiveSlide()) return;
        this.classList.add('is-zooming');
        this._onZoomMove(e);
      };

      _syncZoomToActiveSlide() {
        if (!this._hoverZoomEnabled || !this._zoomImage) return false;
        const slide = this._getZoomSlide();
        if (!slide) return false;

        const src = slide.getAttribute('slide-src');
        if (!src) return false;
        if (this._zoomSource !== src) {
          this._zoomSource = src;
          this._zoomImage.style.backgroundImage = `url(${src})`;
        }
        return true;
      }

      _onZoomMove = (e) => {
        if (!this.classList.contains('is-zooming')) return;
        if (!this._zoomLensArea || !this._zoomImage || !this._zoomPanel) return;
        this._lastZoomEvent = e;

        const rect = this._swiperEl.getBoundingClientRect();
        const panelSize = this._zoomPanel.offsetWidth || window.innerWidth * 0.38;
        const lensSize = Math.min(300, rect.width, rect.height);
        const scale = panelSize / lensSize;
        const lensX = Math.max(0, Math.min(e.clientX - rect.left - lensSize / 2, rect.width - lensSize));
        const lensY = Math.max(0, Math.min(e.clientY - rect.top - lensSize / 2, rect.height - lensSize));

        this._zoomLensArea.style.width = `${lensSize}px`;
        this._zoomLensArea.style.height = `${lensSize}px`;
        this._zoomLensArea.style.transform = `translate3d(${lensX}px, ${lensY}px, 0)`;
        this._zoomImage.style.width = `${rect.width * scale}px`;
        this._zoomImage.style.height = `${rect.height * scale}px`;
        this._zoomImage.style.transform = `translate3d(${-lensX * scale}px, ${-lensY * scale}px, 0)`;
      };

      _onZoomLeave = () => {
        if (this._zoomLensArea) this._zoomLensArea.style.transform = '';
        if (this._zoomImage) {
          this._zoomImage.style.backgroundImage = '';
          this._zoomImage.style.transform = '';
          this._zoomImage.style.width = '';
          this._zoomImage.style.height = '';
        }
        this._zoomSource = null;
        this._lastZoomEvent = null;
        this.classList.remove('is-zooming');
      };

      _onPaginationDragStart = (e) => {
        this._startX = e.pageX - this._paginationEl.offsetLeft;
        this._scrollLeftStart = this._paginationEl.scrollLeft;
        this._isDragging = false;
        this._isMouseDown = true;
        this._paginationEl.classList.add('is-dragging');
      };

      _onPaginationDragMove = (e) => {
        if (!this._isMouseDown) return;
        e.preventDefault();
        const x = e.pageX - this._paginationEl.offsetLeft;
        const walk = (x - this._startX) * 1.5;
        if (Math.abs(walk) > 5) {
          this._isDragging = true;
        }
        this._paginationEl.scrollLeft = this._scrollLeftStart - walk;
      };

      _onPaginationDragEnd = () => {
        this._isMouseDown = false;
        if (this._paginationEl) {
          this._paginationEl.classList.remove('is-dragging');
        }
        setTimeout(() => {
          this._isDragging = false;
        }, 50);
      };

      _normalizeSrc(src) {
        if (!src) return '';
        return src.split('?')[0];
      }

      _findSlideIndexBySrc(src) {
        const target = this._normalizeSrc(src);
        return this._slides.findIndex((slide) => this._normalizeSrc(slide.getAttribute('slide-src')) === target);
      }

      _goToVariantImage(detail) {
        const src = detail.image || this._mediaMap[String(detail.variantId)];
        let index = -1;

        if (src) {
          index = this._findSlideIndexBySrc(src);
        }

        if (index < 0 && detail.variantId) {
          const mediaId = this._getFeaturedMediaIdForVariant(detail.variantId);
          index = this._getFeaturedSlideIndex(mediaId);
        }

        if (index < 0) return;

        const swiper = this._getSwiper('image');
        if (swiper && swiper.activeIndex === index) {
          this._updateBadges();
          return;
        }

        this._goToSlide(index);
      }

      _handleGroupedVariantChange(detail) {
        const variantId = String(detail.variantId);
        const optionHandle = this._getVariantOptionValue(variantId);
        if (!optionHandle) {
          this._goToVariantImage(detail);
          return;
        }
        if (optionHandle !== this._activeOptionValue) {
          this._switchOptionGroup(optionHandle);
        }
        this._goToVariantImage(detail);
      }

      _getVariantOptionValue(variantId) {
        return this._variantGroupByVariant?.[String(variantId)] || null;
      }

      _switchOptionGroup(optionHandle) {
        this._onZoomLeave();
        const prevOptionValue = this._activeOptionValue;

        if (prevOptionValue) {
          const prevSwiperEl = this.querySelector(
            '.product-buy-box-media-gallery__swiper[data-category="' + prevOptionValue + ':image"]'
          );
          this._unbindImageSwiperEvents(prevSwiperEl);
        }

        this._activeOptionValue = optionHandle;
        this._syncCategoryAvailability();

        this._mediaEls.forEach((el) => {
          if (el.hasAttribute('data-option-value')) {
            const match = el.getAttribute('data-option-value') === optionHandle;
            el.classList.toggle('is-active', match && el.getAttribute('media-category') === this._activeCategory);
          }
        });

        if (this._paginationEl) {
          this._paginationEl
            .querySelectorAll('.product-buy-box-media-gallery__pagination-track[data-option-value]')
            .forEach((track) => {
              const match = track.getAttribute('data-option-value') === optionHandle;
              track.toggleAttribute('hidden', !match);
              track.classList.toggle('is-active', match);
            });
        }

        this._swiperEl = this.querySelector(
          '.product-buy-box-media-gallery__swiper[data-category="' + optionHandle + ':image"]'
        );
        this._slides = this._swiperEl
          ? [...this._swiperEl.querySelectorAll('.product-buy-box-media-gallery__slide')]
          : [];
        this._swiper = this._swipers[optionHandle + ':image'] || null;
        this._setZoomLens(this._swiperEl);

        this._thumbs.forEach((thumb) => thumb.removeEventListener('click', thumb._pbbClick));
        this._thumbs = [
          ...this.querySelectorAll(
            '.product-buy-box-media-gallery__pagination-track[data-option-value="' +
              optionHandle +
              '"] .product-buy-box-media-gallery__pagination-item'
          ),
        ];
        this._bindThumbnails();

        if (this._hoverZoomEnabled && this._swiperEl) {
          this._swiperEl.addEventListener('mouseenter', this._onZoomEnter);
          this._swiperEl.addEventListener('mousemove', this._onZoomMove);
          this._swiperEl.addEventListener('mouseleave', this._onZoomLeave);
        }
        if (this._clickPreviewEnabled && this._swiperEl) {
          this._swiperEl.addEventListener('pointerdown', this._onPreviewPointerDown);
          this._swiperEl.addEventListener('click', this._onPreviewClick);
        }

        requestAnimationFrame(() => {
          const swiper = this._getSwiper('image');
          if (swiper) {
            swiper.update();
            this._syncPagination(swiper.activeIndex);
          }
        });
      }
    }

    customElements.define('product-buy-box-media-gallery', ProductBuyBoxMediaGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-promo-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-promo-countdown')) {
    class ProductBuyBoxPromoCountdown extends BaseElement {
      init() {
        clearInterval(this._interval);
        this._cacheElements();
        this._lastAccessibleLabel = '';
        this._root = this.closest('product-buy-box');
        this._hydratedAt = this._hydratedAt || performance.now();

        this._root?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        document.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this._onVariantChange = (e) => this._handleVariantChange(e.detail);
        this._root?.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        if (!this._root) {
          document.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        }

        const initialRemaining = this._readRemaining();
        if (initialRemaining <= 0) {
          this._expire();
          return;
        }

        this._startTime = performance.now();
        this._initialRemaining = initialRemaining;
        this.removeAttribute('hidden');
        this._setExpired(false);
        this._tick();
        this._interval = setInterval(() => this._tick(), 200);
      }

      dispose() {
        clearInterval(this._interval);
        this._root?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        document.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this._daysEl = this._hoursEl = this._minutesEl = this._secondsEl = this._els = null;
      }

      _cacheElements() {
        this._daysEl = this.querySelector('[data-unit="days"] .pbb-promo-countdown__num-current');
        this._hoursEl = this.querySelector('[data-unit="hours"] .pbb-promo-countdown__num-current');
        this._minutesEl = this.querySelector('[data-unit="minutes"] .pbb-promo-countdown__num-current');
        this._secondsEl = this.querySelector('[data-unit="seconds"] .pbb-promo-countdown__num-current');
        this._els = { days: this._daysEl, hours: this._hoursEl, minutes: this._minutesEl, seconds: this._secondsEl };
      }

      _readRemaining() {
        const value = Number.parseInt(this.getAttribute('remaining') || '0', 10);
        return Number.isFinite(value) ? value : 0;
      }

      _handleVariantChange(detail) {
        const promo = detail?.promo || {};
        const remaining = promo.countdown ? this._getAdjustedRemaining(promo.countdownRemaining) : 0;
        const formatted = String(remaining);

        if (this.getAttribute('remaining') === formatted) {
          this.dispose();
          this.init();
          return;
        }

        this.setAttribute('remaining', formatted);
      }

      _getAdjustedRemaining(remaining) {
        const seconds = Number(remaining || 0);
        if (!seconds) return 0;

        const elapsed = Math.floor((performance.now() - this._hydratedAt) / 1000);
        return Math.max(0, seconds - elapsed);
      }

      _tick() {
        const elapsed = (performance.now() - this._startTime) / 1000;
        const remaining = Math.max(0, this._initialRemaining - elapsed);

        if (remaining <= 0) {
          this._expire();
          return;
        }

        const days = Math.floor(remaining / 86400);
        const hours = Math.floor((remaining % 86400) / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = Math.floor(remaining % 60);

        this._maybeUpdate('days', days);
        this._maybeUpdate('hours', hours);
        this._maybeUpdate('minutes', minutes);
        this._maybeUpdate('seconds', seconds);
        this._updateAccessibleLabel(days, hours, minutes, seconds);
      }

      _expire() {
        clearInterval(this._interval);
        this._setAll(0);
        this.setAttribute('hidden', '');
        this._updateAccessibleLabel(0, 0, 0, 0);
        this._setExpired(true);
      }

      _updateAccessibleLabel(days, hours, minutes, seconds) {
        const label = [
          this.getAttribute('a11y-label') || 'Offer ends in',
          String(days).padStart(2, '0'),
          this.getAttribute('day-label') || 'Days',
          String(hours).padStart(2, '0'),
          this.getAttribute('hour-label') || 'Hours',
          String(minutes).padStart(2, '0'),
          this.getAttribute('minute-label') || 'Mins',
          String(seconds).padStart(2, '0'),
          this.getAttribute('second-label') || 'Secs'
        ].join(' ');

        if (this._lastAccessibleLabel === label) return;
        this._lastAccessibleLabel = label;
        this.setAttribute('aria-label', label);
      }

      _setExpired(isExpired) {
        if (isExpired) {
          if (this.hasAttribute('expired')) return;
          this.setAttribute('expired', '');
          this.dispatchEvent(new CustomEvent('product-buy-box:promo-countdown-expired', { bubbles: true }));
          return;
        }

        this.removeAttribute('expired');
      }

      _maybeUpdate(unit, value) {
        const el = this._els?.[unit];
        if (!el) return;

        const formatted = String(value).padStart(2, '0');
        if (el.textContent.trim() === formatted) return;

        el.classList.add('animating', 'slide-out');

        const onSlideOutEnd = () => {
          el.removeEventListener('transitionend', onSlideOutEnd);
          el.classList.remove('animating', 'slide-out');
          void el.offsetWidth;

          el.textContent = formatted;
          el.classList.add('slide-in');
          void el.offsetWidth;
          el.classList.add('animating');

          requestAnimationFrame(() => {
            el.classList.remove('slide-in');
            const onSlideInEnd = () => {
              el.removeEventListener('transitionend', onSlideInEnd);
              el.classList.remove('animating');
            };
            el.addEventListener('transitionend', onSlideInEnd);
          });
        };

        el.addEventListener('transitionend', onSlideOutEnd);
      }

      _setAll(value) {
        const formatted = String(value).padStart(2, '0');
        this.querySelectorAll('.pbb-promo-countdown__num-current').forEach((el) => {
          el.classList.remove('animating', 'slide-out', 'slide-in');
          el.textContent = formatted;
        });
      }

      static get observedAttributes() {
        return ['remaining', 'a11y-label', 'day-label', 'hour-label', 'minute-label', 'second-label'];
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue || !this.isConnected) return;

        if (name === 'remaining') {
          this.dispose();
          this.init();
          return;
        }

        this._syncAccessibleLabelFromDom();
      }

      _syncAccessibleLabelFromDom() {
        const readValue = (unit) => {
          const el = this.querySelector(`[data-unit="${unit}"] .pbb-promo-countdown__num-current`);
          const value = Number.parseInt(el ? el.textContent : '0', 10);
          return Number.isFinite(value) ? value : 0;
        };

        this._updateAccessibleLabel(
          readValue('days'),
          readValue('hours'),
          readValue('minutes'),
          readValue('seconds')
        );
      }
    }

    customElements.define('product-buy-box-promo-countdown', ProductBuyBoxPromoCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-promo')) {
    class ProductBuyBoxPromo extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');

        this._discountArea = this.querySelector('[data-promo-discount]');
        this._amountWrap = this.querySelector('[data-promo-amount-wrap]');
        this._amountEl = this.querySelector('[data-promo-amount]');
        this._codeWrap = this.querySelector('[data-promo-code-wrap]');
        this._codeEl = this.querySelector('[data-promo-code]');

        this._baseCode = this.getAttribute('base-code') || '';
        this._baseAmount = this.getAttribute('base-amount') || '';
        this._copySuccess = this.getAttribute('copy-success') || '';
        this._helpLabel = this.getAttribute('help-label') || '';

        this._copyBtn = this.querySelector('[data-promo-copy]');
        this._helpBtn = this.querySelector('[data-promo-help]');
        this._copyResetTimer = null;

        this._onVariantChange = (e) => this._handleVariantChange(e.detail);
        this._onCopyClick = () => this._handleCopy();
        this._onHelpClick = () => this._handleHelp();

        this._root?.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        if (!this._root) {
          document.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        }
        this._copyBtn?.addEventListener('click', this._onCopyClick);
        this._helpBtn?.addEventListener('click', this._onHelpClick);
      }

      dispose() {
        this._clearCopyResetTimer();
        this._root?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        document.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this._copyBtn?.removeEventListener('click', this._onCopyClick);
        this._helpBtn?.removeEventListener('click', this._onHelpClick);
        this._root = null;
      }

      _handleVariantChange(detail) {
        this._clearCopyResetTimer();
        this._renderPromo(detail?.promo || null);
      }

      _renderPromo(info) {
        if (info?.hide) {
          this._setHidden(true);
          return;
        }

        const amount = info?.discountText || this._baseAmount;
        const code = info?.code || this._baseCode;
        const hasPromoContent = Boolean(amount);

        this._setHidden(!hasPromoContent);
        if (!hasPromoContent) {
          return;
        }

        this._updateDiscount({ discountText: amount, code });
      }

      _updateDiscount(info) {
        if (!this._discountArea) return;
        const hasAmount = Boolean(info.discountText);
        const hasCode = Boolean(info.code);
        this._setElementHidden(this._discountArea, !hasAmount);
        if (this._codeWrap) this._setElementHidden(this._codeWrap, !hasCode);

        if (this._amountEl && hasAmount) {
          this._amountEl.textContent = info.discountText;
          this._amountWrap?.removeAttribute('data-empty');
        } else if (this._amountEl) {
          this._amountEl.textContent = '';
          this._amountWrap?.setAttribute('data-empty', '');
        }
        if (this._codeEl) {
          this._codeEl.textContent = info.code || '';
        }
      }

      _setHidden(hidden) {
        this._setElementHidden(this, hidden);
      }

      _setElementHidden(element, hidden) {
        element.classList.toggle('pbb-promo__hidden', hidden);
        if (hidden) {
          if (element.contains(document.activeElement)) {
            document.activeElement.blur();
          }
          element.setAttribute('aria-hidden', 'true');
          element.setAttribute('inert', '');
        } else {
          element.removeAttribute('aria-hidden');
          element.removeAttribute('inert');
        }
      }

      async _handleCopy() {
        const code = this._codeEl ? this._codeEl.textContent.trim() : '';
        if (!code) return;

        let copied = false;

        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
            copied = true;
          }
        } catch (_) {}

        if (!copied) {
          const input = document.createElement('INPUT');
          input.style.cssText = 'position: fixed; top: -100000px;';
          document.body.appendChild(input);
          input.value = code;
          input.focus();
          input.select();
          const range = document.createRange();
          range.selectNodeContents(input);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          input.setSelectionRange(0, 9999);
          copied = document.execCommand('copy');
          input.blur();
          document.body.removeChild(input);
        }

        if (copied && this._codeEl && this._copySuccess) {
          this._clearCopyResetTimer();
          const original = this._codeEl.textContent;
          this._codeEl.textContent = this._copySuccess;
          this._copyResetTimer = setTimeout(() => {
            if (this._codeEl) this._codeEl.textContent = original;
            this._copyResetTimer = null;
          }, 2000);
        }
      }

      _clearCopyResetTimer() {
        if (!this._copyResetTimer) return;
        clearTimeout(this._copyResetTimer);
        this._copyResetTimer = null;
      }

      _handleHelp() {
        if (!this._root) return;
        this._root.dispatchEvent(new CustomEvent('product-buy-box:promo-help-open', {
          bubbles: true
        }));
      }
    }

    customElements.define('product-buy-box-promo', ProductBuyBoxPromo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-retailer-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-retailer-links')) {
    class ProductBuyBoxRetailerLinks extends BaseElement {
      init() {
        this._trigger = this.querySelector('.product-buy-box-retailer-links__trigger');
        this._list = this.querySelector('.product-buy-box-retailer-links__list');
        this._arrow = this.querySelector('.product-buy-box-retailer-links__arrow');
        this._onClick = () => this._toggle();
        this._trigger?.addEventListener('click', this._onClick);
      }

      dispose() {
        this._trigger?.removeEventListener('click', this._onClick);
      }

      _toggle() {
        if (!this._trigger || !this._list) return;
        const isExpanded = this._trigger.getAttribute('aria-expanded') === 'true';
        this._trigger.setAttribute('aria-expanded', String(!isExpanded));
        this._list.classList.toggle('is-hidden', isExpanded);
        this._arrow?.classList.toggle('product-buy-box-retailer-links__arrow--rotated', !isExpanded);
      }
    }

    customElements.define('product-buy-box-retailer-links', ProductBuyBoxRetailerLinks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-sticky-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-sticky-total')) {
    class ProductBuyBoxStickyTotal extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._amountEl = this.querySelector('[data-price-amount]');
        this._compareAmountEl = this.querySelector('[data-compare-price-amount]');
        this._comparePriceDisplay = this.getAttribute('compare-price-display') || 'auto';
        this._initialVariantId = this.getAttribute('initial-variant-id');
        this._initialComparePrice = Number(this.getAttribute('initial-compare-price')) || 0;
        this._onTotalUpdate = (e) => {
          const detail = e.detail || {};
          const amount = this._amountEl;
          const compareAmount = this._compareAmountEl;

          if (amount && detail.totalPrice != null) {
            amount.textContent = $360.formatMoney(detail.totalPrice);
          }

          if (!compareAmount || detail.compareAtPrice == null) return;

          const forceHiddenClass = 'product-buy-box-sticky-bar__compare-amount--force-hidden';
          const hiddenClass = 'product-buy-box-sticky-bar__compare-amount--hidden';
          let comparePrice = Number(detail.compareAtPrice) || 0;
          if (comparePrice <= 0 && String(detail.variantId) === this._initialVariantId && this._initialComparePrice > 0) {
            comparePrice = this._initialComparePrice;
          }
          const price = Number(detail.variantPrice ?? detail.totalPrice) || 0;
          const shouldHide = compareAmount.classList.contains(forceHiddenClass) || (
            this._comparePriceDisplay === 'auto' && (comparePrice <= 0 || comparePrice <= price)
          );

          compareAmount.textContent = $360.formatMoney(comparePrice);
          compareAmount.classList.toggle(hiddenClass, shouldHide && !compareAmount.classList.contains(forceHiddenClass));
          compareAmount.hidden = shouldHide;
          compareAmount.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        };
        this._root?.addEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }
    }
    customElements.define('product-buy-box-sticky-total', ProductBuyBoxStickyTotal);
  }

  if (!customElements.get('product-buy-box-sticky-bar')) {
    class ProductBuyBoxStickyBar extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._stockLabel = this.querySelector('[data-stock-label]');
        this._onTotalUpdate = (e) => this._renderState(e.detail || {});
        this._root?.addEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      _renderState(detail) {
        if (!this._stockLabel || detail.available == null) return;
        this._stockLabel.classList.toggle('is-hidden', Boolean(detail.available));
      }
    }

    customElements.define('product-buy-box-sticky-bar', ProductBuyBoxStickyBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-subscription"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-subscription-tracker')) {
    class ProductBuyBoxSubscriptionTracker extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        const eventName = this.getAttribute('data-submit-event');
        const popupEvent = this.getAttribute('data-popup-event');
        if (!eventName || typeof $narwal === 'undefined') return;

        $narwal.bind(eventName, (opt) => {
          if (typeof $narwal.report === 'function') {
            $narwal.report({
              event: 'subscribe',
              params: {
                page: 'self',
                method: 'email',
                btn: opt && opt.button
              }
            });
          }
          if (popupEvent) $narwal.emit(popupEvent);
        });
      }
    }

    customElements.define('product-buy-box-subscription-tracker', ProductBuyBoxSubscriptionTracker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-variant-picker')) {
    class ProductBuyBoxVariantPicker extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._listEl = this._root?.querySelector('[data-variants]');
        if (!this._listEl) return;

        this._variants = JSON.parse(this._listEl.textContent);
        this._variantById = new Map(this._variants.map((variant) => [String(variant.id), variant]));
        this._selected = {};
        this._optionNames = this._getOptionNames();
        this._aggregateOptionName = this.getAttribute('aggregate-option-name') || '';
        const aggIdxRaw = parseInt(this.getAttribute('agg-idx'));
        this._aggregateOptionIndex = isNaN(aggIdxRaw) ? -1 : aggIdxRaw;
        const cardIdxRaw = parseInt(this.getAttribute('card-group-idx'));
        this._cardGroupIdx = isNaN(cardIdxRaw) ? -1 : cardIdxRaw;
        this._autoSelectFirst = this.getAttribute('auto-select-first-available') === 'true';

        this._statusEl = this.querySelector('[data-variant-picker-status]');
        this._cardLists = [...this.querySelectorAll('[data-pbb-card-list]')];
        this._cards = [...this.querySelectorAll('[data-pbb-card]')];
        this._defaultSelectionsByAggregate = this._buildDefaultSelectionsByAggregate();
        this._userSelectionsByAggregate = {};

        this._hydrate();
        this._applyOptionStyles();
        this._syncFromURL();
        this.addEventListener('keydown', this._onKeyDown);
      }

      dispose() {
        this.removeEventListener('keydown', this._onKeyDown);
        this.querySelectorAll('[data-pbb-btn]').forEach((btn) => {
          btn.removeEventListener('click', btn._pbbClick);
        });
        this.querySelectorAll('[data-pbb-card]').forEach((card) => {
          card.removeEventListener('click', card._cardClick);
          card.removeEventListener('keydown', card._cardKeyDown);
        });
      }

      _hydrate() {
        this.querySelectorAll('[data-pbb-btn]').forEach((btn) => {
          const idx = Number(btn.getAttribute('option-index'));
          const val = btn.getAttribute('option-value');
          btn._pbbClick = () => this._selectOption(idx, val);
          btn.addEventListener('click', btn._pbbClick);
        });

        this._cards.forEach((card) => {
          const hasNote = card.hasAttribute('data-has-note');

          card._cardClick = (e) => {
            if (e.target.closest('.variant-tag')) return;
            this._selectCard(card);
          };
          card.addEventListener('click', card._cardClick);

          card._cardKeyDown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              card._cardClick(e);
            }
          };
          card.addEventListener('keydown', card._cardKeyDown);
        });
      }

      _applyOptionStyles() {
        const styleData = {};
        this.querySelectorAll('[data-product-buy-box-option-style]').forEach((el) => {
          try {
            const data = JSON.parse(el.textContent);
            const optionValue = el.dataset.optionValue || data.optionValue;
            if (!optionValue) return;

            styleData[optionValue] = {
              ...data,
              optionValue,
              label: el.dataset.optionLabel || data.label,
              swatchColor: el.dataset.optionSwatchColor || data.swatchColor
            };
          } catch (e) {}
        });

        if (Object.keys(styleData).length === 0) return;

        this.querySelectorAll('[data-pbb-btn][option-index="' + this._aggregateOptionIndex + '"]').forEach((btn) => {
          const val = btn.getAttribute('option-value');
          const style = styleData[val];
          if (!style) return;

          if (style.image) {
            let img = btn.querySelector('.product-buy-box-option-card__cover-img');
            if (img) {
              img.src = style.image;
              img.removeAttribute('srcset');
            } else {
              const cover = btn.querySelector('.product-buy-box-option-card__cover');
              if (cover) {
                img = document.createElement('img');
                img.className = 'product-buy-box-option-card__cover-img';
                img.src = style.image;
                img.alt = '';
                img.loading = 'lazy';
                cover.innerHTML = '';
                cover.appendChild(img);
              }
            }
          }

          if (style.label) {
            const labelEl = btn.querySelector('.product-buy-box-option-card__label-text');
            if (labelEl) labelEl.textContent = style.label;
            btn.setAttribute('aria-label', (this._aggregateOptionName || '') + ': ' + style.label);
          }

          if (style.swatchColor) {
            btn.style.setProperty('--pbb-swatch-color', style.swatchColor);
          }

          const badge = btn.querySelector('.product-buy-box-option-card__badge');
          if (badge && style.badgeText) {
            badge.textContent = style.badgeText;
            badge.hidden = false;
          }
        });

        this._cards.forEach((card) => {
          const val = card.getAttribute('data-option-value');
          const style = styleData[val];
          if (!style) return;

          if (style.label) {
            const title = card.querySelector('.title');
            if (title) title.textContent = style.label;
          }

          if (style.badgeText) {
            let badge = card.querySelector('[data-card-badge]');
            if (!badge) {
              badge = document.createElement('div');
              badge.className = 'variant-tag';
              badge.setAttribute('data-card-badge', '');
              const content = card.querySelector('.variant-content');
              if (content) content.appendChild(badge);
            }
            badge.textContent = style.badgeText;
          }
        });
      }

      _getOptionNames() {
        const names = [];
        for (let i = 1; this.getAttribute('option-' + i); i++) {
          names.push(this.getAttribute('option-' + i));
        }
        return names;
      }

      _hasAggregate() {
        return this._aggregateOptionIndex >= 0;
      }

      _findVariant(selected) {
        const sel = selected || this._selected;
        const hasFullSelection = this._optionNames.every((_, i) => sel[i] != null);

        if (hasFullSelection) {
          const exact = this._variants.find((v) =>
            v.options.every((opt, i) => opt === sel[i])
          );
          if (exact) return exact;
        }

        const partial = this._variants.filter((v) =>
          v.options.every((opt, i) => sel[i] == null || opt === sel[i])
        );
        return partial.find((v) => v.available) || partial[0] || null;
      }

      _findVariantById(id) {
        if (id == null) return null;
        return this._variantById.get(String(id)) || null;
      }

      _buildDefaultSelectionsByAggregate() {
        if (!this._hasAggregate()) return {};

        return this._variants.reduce((memo, variant) => {
          const aggVal = variant.options[this._aggregateOptionIndex];
          if (aggVal == null || memo[aggVal]) return memo;
          memo[aggVal] = this._getSelectionFromVariant(variant);
          return memo;
        }, {});
      }

      _getSelectionFromVariant(variant) {
        return variant.options.reduce((selected, opt, i) => {
          selected[i] = opt;
          return selected;
        }, {});
      }

      _rememberCurrentSelection() {
        if (!this._hasAggregate()) return;
        const aggVal = this._selected[this._aggregateOptionIndex];
        if (aggVal == null) return;
        this._userSelectionsByAggregate[aggVal] = { ...this._selected };
      }

      _isOptionValueAvailable(optionIndex, value) {
        const trial = { ...this._selected, [optionIndex]: value };
        return this._variants.some((v) =>
          v.available && v.options.every((opt, i) => trial[i] == null || opt === trial[i])
        );
      }

      _isOptionValuePresent(optionIndex, value) {
        const trial = { ...this._selected, [optionIndex]: value };
        return this._variants.some((v) =>
          v.options.every((opt, i) => trial[i] == null || opt === trial[i])
        );
      }

      _getVisibleVariants() {
        if (!this._hasAggregate()) return this._variants;
        const aggVal = this._selected[this._aggregateOptionIndex];
        if (aggVal == null) return this._variants;
        return this._variants.filter((v) => v.options[this._aggregateOptionIndex] === aggVal);
      }

      _normalizeAfterAggregateChange() {
        const visible = this._getVisibleVariants();
        const fallback = this._autoSelectFirst
          ? visible.find((v) => v.available) || visible[0]
          : visible[0];
        if (!fallback) return;

        const aggVal = this._selected[this._aggregateOptionIndex];
        const remembered = this._autoSelectFirst
          ? null
          : this._userSelectionsByAggregate[aggVal] || this._defaultSelectionsByAggregate[aggVal];
        const nextSelection = remembered || this._getSelectionFromVariant(fallback);

        this._selected = { ...nextSelection, [this._aggregateOptionIndex]: aggVal };

        if (!this._findVariant(this._selected)) {
          this._selected = this._getSelectionFromVariant(fallback);
        }
      }

      _findVariantForCard(card) {
        return this._findVariantById(card.getAttribute('data-variant-id'));
      }

      _syncCardLists() {
        if (!this._hasAggregate()) return;
        const aggregateValue = this._selected[this._aggregateOptionIndex];

        this._cardLists.forEach((list) => {
          list.hidden = list.getAttribute('aggregate-option-value') !== aggregateValue;
        });
      }

      _syncCards() {
        if (!this._cards.length) return;
        this._syncCardLists();

        this._cards.forEach((card) => {
          if (card.closest('[data-pbb-card-list]')?.hidden) {
            card.classList.add('is-hidden');
            return;
          }

          const variant = this._findVariantForCard(card);
          if (!variant) {
            card.classList.add('is-hidden');
            return;
          }

          if (this._hasAggregate()) {
            const aggVal = this._selected[this._aggregateOptionIndex];
            if (aggVal != null && variant.options[this._aggregateOptionIndex] !== aggVal) {
              card.classList.add('is-hidden');
              return;
            }
          }

          for (let i = 0; i < this._optionNames.length; i++) {
            if (i === this._aggregateOptionIndex) continue;
            if (i === this._cardGroupIdx) continue;
            if (this._selected[i] != null && variant.options[i] !== this._selected[i]) {
              card.classList.add('is-hidden');
              return;
            }
          }

          card.classList.remove('is-hidden');
        });
      }

      _selectOption(index, value) {
        const isAggregate = this._hasAggregate() && index === this._aggregateOptionIndex;
        const prevAggVal = this._selected[this._aggregateOptionIndex];

        this._selected[index] = value;

        if (!isAggregate) {
          this._rememberCurrentSelection();
        }

        const optionName = this._optionNames[index] || '';

        this._dispatchOptionChange(index, optionName, value, isAggregate);

        if (isAggregate && prevAggVal !== value) {
          this._normalizeAfterAggregateChange();
          this._syncCards();
        }

        if (!isAggregate && index !== this._cardGroupIdx) {
          this._syncCards();
        }

        const variant = this._findVariant();
        this._updateUI(variant);
        this._dispatchListChange(variant);
        this._dispatchVariantChange(variant);

        if (variant) {
          this._updateURL(variant.id);
          this._announceStatus(variant);
        }
      }

      _selectCard(card) {
        const variant = this._findVariantForCard(card);
        if (!variant) return;

        this._selected = this._getSelectionFromVariant(variant);
        this._rememberCurrentSelection();

        const optionName = this._optionNames[this._cardGroupIdx] || '';
        const value = variant.options[this._cardGroupIdx];
        this._dispatchOptionChange(this._cardGroupIdx, optionName, value, false);
        this._syncCards();
        this._updateUI(variant);
        this._dispatchListChange(variant);
        this._dispatchVariantChange(variant);
        this._updateURL(variant.id);
        this._announceStatus(variant);
      }

      _updateUI(variant) {
        this.querySelectorAll('[data-pbb-btn]').forEach((btn) => {
          const i = Number(btn.getAttribute('option-index'));
          const val = btn.getAttribute('option-value');
          const isAgg = this._hasAggregate() && i === this._aggregateOptionIndex;
          const selected = this._selected[i] === val;
          const present = isAgg || this._isOptionValuePresent(i, val);
          const available = this._isOptionValueAvailable(i, val);

          btn.classList.toggle('is-selected', selected);
          btn.setAttribute('aria-checked', selected ? 'true' : 'false');

          if (!present) {
            btn.hidden = true;
            btn.disabled = true;
            btn.tabIndex = -1;
            return;
          }
          btn.hidden = false;
          btn.disabled = isAgg ? false : !available;
          btn.tabIndex = -1;
        });

        this._cards.forEach((card) => {
          const cardVariant = this._findVariantForCard(card);
          const selected = variant && cardVariant && String(variant.id) === String(cardVariant.id);
          const hasNote = card.hasAttribute('data-has-note');

          card.classList.toggle('is-unavailable', Boolean(cardVariant && !cardVariant.available));
          card.classList.toggle('is-selected', selected);
          card.classList.toggle('is-on', selected && hasNote);
          card.setAttribute('aria-checked', selected ? 'true' : 'false');
          card.tabIndex = selected && !card.classList.contains('is-hidden') ? 0 : -1;
        });

        this.querySelectorAll('.product-buy-box-option-group').forEach((group) => {
          const items = [...group.querySelectorAll('[data-pbb-btn]:not([hidden]), [data-pbb-card]:not(.is-hidden)')]
            .filter((item) => !item.disabled && item.getAttribute('aria-disabled') !== 'true');
          if (!items.length) return;

          const checked = items.find((item) => item.getAttribute('aria-checked') === 'true');
          (checked || items[0]).tabIndex = 0;
        });
      }

      _updateURL(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState(null, '', url);
      }

      _syncFromURL() {
        const id = new URL(window.location.href).searchParams.get('variant');
        const variant = id
          ? this._findVariantById(id)
          : this._variants.find((v) => v.available) || this._variants[0];

        if (!variant) return;

        variant.options.forEach((opt, i) => {
          this._selected[i] = opt;
        });
        this._syncCards();
        this._updateUI(variant);
        this._dispatchListChange(variant);
        this._dispatchVariantChange(variant);
      }

      _announceStatus(variant) {
        if (!this._statusEl) return;
        const optionLabels = variant.options.filter(Boolean).join(', ');
        const stock = variant.available ? 'In stock.' : 'Out of stock.';
        this._statusEl.textContent = 'Selected ' + optionLabels + '. ' + stock;
      }

      _dispatchOptionChange(index, optionName, value, isAggregate) {
        const detail = {
          optionIndex: index,
          optionName: optionName,
          value: value,
          role: isAggregate ? 'aggregate' : 'regular',
          selectedOptions: this._optionNames.map((_, i) => this._selected[i] || null),
          optionMap: {},
          matchedVariantId: null,
          source: 'variant-picker'
        };

        this._optionNames.forEach((n, i) => {
          if (this._selected[i] != null) detail.optionMap[n] = this._selected[i];
        });

        const variant = this._findVariant();
        if (variant) detail.matchedVariantId = variant.id;

        this._root.dispatchEvent(new CustomEvent('product-buy-box:option-change', {
          bubbles: true, composed: true, detail: detail
        }));
      }

      _dispatchListChange(variant) {
        const visible = this._getVisibleVariants();
        const available = visible.filter((v) => v.available);
        const detail = {
          aggregateOptionName: this._hasAggregate() ? this._optionNames[this._aggregateOptionIndex] : null,
          aggregateOptionIndex: this._aggregateOptionIndex,
          aggregateValue: this._hasAggregate() ? this._selected[this._aggregateOptionIndex] : null,
          selectedOptions: this._optionNames.map((_, i) => this._selected[i] || null),
          visibleVariantIds: visible.map((v) => v.id),
          availableVariantIds: available.map((v) => v.id),
          activeVariantId: variant ? variant.id : null,
          source: 'variant-picker'
        };

        this._root.dispatchEvent(new CustomEvent('product-buy-box:variant-list-change', {
          bubbles: true, composed: true, detail: detail
        }));
      }

      _dispatchVariantChange(variant) {
        if (!variant) return;

        const optionMap = {};
        this._optionNames.forEach((n, i) => {
          if (variant.options[i] != null) optionMap[n] = variant.options[i];
        });

        this._root.dispatchEvent(new CustomEvent('product-buy-box:variant-change', {
          bubbles: true, composed: true,
          detail: {
            variantId: variant.id,
            available: variant.available,
            price: variant.price,
            compareAtPrice: variant.compare_at_price || 0,
            image: variant.featured_image,
            featuredMediaId: variant.featured_media_id,
            title: variant.title,
            options: variant.options,
            optionMap: optionMap,
            promo: variant.promo || {},
            sku: variant.sku,
            source: 'variant-picker'
          }
        }));
      }

      _onKeyDown = (e) => {
        const target = e.target.closest('[data-pbb-btn], [data-pbb-card]');
        if (!target) return;

        const group = target.closest('.product-buy-box-option-group');
        if (!group) return;

        const buttons = [...group.querySelectorAll('[data-pbb-btn]:not([hidden]), [data-pbb-card]:not(.is-hidden)')]
          .filter((item) => !item.disabled && item.getAttribute('aria-disabled') !== 'true');
        const idx = buttons.indexOf(target);
        if (idx < 0) return;

        let nextIdx = idx;

        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            nextIdx = idx > 0 ? idx - 1 : buttons.length - 1;
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            nextIdx = idx < buttons.length - 1 ? idx + 1 : 0;
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            target.click();
            return;
          default:
            return;
        }

        const next = buttons[nextIdx];
        if (next && !next.disabled) {
          next.click();
          next.focus();
        }
      }
    }
    customElements.define('product-buy-box-variant-picker', ProductBuyBoxVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-warranty-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-modal')) {
    class ProductBuyBoxModal extends BaseElement {
      init() {
        this._modalRole = this.getAttribute('modal-role') || '';
        this._dialog = this.querySelector('[role="dialog"]');
        this._onOpen = (e) => this._handleOpen(e.detail || {});
        this._onCloseClick = (e) => {
          if (e.target.matches('[data-modal-close]')) this.close();
        };
        this._onKeyDown = (e) => this._handleKeyDown(e);
        this.closest('product-buy-box')?.addEventListener('product-buy-box:modal-open', this._onOpen);
        this.addEventListener('click', this._onCloseClick);
      }

      dispose() {
        this.closest('product-buy-box')?.removeEventListener('product-buy-box:modal-open', this._onOpen);
        this.removeEventListener('click', this._onCloseClick);
        document.removeEventListener('keydown', this._onKeyDown);
      }

      _handleOpen(detail) {
        if (detail.modalRole !== this._modalRole) return;
        this._previousActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.hidden = false;
        document.addEventListener('keydown', this._onKeyDown);
        this._focusFirstElement();
      }

      close() {
        if (this.hidden) return;
        this.hidden = true;
        document.removeEventListener('keydown', this._onKeyDown);
        if (this._previousActiveElement?.isConnected) this._previousActiveElement.focus();
        this._previousActiveElement = null;
      }

      _focusableElements() {
        return [...this.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((el) => el.offsetParent !== null);
      }

      _focusFirstElement() {
        this._dialog?.focus();
      }

      _handleKeyDown(e) {
        if (this.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
          return;
        }
        if (e.key !== 'Tab') return;

        const focusable = this._focusableElements();
        if (!focusable.length) {
          e.preventDefault();
          this._dialog?.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (document.activeElement === this._dialog) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    customElements.define('product-buy-box-modal', ProductBuyBoxModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-warranty"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-warranty')) {
    class ProductBuyBoxWarranty extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._selected = null;
        this._helpBtn = this.querySelector('[data-warranty-help]');
        this._collapsedCount = parseInt(this.getAttribute('collapsed-count'), 10) || 1;
        this._toggleRow = this.querySelector('[data-warranty-toggle-row]');
        this._toggleBtn = this.querySelector('[data-warranty-toggle]');
        this._toggleText = this.querySelector('[data-warranty-toggle-text]');

        this._onRootVariantChange = (e) => {
          if (e.detail.available) {
            this._restoreCards();
          } else {
            this._disableAllCards();
          }
        };

        this._onCheckboxChange = (e) => {
          const detail = e.detail || {};
          const target = detail.element || e.target;
          const card = target.closest('.product-buy-box-warranty__card');
          if (!card || !this.contains(card)) return;
          this._handleCheckbox(card, target.checked);
        };

        this._onCardClick = (e) => {
          const card = e.target.closest('.product-buy-box-warranty__card');
          if (!card || !this.contains(card)) return;
          if (card.classList.contains('is-disabled')) return;
          if (e.target.closest('.ndev-checkbox-wrapper, [data-warranty-toggle-row]')) return;

          const chk = card.querySelector('.ndev-checkbox-input');
          if (chk && !chk.disabled) {
            chk.checked = !chk.checked;
            chk.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };
        this._onHelpClick = () => this._handleHelp();
        this._onToggleClick = (e) => this._toggleExpanded(e);

        this.addEventListener('click', this._onCardClick);
        this.addEventListener('checkbox:change', this._onCheckboxChange);
        this._root?.addEventListener('product-buy-box:variant-change', this._onRootVariantChange);
        this._helpBtn?.addEventListener('click', this._onHelpClick);
        this._toggleBtn?.addEventListener('click', this._onToggleClick);

        const rootAvailable = this.getAttribute('data-root-variant-available');
        if (rootAvailable === 'false') {
          this._disableAllCards();
        }

        this._initMoreToggle();
        this._emitSourceChange();
      }

      dispose() {
        this.removeEventListener('click', this._onCardClick);
        this.removeEventListener('checkbox:change', this._onCheckboxChange);
        this._root?.removeEventListener('product-buy-box:variant-change', this._onRootVariantChange);
        this._helpBtn?.removeEventListener('click', this._onHelpClick);
        this._toggleBtn?.removeEventListener('click', this._onToggleClick);
      }

      _initMoreToggle() {
        if (!this._toggleBtn) return;
        const cards = this.querySelectorAll('[data-warranty-card]');
        cards.forEach((card, index) => {
          card.classList.toggle('is-collapsed-hidden', index >= this._collapsedCount);
        });
        const shouldShowToggle = cards.length > this._collapsedCount;
        if (this._toggleRow) this._toggleRow.hidden = !shouldShowToggle;
        this.classList.remove('is-expanded');
        this._syncToggleState();
      }

      _toggleExpanded(event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.classList.toggle('is-expanded');
        this._syncToggleState();
      }

      _syncToggleState() {
        if (!this._toggleBtn) return;
        const expanded = this.classList.contains('is-expanded');
        this._toggleBtn.setAttribute('aria-expanded', String(expanded));
        this._moveToggleRow(expanded);
        if (!this._toggleText) return;
        this._toggleText.textContent = expanded
          ? (this._toggleBtn.getAttribute('data-less-text') || 'Hide')
          : (this._toggleBtn.getAttribute('data-more-text') || 'More');
      }

      _moveToggleRow(expanded) {
        if (!this._toggleRow || this._toggleRow.hidden) return;
        const cards = Array.from(this.querySelectorAll('[data-warranty-card]'));
        if (!cards.length) return;

        cards.forEach((card) => card.classList.remove('is-last-visible'));
        const visibleCards = expanded ? cards : cards.slice(0, this._collapsedCount);
        const targetCard = visibleCards[visibleCards.length - 1] || cards[0];
        targetCard.classList.add('is-last-visible');
        targetCard.appendChild(this._toggleRow);
      }

      _disableAllCards() {
        this.classList.add('is-root-disabled');
        this.classList.remove('has-selected');
        const cards = this.querySelectorAll('.product-buy-box-warranty__card');
        cards.forEach((card) => {
          card.classList.add('is-disabled');
          card.classList.remove('is-selected');
          const chk = card.querySelector('.ndev-checkbox-input');
          if (chk) {
            chk.checked = false;
            chk.disabled = true;
          }
          this._setCheckboxDisabled(card, true);
        });
        this._selected = null;
        this._emitSourceChange();
      }

      _restoreCards() {
        this.classList.remove('is-root-disabled');
        const cards = this.querySelectorAll('.product-buy-box-warranty__card');
        cards.forEach((card) => {
          const cardAvailable = card.getAttribute('data-available');
          if (cardAvailable !== 'false') {
            card.classList.remove('is-disabled');
            const chk = card.querySelector('.ndev-checkbox-input');
            if (chk) chk.disabled = false;
            this._setCheckboxDisabled(card, false);
          } else {
            card.classList.add('is-disabled');
            card.classList.remove('is-selected');
            const chk = card.querySelector('.ndev-checkbox-input');
            if (chk) {
              chk.checked = false;
              chk.disabled = true;
            }
            this._setCheckboxDisabled(card, true);
          }
        });
      }

      _setCheckboxDisabled(card, disabled) {
        const wrapper = card.querySelector('.ndev-checkbox-wrapper');
        if (wrapper) wrapper.classList.toggle('is-disabled', disabled);
      }

      _handleCheckbox(card, checked) {
        if (card.classList.contains('is-disabled')) return;

        const cards = this.querySelectorAll('.product-buy-box-warranty__card');
        cards.forEach((item) => {
          if (item === card) return;
          item.classList.remove('is-selected');
          const chk = item.querySelector('.ndev-checkbox-input');
          if (chk) chk.checked = false;
        });

        if (checked) {
          const variantId = card.getAttribute('data-variant-id');
          const price = parseInt(card.getAttribute('data-price')) || 0;
          this._selected = { variantId, price, quantity: 1 };
          card.classList.add('is-selected');
        } else {
          this._selected = null;
          card.classList.remove('is-selected');
        }

        this.classList.toggle('has-selected', !!this._selected);
        this._emitSourceChange();
      }

      _emitSourceChange() {
        const items = [];
        let total = 0;

        if (this._selected) {
          total = this._selected.price;
          items.push({
            variantId: this._selected.variantId,
            quantity: 1,
            properties: {}
          });
        }

        if (!this._root) return;
        this._root.dispatchEvent(new CustomEvent('product-buy-box:source-change', {
          bubbles: true,
          composed: true,
          detail: {
            source: 'warranty',
            total,
            items
          }
        }));
      }

      _handleHelp() {
        if (!this._root) return;
        this._root.dispatchEvent(new CustomEvent('product-buy-box:modal-open', {
          bubbles: true,
          detail: {
            modalRole: 'warranty'
          }
        }));
      }
    }
    customElements.define('product-buy-box-warranty', ProductBuyBoxWarranty);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_site-header-nav-tab-panel"] && !Shopify.designMode) return;
  try {
    class SiteHeaderNavTabPanel extends BaseElement {
    init() {
      this.dispose();

      this._listeners = [];
      this._tabPanelMediaQuery = window.matchMedia('(min-width: 1024px)');
      this._layout = this.querySelector(':scope > .site-header-nav-tab-panel__layout');
      if (!this._layout) return;

      this._items = Array.from(this._layout.children)
        .filter((root) => root.hasAttribute('data-site-header-nav-tab-panel-item'))
        .map((root) => ({
          root,
          trigger: root.querySelector(':scope > .site-header-nav-tab__trigger'),
          panel: root.querySelector(':scope > .site-header-nav-tab__region'),
        }))
        .filter((item) => item.trigger && item.panel);

      if (!this._items.length) return;

      this._syncViewport();
      this.setAttribute('enhanced', '');
      this._items.forEach((item) => {
        item.trigger.disabled = false;
        this._listen(item.trigger, 'pointerenter', () => this._handleDesktopActivate(item));
        this._listen(item.trigger, 'focusin', () => this._handleDesktopActivate(item));
        this._listen(item.trigger, 'click', () => this._handleTriggerClick(item));
      });

      this._listen(this._tabPanelMediaQuery, 'change', () => this._syncViewport());
      this._listen(document, 'shopify:block:select', (event) => this._handleBlockSelect(event));
    }

    dispose() {
      if (this._listeners) {
        this._listeners.forEach(({ target, type, handler }) => target.removeEventListener(type, handler));
      }

      if (this._items) {
        this._items.forEach((item) => {
          item.trigger.disabled = true;
          item.trigger.setAttribute('aria-expanded', 'true');
          item.panel.hidden = false;
          item.panel.removeAttribute('inert');
        });
      }

      this._listeners = [];
      this._items = [];
      this._layout = null;
      this._activeDesktopItem = null;
      this._tabPanelMediaQuery = null;
      this.removeAttribute('enhanced');
    }

    _listen(target, type, handler) {
      target.addEventListener(type, handler);
      this._listeners.push({ target, type, handler });
    }

    _handleDesktopActivate(item) {
      if (!this._tabPanelMediaQuery.matches) return;
      this._activateDesktop(item);
    }

    _handleTriggerClick(item) {
      if (this._tabPanelMediaQuery.matches) {
        this._activateDesktop(item);
        return;
      }

      const shouldExpand = item.trigger.getAttribute('aria-expanded') !== 'true';
      this._setItemExpanded(item, shouldExpand);
      if (shouldExpand) this._activeDesktopItem = item;
    }

    _activateDesktop(item) {
      if (!item || !this._items.includes(item)) return;

      this._activeDesktopItem = item;
      this._items.forEach((candidate) => this._setItemExpanded(candidate, candidate === item));
    }

    _syncViewport() {
      if (this._tabPanelMediaQuery.matches) {
        const activeItem = this._items.includes(this._activeDesktopItem) ? this._activeDesktopItem : this._items[0];
        this._activateDesktop(activeItem);
        return;
      }

      this._items.forEach((item) => this._setItemExpanded(item, false));
    }

    _setItemExpanded(item, isExpanded) {
      item.trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      item.panel.hidden = !isExpanded;
      item.panel.toggleAttribute('inert', !isExpanded);
    }

    _handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;

      const selectedRoot = event.target.closest('[data-site-header-nav-tab-panel-item]');
      let selectedItem = this._items.find((item) => item.root === selectedRoot);
      if (!selectedItem && selectedRoot) {
        this.init();
        selectedItem = this._items.find((item) => item.root === selectedRoot);
      }
      if (!selectedItem) return;

      const outerDetails = this.closest('.site-header-nav-grouped-link__details');
      if (outerDetails) outerDetails.open = true;

      if (this._tabPanelMediaQuery.matches) this._activateDesktop(selectedItem);
      else this._setItemExpanded(selectedItem, true);
    }
  }

  if (!customElements.get('site-header-nav-tab-panel')) {
    customElements.define('site-header-nav-tab-panel', SiteHeaderNavTabPanel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-button"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-button';
    const ROOT_SELECTOR = '[data-ndev-button]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function trimAttr(value) {
      if (value == null) return '';
      const s = String(value).trim();
      return s;
    }

    function resolveVariantIdFromAncestors(el) {
      const blockRoot = el.closest('[data-ndev-button]');
      const start =
        blockRoot && blockRoot.parentElement ? blockRoot.parentElement : el.parentElement;
      if (!start) return '';
      const ndev = start.closest('[data-ndev-product-variant-id]');
      if (ndev) {
        const id = trimAttr(ndev.getAttribute('data-ndev-product-variant-id'));
        if (id) return id;
      }
      const legacy = start.closest('[data-variant-id]');
      if (legacy) {
        const id = trimAttr(legacy.getAttribute('data-variant-id'));
        if (id) return id;
      }
      return '';
    }

    function resolveCartPayload(el) {
      // 严格顺序：1–3（data-cart-variant-id）→ 4 祖先 dataset → 5（data-cart-variant-fallback-id）
      let variantId = trimAttr(el.getAttribute('data-cart-variant-id'));
      if (!variantId) {
        variantId = resolveVariantIdFromAncestors(el);
      }
      if (!variantId) {
        variantId = trimAttr(el.getAttribute('data-cart-variant-fallback-id'));
      }

      let variantPrice = trimAttr(el.getAttribute('data-cart-variant-price'));
      if (!variantPrice) {
        const ndevP = el.closest('[data-ndev-product-variant-price]');
        if (ndevP) variantPrice = trimAttr(ndevP.getAttribute('data-ndev-product-variant-price'));
      }
      if (!variantPrice) {
        const vp = el.closest('[data-variant-price]');
        if (vp) variantPrice = trimAttr(vp.getAttribute('data-variant-price'));
      }
      if (!variantPrice) variantPrice = '0';

      let variantTitle = trimAttr(el.getAttribute('data-cart-variant-title'));
      if (!variantTitle) {
        const ndevT = el.closest('[data-ndev-product-variant-title]');
        if (ndevT) variantTitle = trimAttr(ndevT.getAttribute('data-ndev-product-variant-title'));
      }
      if (!variantTitle) {
        const vt = el.closest('[data-variant-title]');
        if (vt) variantTitle = trimAttr(vt.getAttribute('data-variant-title'));
      }
      if (!variantTitle) variantTitle = 'default';

      return { variantId, variantPrice, variantTitle };
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const button = root.querySelector('.ndev-button__btn');
      if (!button) return;

      const purpose = button.getAttribute('data-btn-purpose');
      const isCart = purpose === 'cart';
      const isScroll = purpose === 'scroll';
      const cartIcon = button.querySelector('.ndev-button__cart-icon');
      let hiddenButton = null;
      let observer = null;

      // 购物车功能
      if (isCart && typeof $360 !== 'undefined' && typeof $360.addToCart === 'function') {
        hiddenButton = document.createElement('button');
        hiddenButton.style.display = 'none';
        document.body.appendChild(hiddenButton);

        observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
              if (hiddenButton.disabled) {
                button.classList.add('ndev-button__btn--loading');
                button.disabled = true;
                button.setAttribute('aria-busy', 'true');
              } else {
                button.classList.remove('ndev-button__btn--loading');
                button.disabled = false;
                button.removeAttribute('aria-busy');
              }
            }
          });
        });

        observer.observe(hiddenButton, {
          attributes: true,
          attributeFilter: ['disabled'],
        });

        const addToCart = function (options, event, buyNow) {
          const qty = options.qty;
          const variantId = options.variantId;
          const properties = options.properties;

          return $360.addToCart(
            {
              qty: qty,
              variantId: variantId,
              button: hiddenButton,
              properties: properties,
            },
            null,
            event,
            buyNow
          );
        };

        const cartData = {
          quantity: 1,
          buyNow: button.getAttribute('data-cart-buy-now') === 'true',
        };

        // 购物车图标点击（固定为加入购物车）
        if (cartIcon) {
          const handleCartIconClick = function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (button.classList.contains('ndev-button__btn--disabled') || button.disabled) {
              return;
            }

            const resolved = resolveCartPayload(button);
            if (!resolved.variantId) {
              console.error('[ndev-button][NB-CART-01]');
              return;
            }

            if (typeof $narwal !== 'undefined' && typeof $narwal.report === 'function') {
              $narwal.report(e);
            }

            addToCart(
              {
                qty: cartData.quantity,
                variantId: resolved.variantId,
              },
              e,
              false
            );
          };

          cartIcon.addEventListener('click', handleCartIconClick);
          button._handleCartIconClick = handleCartIconClick;
        }

        // 按钮主体点击
        const handleMainClick = function (e) {
          if (cartIcon && e.target.closest('.ndev-button__cart-icon')) {
            return;
          }

          if (button.classList.contains('ndev-button__btn--disabled') || button.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          if (typeof $narwal !== 'undefined' && typeof $narwal.report === 'function') {
            $narwal.report(e);
          }

          e.preventDefault();
          e.stopPropagation();

          const resolved = resolveCartPayload(button);
          if (!resolved.variantId) {
            console.error('[ndev-button][NB-CART-01]');
            return;
          }

          addToCart(
            {
              qty: cartData.quantity,
              variantId: resolved.variantId,
            },
            e,
            cartData.buyNow
          );
        };

        button.addEventListener('click', handleMainClick);
        button._handleMainClick = handleMainClick;
      }

      // 页面定位功能 (scroll 模式)
      if (isScroll) {
        const scrollType = button.getAttribute('data-scroll-type');
        const scrollOffset = button.getAttribute('data-scroll-offset');

        const handleScrollClick = function (e) {
          e.preventDefault();
          e.stopPropagation();

          let targetEl = null;

          if (scrollType === 'section_scroll') {
            const sectionIndex = parseInt(button.getAttribute('data-scroll-section-index')) || 1;
            const allSections = document.querySelectorAll('#main-content .shopify-section');
            if (allSections[sectionIndex - 1]) {
              targetEl = allSections[sectionIndex - 1];
            } else {
              console.warn('[ndev-button][NB-SCR-01]');
              return;
            }
          } else if (scrollType === 'anchor') {
            const selector = button.getAttribute('data-scroll-anchor');
            if (selector) {
              try {
                targetEl = document.querySelector(selector);
              } catch (err) {
                console.warn('[ndev-button][NB-SCR-02]');
                return;
              }
            }
            if (!targetEl) {
              console.warn('[ndev-button][NB-SCR-02]');
              return;
            }
          }

          if (!targetEl) {
            console.warn('[ndev-button][NB-SCR-03]');
            return;
          }

          const box = targetEl.getBoundingClientRect();
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const targetTop = box.top + scrollTop;

          let offset = 0;
          if (scrollOffset) {
            offset = parseInt(scrollOffset);
          } else {
            const header = document.querySelector('#site-header');
            if (header) offset = header.offsetHeight;
            offset += 64;
          }

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({
            top: targetTop - offset,
            behavior: reducedMotion ? 'auto' : 'smooth',
          });

          if (typeof $narwal !== 'undefined' && typeof $narwal.report === 'function') {
            $narwal.report(e);
          }
        };

        button.addEventListener('click', handleScrollClick);
        button._handleScrollClick = handleScrollClick;
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          if (button._handleCartIconClick && cartIcon) {
            cartIcon.removeEventListener('click', button._handleCartIconClick);
          }
          if (button._handleMainClick) {
            button.removeEventListener('click', button._handleMainClick);
          }
          if (button._handleScrollClick) {
            button.removeEventListener('click', button._handleScrollClick);
          }
          if (observer) {
            observer.disconnect();
          }
          if (hiddenButton && hiddenButton.parentNode) {
            hiddenButton.parentNode.removeChild(hiddenButton);
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-capsule-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-capsule-tabs')) {
    class NdevCapsuleTabs extends BaseElement {
      init() {
        this.dispose();

        this.grid = this.querySelector('.ndev-capsule-tabs__grid');
        if (!this.grid) return;

        this.previousButton = this.querySelector('.ndev-capsule-tabs__arrow--previous');
        this.nextButton = this.querySelector('.ndev-capsule-tabs__arrow--next');

        this.items = Array.from(this.grid.children)
          .filter((child) => child.classList.contains('ndev-tab'))
          .map((item) => ({
            tab: item.querySelector(':scope > .ndev-tab__title'),
            panel: item.querySelector(':scope > .ndev-tab__panel'),
          }))
          .filter((item) => item.tab && item.panel);
        this.tabs = this.items.map((item) => item.tab);
        this.panels = this.items.map((item) => item.panel);
        this.boundListeners = [];
        this.overflowRafId = null;
        this.shouldRemeasureOverflow = false;
        this.mobileMedia = window.matchMedia('(max-width: 1023px)');

        if (!this.tabs.length) return;
        this.tabs.forEach((tab, index) => {
          const clickHandler = () => this.activate(index, true);
          const keyHandler = (event) => this.handleKeydown(event, index);

          tab.addEventListener('click', clickHandler);
          tab.addEventListener('keydown', keyHandler);
          this.boundListeners.push([tab, 'click', clickHandler], [tab, 'keydown', keyHandler]);
        });

        this.listen(this.grid, 'scroll', () => this.scheduleOverflowUpdate());
        this.listen(this.mobileMedia, 'change', () => this.scheduleOverflowUpdate(true));
        if (this.previousButton) this.listen(this.previousButton, 'click', () => this.scrollTabs(-1));
        if (this.nextButton) this.listen(this.nextButton, 'click', () => this.scrollTabs(1));

        if (typeof ResizeObserver === 'function') {
          this.resizeObserver = new ResizeObserver(() => this.scheduleOverflowUpdate(true));
          this.resizeObserver.observe(this);
          this.resizeObserver.observe(this.grid);
          this.tabs.forEach((tab) => this.resizeObserver.observe(tab));
        } else {
          this.listen(window, 'resize', () => this.scheduleOverflowUpdate(true));
        }

        if (document.fonts?.addEventListener) {
          this.listen(document.fonts, 'loadingdone', () => this.scheduleOverflowUpdate(true));
        }

        const initialIndex = this.getInitialIndex();
        this.activate(initialIndex, false);
        this.scheduleOverflowUpdate(true);
        this.classList.add('is-ready');
      }

      listen(target, eventName, handler) {
        target.addEventListener(eventName, handler);
        this.boundListeners.push([target, eventName, handler]);
      }

      dispose() {
        if (this.boundListeners) {
          this.boundListeners.forEach(([target, eventName, handler]) => {
            target.removeEventListener(eventName, handler);
          });
        }

        if (this.overflowRafId !== null && this.overflowRafId !== undefined) {
          cancelAnimationFrame(this.overflowRafId);
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();

        this.boundListeners = [];
        this.overflowRafId = null;
        this.resizeObserver = null;
        this.removeAttribute('overflowing');
        this.setArrowState(this.previousButton, false);
        this.setArrowState(this.nextButton, false);
        this.classList.remove('is-ready');
      }

      getInitialIndex() {
        const expandedIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-expanded') === 'true');
        if (expandedIndex >= 0) return expandedIndex;

        const activePanelIndex = this.panels.findIndex((panel) => panel.classList.contains('active') || !panel.hasAttribute('hidden'));
        if (activePanelIndex >= 0) return activePanelIndex;

        return 0;
      }

      activate(index, focusTab) {
        if (!this.tabs.length) return;

        const normalizedIndex = (index + this.tabs.length) % this.tabs.length;

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === normalizedIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          if (isActive && focusTab) tab.focus();
        });

        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === normalizedIndex;
          panel.classList.toggle('active', isActive);
          panel.toggleAttribute('hidden', !isActive);
        });

        this.scrollTabIntoView(this.tabs[normalizedIndex]);
      }

      scheduleOverflowUpdate(remeasure = false) {
        this.shouldRemeasureOverflow ||= remeasure;
        if (this.overflowRafId !== null) return;

        this.overflowRafId = requestAnimationFrame(() => {
          this.overflowRafId = null;
          const shouldRemeasure = this.shouldRemeasureOverflow;
          this.shouldRemeasureOverflow = false;
          this.updateOverflowState(shouldRemeasure);
        });
      }

      updateOverflowState(remeasure = false) {
        if (!this.grid) return;

        if (!this.mobileMedia?.matches) {
          this.removeAttribute('overflowing');
          this.setArrowState(this.previousButton, false);
          this.setArrowState(this.nextButton, false);
          this.grid.scrollLeft = 0;
          return;
        }

        if (remeasure) this.removeAttribute('overflowing');

        const overflowing = this.grid.scrollWidth - this.grid.clientWidth > 1;
        this.toggleAttribute('overflowing', overflowing);

        const maxLeft = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
        const atStart = this.grid.scrollLeft <= 1;
        const atEnd = this.grid.scrollLeft >= maxLeft - 1;

        this.setArrowState(this.previousButton, overflowing && !atStart);
        this.setArrowState(this.nextButton, overflowing && !atEnd);

        if (remeasure && overflowing) {
          const activeTab = this.tabs.find((tab) => tab.getAttribute('aria-expanded') === 'true');
          this.scrollTabIntoView(activeTab);
        }
      }

      setArrowState(button, isAvailable) {
        if (!button) return;

        button.disabled = !isAvailable;
        button.setAttribute('aria-hidden', isAvailable ? 'false' : 'true');
      }

      scrollTabs(direction) {
        if (!this.grid) return;

        const maxLeft = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
        const step = this.grid.clientWidth * 0.75;
        const nextLeft = Math.max(0, Math.min(this.grid.scrollLeft + direction * step, maxLeft));

        this.grid.scrollTo({
          left: nextLeft,
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        });
      }

      scrollTabIntoView(tab) {
        if (!this.grid || !tab || !this.hasAttribute('overflowing')) return;

        const gridRect = this.grid.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const startInset = this.previousButton?.getAttribute('aria-hidden') === 'false' ? 44 : 0;
        const endInset = this.nextButton?.getAttribute('aria-hidden') === 'false' ? 44 : 0;
        let offset = 0;

        if (tabRect.left < gridRect.left + startInset) offset = tabRect.left - gridRect.left - startInset;
        else if (tabRect.right > gridRect.right - endInset) offset = tabRect.right - gridRect.right + endInset;

        if (Math.abs(offset) < 1) return;

        const maxLeft = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
        const nextLeft = Math.max(0, Math.min(this.grid.scrollLeft + offset, maxLeft));
        this.grid.scrollTo({
          left: nextLeft,
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        });
      }

      prefersReducedMotion() {
        return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      }

      handleKeydown(event, index) {
        let nextIndex = null;

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = index - 1;
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = index + 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        }

        if (nextIndex == null) return;

        event.preventDefault();
        this.activate(nextIndex, true);
      }
    }

    customElements.define('ndev-capsule-tabs', NdevCapsuleTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-card-group"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const ROOT_SELECTOR = '[data-ndev-card-group]';
    const INIT_ATTR = 'data-ndev-card-group-init';

    const registry = new WeakMap();

    function checkNavButtons(itemsEl, navEl, swiper) {
      if (!itemsEl || !navEl || !swiper) return;
      const needsScroll = itemsEl.scrollWidth > itemsEl.parentElement.offsetWidth + 1;
      if (needsScroll) {
        navEl.classList.add('show');
      } else {
        navEl.classList.remove('show');
      }
    }

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    function shouldUseSwiper(root) {
      const layout = root.dataset.layout || 'flex';
      const layoutMobile = root.dataset.layoutMobile || layout;
      const isMobile = window.innerWidth < 1024;
      return isMobile ? layoutMobile === 'swiper' : layout === 'swiper';
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const itemsEl = root.querySelector('[data-card-group-items]');
      if (!itemsEl) return;

      const wrapper = root.closest('.ndev-card-group-wrapper') || root.parentElement;
      const navEl = wrapper ? wrapper.querySelector('[data-card-group-nav]') : null;
      const paginationEl = wrapper ? wrapper.querySelector('[data-card-group-pagination]') : null;

      let swiper = null;
      let resizeTimer = null;
      let lastWasMobile = window.innerWidth < 1024;
      let paginationClickHandler = null;

      function applySwiperDOM() {
        itemsEl.classList.add('swiper-wrapper');
        let count = 0;
        for (const child of itemsEl.children) {
          if (child.nodeType !== 1 || child.tagName === 'STYLE' || child.tagName === 'SCRIPT') continue;
          child.classList.add('swiper-slide');
          count++;
        }
        root.style.setProperty('--card-count', String(count));
      }

      function removeSwiperDOM() {
        itemsEl.classList.remove('swiper-wrapper');
        for (const child of itemsEl.children) {
          if (child.nodeType !== 1 || child.tagName === 'STYLE' || child.tagName === 'SCRIPT') continue;
          child.classList.remove('swiper-slide');
        }
      }

      function initSwiper() {
        if (swiper) return;
        applySwiperDOM();

        const config = {
          slidesPerView: 'auto',
          spaceBetween: 0,
          loop: false,
          grabCursor: true,
          watchSlidesProgress: true,
        };

        if (navEl) {
          const prevBtn = navEl.querySelector('.ndev-card-group__nav-btn--prev');
          const nextBtn = navEl.querySelector('.ndev-card-group__nav-btn--next');
          if (prevBtn && nextBtn) {
            config.navigation = {
              prevEl: prevBtn,
              nextEl: nextBtn,
              disabledClass: 'swiper-button-disabled',
            };
          }
        }

        if (paginationEl && root.dataset.showPagination === 'true') {
          const paginationType = root.dataset.paginationType;
          if (paginationType === 'numbered') {
            config.pagination = {
              el: paginationEl,
              type: 'custom',
              renderCustom: function (swiperInstance, current, total) {
                return (
                  '<div class="ndev-card-group__pagination-info">' +
                  '<span class="ndev-card-group__pagination-current">' +
                  formatPageNum(current) +
                  '</span>' +
                  '<span class="ndev-card-group__pagination-total">/' +
                  formatPageNum(total) +
                  '</span>' +
                  '</div>' +
                  '<div class="ndev-card-group__pagination-buttons">' +
                  '<button class="ndev-card-group__pagination-button ndev-card-group__pagination-button--prev" type="button" aria-label="Previous slide">' +
                  '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '</button>' +
                  '<button class="ndev-card-group__pagination-button ndev-card-group__pagination-button--next" type="button" aria-label="Next slide">' +
                  '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '</button>' +
                  '</div>'
                );
              },
            };
          } else {
            config.pagination = {
              el: paginationEl,
              type: 'bullets',
              clickable: true,
            };
          }
        }

        config.on = {
          init() {
            setTimeout(() => {
              updateCentering();
              if (navEl) checkNavButtons(itemsEl, navEl, swiper);
            }, 100);
          },
          resize() {
            updateCentering();
            if (navEl) checkNavButtons(itemsEl, navEl, swiper);
          },
        };

        swiper = new window.Swiper(root, config);

        if (paginationEl && root.dataset.showPagination === 'true' && root.dataset.paginationType === 'numbered') {
          paginationEl.classList.add('ndev-card-group__pagination--numbered');
          paginationClickHandler = function (e) {
            if (!swiper) return;
            let target = e.target;
            while (target && target !== paginationEl) {
              if (target.classList && target.classList.contains('ndev-card-group__pagination-button--prev')) {
                swiper.slidePrev();
                return;
              }
              if (target.classList && target.classList.contains('ndev-card-group__pagination-button--next')) {
                swiper.slideNext();
                return;
              }
              target = target.parentElement;
            }
          };
          paginationEl.addEventListener('click', paginationClickHandler);
        }
      }

      function destroySwiper() {
        if (!swiper) return;
        if (paginationClickHandler && paginationEl) {
          paginationEl.removeEventListener('click', paginationClickHandler);
          paginationClickHandler = null;
        }
        if (paginationEl) {
          paginationEl.classList.remove('ndev-card-group__pagination--numbered');
        }
        swiper.destroy(true, true);
        swiper = null;
        removeSwiperDOM();
        root.style.removeProperty('--ndev-group-justify');
      }

      function updateCentering() {
        if (!itemsEl.classList.contains('swiper-wrapper')) return;
        const containerWidth = root.offsetWidth;
        let totalSlideWidth = 0;
        for (const child of itemsEl.children) {
          if (child.nodeType !== 1 || child.tagName === 'STYLE' || child.tagName === 'SCRIPT') continue;
          const style = window.getComputedStyle(child);
          totalSlideWidth += child.offsetWidth + (parseFloat(style.marginRight) || 0);
        }
        if (totalSlideWidth <= containerWidth + 1) {
          root.style.setProperty('--ndev-group-justify', 'center');
        } else {
          root.style.setProperty('--ndev-group-justify', 'flex-start');
        }
      }

      function handleSwiperState() {
        if (shouldUseSwiper(root)) {
          initSwiper();
        } else {
          destroySwiper();
        }
      }

      handleSwiperState();

      const onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const isMobile = window.innerWidth < 1024;
          if (isMobile !== lastWasMobile) {
            lastWasMobile = isMobile;
            handleSwiperState();
          }
          if (swiper) {
            swiper.update();
            updateCentering();
            if (navEl) checkNavButtons(itemsEl, navEl, swiper);
          }
        }, 250);
      };

      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      registry.set(root, {
        destroy() {
          window.removeEventListener('resize', onResize);
          clearTimeout(resizeTimer);
          destroySwiper();
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function destroyOne(root) {
      const ctrl = registry.get(root);
      if (ctrl) ctrl.destroy();
      registry.delete(root);
    }

    /*
     * 展开收起：按实际排出的行折叠（窄屏会少排一列，不按「列数 × 行数」算）。
     * 不依赖 Swiper，独立初始化；轮播端不生效。
     */
    const MORE_INIT_ATTR = 'data-ndev-card-group-more-init';
    const HIDDEN_CLASS = 'is-show-more-hidden';
    const ENTER_CLASS = 'is-show-more-entering';
    const EXPAND_MS = 260;
    const moreRegistry = new WeakMap();

    function getCards(itemsEl) {
      const cards = [];
      for (const child of itemsEl.children) {
        if (child.nodeType !== 1 || child.tagName === 'STYLE' || child.tagName === 'SCRIPT') continue;
        cards.push(child);
      }
      return cards;
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function parseColor(str) {
      const m = str && str.match(/rgba?\(([^)]+)\)/);
      if (!m) return null;
      const p = m[1].split(/[\s,/]+/).filter(Boolean).map(parseFloat);
      return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
    }

    function blend(top, base) {
      const a = top.a;
      return { r: top.r * a + base.r * (1 - a), g: top.g * a + base.g * (1 - a), b: top.b * a + base.b * (1 - a), a: 1 };
    }

    function luminance(c) {
      const ch = [c.r, c.g, c.b].map((v) => {
        const s = v / 255;
        return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * ch[0] + 0.7152 * ch[1] + 0.0722 * ch[2];
    }

    function contrast(c1, c2) {
      const l1 = luminance(c1);
      const l2 = luminance(c2);
      return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
    }

    // 从按钮所在位置往上取实际背景（含渐变各色标与半透明叠合），无背景时按白底
    function resolveBackgrounds(el) {
      const layers = [];
      let node = el;
      while (node && node.nodeType === 1) {
        const cs = window.getComputedStyle(node);
        const gradient = cs.backgroundImage && cs.backgroundImage.indexOf('gradient') !== -1;
        if (gradient) {
          const stops = (cs.backgroundImage.match(/rgba?\([^)]+\)/g) || []).map(parseColor).filter(Boolean);
          if (stops.length) layers.push(stops);
        }
        const bg = parseColor(cs.backgroundColor);
        if (bg && bg.a > 0) {
          layers.push([bg]);
          if (bg.a >= 1 && !gradient) break;
        }
        node = node.parentElement;
      }
      let candidates = [{ r: 255, g: 255, b: 255, a: 1 }];
      for (let i = layers.length - 1; i >= 0; i--) {
        const next = [];
        layers[i].forEach((color) => candidates.forEach((base) => next.push(blend(color, base))));
        candidates = next;
      }
      return candidates;
    }

    // 白色线框 vs 黑色线框（#1D1D1F）：取在最差色标上对比度仍更高的那个
    function pickTone(el) {
      const white = { r: 255, g: 255, b: 255 };
      const dark = { r: 29, g: 29, b: 31 };
      const bgs = resolveBackgrounds(el);
      const minWhite = Math.min.apply(null, bgs.map((c) => contrast(white, c)));
      const minDark = Math.min.apply(null, bgs.map((c) => contrast(dark, c)));
      return minWhite > minDark ? 'on-dark' : 'on-light';
    }

    // 关掉浏览器自带滚动锚定（展开时它会把新卡推到视口外，收起时会和手动补偿叠加），返回恢复函数
    function suspendScrollAnchoring() {
      const html = document.documentElement;
      const prevAnchor = html.style.overflowAnchor;
      const prevBehavior = html.style.scrollBehavior;
      html.style.overflowAnchor = 'none';
      html.style.scrollBehavior = 'auto';
      return () => {
        requestAnimationFrame(() => {
          html.style.overflowAnchor = prevAnchor;
          html.style.scrollBehavior = prevBehavior;
        });
      };
    }

    function initShowMore(root) {
      if (!root || !root.hasAttribute('data-show-more') || root.getAttribute(MORE_INIT_ATTR) === '1') return;

      const itemsEl = root.querySelector('[data-card-group-items]');
      const wrapper = root.closest('.ndev-card-group-wrapper') || root.parentElement;
      const moreEl = wrapper ? wrapper.querySelector('[data-card-group-more]') : null;
      const btn = moreEl ? moreEl.querySelector('[data-card-group-more-btn]') : null;
      if (!itemsEl || !moreEl || !btn) return;

      const textEl = btn.querySelector('.ndev-standard-button__text');
      const rowsPc = parseInt(root.dataset.rowsPc, 10) || 0;
      const rowsMb = parseInt(root.dataset.rowsMb, 10) || 0;
      let expanded = false;
      let lastWidth = -1;
      let resizeTimer = null;
      let expandTimer = null;
      let restoreAnchoring = null;

      function currentLimit() {
        if (shouldUseSwiper(root)) return 0;
        return window.innerWidth < 1024 ? rowsMb : rowsPc;
      }

      function syncButton() {
        const label = expanded ? btn.dataset.lessText : btn.dataset.moreText;
        if (textEl) textEl.textContent = label;
        btn.setAttribute('aria-label', label);
        btn.setAttribute('aria-expanded', String(expanded));
        moreEl.classList.toggle('is-expanded', expanded);
      }

      // 先全部放开量每张卡所在行，再把超出行数的收起；同一帧内完成，不会闪
      function layoutRows() {
        const cards = getCards(itemsEl);
        cards.forEach((card) => card.classList.remove(HIDDEN_CLASS));
        itemsEl.setAttribute('data-show-more-ready', '');

        const limit = currentLimit();
        if (!limit) {
          moreEl.hidden = true;
          return;
        }

        let row = -1;
        let lastTop = -Infinity;
        const rowOf = cards.map((card) => {
          if (card.offsetParent === null) return row;
          const top = card.getBoundingClientRect().top;
          if (top > lastTop + 1) {
            row += 1;
            lastTop = top;
          }
          return row;
        });

        const needToggle = row + 1 > limit;
        if (needToggle && !expanded) {
          cards.forEach((card, i) => {
            if (rowOf[i] >= limit) card.classList.add(HIDDEN_CLASS);
          });
        }
        if (needToggle && moreEl.hidden) {
          moreEl.setAttribute('data-tone', pickTone(moreEl));
        }
        moreEl.hidden = !needToggle;
      }

      function finishExpand(revealed, fromKeyboard) {
        clearTimeout(expandTimer);
        if (restoreAnchoring) {
          restoreAnchoring();
          restoreAnchoring = null;
        }
        itemsEl.style.removeProperty('height');
        itemsEl.style.removeProperty('overflow');
        itemsEl.style.removeProperty('transition');
        revealed.forEach((card) => card.classList.remove(ENTER_CLASS));
        if (fromKeyboard && revealed.length) {
          const target =
            revealed[0].querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])') || null;
          if (target) target.focus({ preventScroll: true });
        }
      }

      function expand(fromKeyboard) {
        const revealed = getCards(itemsEl).filter((card) => card.classList.contains(HIDDEN_CLASS));
        finishExpand([], false);
        restoreAnchoring = suspendScrollAnchoring();
        const startHeight = itemsEl.getBoundingClientRect().height;
        revealed.forEach((card) => card.classList.remove(HIDDEN_CLASS));
        expanded = true;
        syncButton();

        if (prefersReducedMotion() || !revealed.length) {
          finishExpand(revealed, fromKeyboard);
          return;
        }

        const endHeight = itemsEl.getBoundingClientRect().height;
        revealed.forEach((card) => card.classList.add(ENTER_CLASS));
        itemsEl.style.overflow = 'clip';
        itemsEl.style.height = startHeight + 'px';
        itemsEl.getBoundingClientRect();
        itemsEl.style.transition = 'height ' + EXPAND_MS + 'ms ease-out';
        itemsEl.style.height = endHeight + 'px';

        const onEnd = (e) => {
          if (e.target !== itemsEl || e.propertyName !== 'height') return;
          itemsEl.removeEventListener('transitionend', onEnd);
          finishExpand(revealed, fromKeyboard);
        };
        itemsEl.addEventListener('transitionend', onEnd);
        expandTimer = setTimeout(() => {
          itemsEl.removeEventListener('transitionend', onEnd);
          finishExpand(revealed, fromKeyboard);
        }, EXPAND_MS + 100);
      }

      // 收起瞬间完成：按钮留在手指下（手动补偿滚动，关掉浏览器自带滚动锚定避免补两次）
      function collapse() {
        finishExpand([], false);
        const restore = suspendScrollAnchoring();
        const before = btn.getBoundingClientRect().top;
        expanded = false;
        layoutRows();
        syncButton();
        const delta = btn.getBoundingClientRect().top - before;
        if (delta) window.scrollTo(0, window.scrollY + delta);
        restore();
      }

      const onClick = (e) => {
        e.preventDefault();
        if (expanded) {
          collapse();
        } else {
          expand(e.detail === 0);
        }
      };

      const onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const width = itemsEl.getBoundingClientRect().width;
          if (width === lastWidth) return;
          lastWidth = width;
          finishExpand([], false);
          layoutRows();
        }, 300);
      };

      // 编辑器里选中被折叠的卡 → 展开，便于编辑
      const onBlockSelect = (e) => {
        if (expanded || !itemsEl.contains(e.target)) return;
        const card = getCards(itemsEl).find((c) => c.contains(e.target));
        if (card && card.classList.contains(HIDDEN_CLASS)) {
          expanded = true;
          getCards(itemsEl).forEach((c) => c.classList.remove(HIDDEN_CLASS));
          syncButton();
        }
      };

      btn.addEventListener('click', onClick);
      window.addEventListener('resize', onResize);
      document.addEventListener('shopify:block:select', onBlockSelect);

      lastWidth = itemsEl.getBoundingClientRect().width;
      layoutRows();
      syncButton();

      root.setAttribute(MORE_INIT_ATTR, '1');
      moreRegistry.set(root, {
        destroy() {
          btn.removeEventListener('click', onClick);
          window.removeEventListener('resize', onResize);
          document.removeEventListener('shopify:block:select', onBlockSelect);
          clearTimeout(resizeTimer);
          finishExpand([], false);
          root.removeAttribute(MORE_INIT_ATTR);
        },
      });
    }

    function destroyShowMore(root) {
      const ctrl = moreRegistry.get(root);
      if (ctrl) ctrl.destroy();
      moreRegistry.delete(root);
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        initOne(root);
        initShowMore(root);
      });
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        destroyOne(root);
        destroyShowMore(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      initAll(e.target);
    });

    document.addEventListener('shopify:section:unload', (e) => {
      destroyAll(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-countdown-timer"] && !Shopify.designMode) return;
  try {
    class NdevCountdownTimer extends BaseElement {
    createdCallback() {}

    init() {
      this.dispose();
      const initialRemaining = parseInt(this.getAttribute('remaining'), 10);
      this._lastAccessibleLabel = '';
      this._cacheElements();
      this._animMode = this.classList.contains('ndev-countdown-timer--anim-none') ? 'none' : 'roll';
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._onMotionChange = () => {
        if (!this._motionQuery.matches) return;
        this._animations.forEach((cancel) => cancel());
        if (this._interval !== null) this._tick();
      };
      this._motionQuery.addEventListener('change', this._onMotionChange);

      if (!initialRemaining || initialRemaining <= 0) {
        this._setUnitValues(0, 0, 0, 0);
        this._updateAccessibleLabel(0, 0, 0, 0);
        this._setExpired(true);
        this._syncExpiryVisibility();
        return;
      }

      if (this._remainingValue !== this.getAttribute('remaining')) {
        this._remainingValue = this.getAttribute('remaining');
        this._deadline = performance.now() + initialRemaining * 1000;
      }

      this.removeAttribute('hidden');
      this._setExpired(false);
      this._tick();
      if (!this.hasAttribute('expired')) {
        this._interval = setInterval(() => this._tick(), 200);
      }
    }

    dispose() {
      clearInterval(this._interval);
      this._interval = null;
      this._motionQuery?.removeEventListener('change', this._onMotionChange);
      this._animations?.forEach((cancel) => cancel());
      this._animations = new Map();
      this._daysEl = this._hoursEl = this._minutesEl = this._secondsEl = this._els = null;
    }

    _tick() {
      const remaining = Math.max(0, Math.ceil((this._deadline - performance.now()) / 1000));

      if (remaining <= 0) {
        this._setUnitValues(0, 0, 0, 0);
        this._updateAccessibleLabel(0, 0, 0, 0);
        this._setExpired(true);
        this._syncExpiryVisibility();
        this.dispose();
        return;
      }

      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = Math.floor(remaining % 60);

      this._maybeUpdate('days', days);
      this._maybeUpdate('hours', hours);
      this._maybeUpdate('minutes', minutes);
      this._maybeUpdate('seconds', seconds);
      this._updateAccessibleLabel(days, hours, minutes, seconds);
    }

    _cacheElements() {
      this._daysEl = this.querySelector('[data-unit="days"] .ndev-countdown-timer__num-current');
      this._hoursEl = this.querySelector('[data-unit="hours"] .ndev-countdown-timer__num-current');
      this._minutesEl = this.querySelector('[data-unit="minutes"] .ndev-countdown-timer__num-current');
      this._secondsEl = this.querySelector('[data-unit="seconds"] .ndev-countdown-timer__num-current');
      this._els = { days: this._daysEl, hours: this._hoursEl, minutes: this._minutesEl, seconds: this._secondsEl };
    }

    _setUnitValues(days, hours, minutes, seconds) {
      const values = { days, hours, minutes, seconds };
      Object.entries(values).forEach(([unit, value]) => {
        const el = this._els && this._els[unit];
        if (!el) return;
        this._animations?.get(el)?.();
        el.textContent = String(value).padStart(2, '0');
      });
    }

    _updateAccessibleLabel(days, hours, minutes, seconds) {
      const label = [
        this.getAttribute('a11y-label') || 'Offer ends in',
        String(days).padStart(2, '0'),
        this.getAttribute('day-label') || 'days',
        String(hours).padStart(2, '0'),
        this.getAttribute('hour-label') || 'hours',
        String(minutes).padStart(2, '0'),
        this.getAttribute('minute-label') || 'minutes',
        String(seconds).padStart(2, '0'),
        this.getAttribute('second-label') || 'seconds',
      ].join(' ');

      if (this._lastAccessibleLabel === label) return;
      this._lastAccessibleLabel = label;
      this.setAttribute('aria-label', label);
    }

    _setExpired(isExpired) {
      if (isExpired) {
        if (this.hasAttribute('expired')) return;
        this.setAttribute('expired', '');
        this.dispatchEvent(new CustomEvent('ndev:countdown-expired', { bubbles: true }));
        return;
      }

      this.removeAttribute('expired');
    }

    _shouldAutoHide() {
      return this.getAttribute('auto-hide-on-expire') === 'true';
    }

    _syncExpiryVisibility() {
      if (this.hasAttribute('expired') && this._shouldAutoHide()) {
        this.setAttribute('hidden', '');
        return;
      }

      this.removeAttribute('hidden');
    }

    _maybeUpdate(unit, value) {
      const el = this._els?.[unit];
      if (!el) return;

      const formatted = String(value).padStart(2, '0');
      const animation = this._animations.get(el);

      if (this._motionQuery.matches || this._animMode === 'none') {
        this._animations.get(el)?.();
        el.textContent = formatted;
        return;
      }

      if (animation?.value === formatted) return;
      animation?.();
      if (el.textContent.trim() === formatted) return;

      this._swapWithNext(el, formatted);
    }

    // roll：临时插入第二个数字 span，新旧数字同帧过渡；取消时落定清理，不打断后续 tick
    _swapWithNext(el, formatted) {
      const parent = el.parentElement;
      if (!parent) {
        el.textContent = formatted;
        return;
      }

      const next = document.createElement('span');
      next.className = 'ndev-countdown-timer__num-current ndev-countdown-timer__num-next';
      next.textContent = formatted;
      next.setAttribute('aria-hidden', 'true');
      parent.appendChild(next);

      let timer;
      let active = true;
      const cancel = () => {
        active = false;
        clearTimeout(timer);
        next.removeEventListener('transitionend', onEnd);
        el.classList.remove('swap-motion', 'swap-exit');
        next.remove();
        this._animations.delete(el);
      };
      const finish = () => {
        if (!active) return;
        cancel();
        el.textContent = formatted;
      };
      const onEnd = (event) => {
        if (event && (event.target !== next || event.propertyName !== 'transform')) return;
        finish();
      };
      next.addEventListener('transitionend', onEnd);
      // 隐藏元素或过渡被禁用时可能不触发事件
      timer = setTimeout(finish, 600);
      cancel.value = formatted;
      this._animations.set(el, cancel);

      // 先让初始状态完成样式计算，再挂载过渡与目标状态
      void next.offsetWidth;
      el.classList.add('swap-motion', 'swap-exit');
      next.classList.add('swap-motion', 'swap-active');
    }

    static get observedAttributes() {
      return [
        'remaining',
        'a11y-label',
        'day-label',
        'hour-label',
        'minute-label',
        'second-label',
        'auto-hide-on-expire',
      ];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;
      if (!this.isConnected) return;

      if (name === 'remaining') {
        this._remainingValue = null;
        this.init();
        return;
      }

      if (name === 'auto-hide-on-expire') {
        this._syncExpiryVisibility();
        return;
      }

      this._syncAccessibleLabelFromDom();
    }

    _syncAccessibleLabelFromDom() {
      const readValue = (unit) => {
        const el = this.querySelector(`[data-unit="${unit}"] .ndev-countdown-timer__num-current`);
        const value = Number.parseInt(el ? el.textContent : '0', 10);
        return Number.isFinite(value) ? value : 0;
      };

      this._updateAccessibleLabel(readValue('days'), readValue('hours'), readValue('minutes'), readValue('seconds'));
    }
  }

  if (!customElements.get('ndev-countdown-timer')) {
    customElements.define('ndev-countdown-timer', NdevCountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-flex-media-card-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-flex-media-card-list')) {
    class NdevFlexMediaCardList extends BaseElement {
      init() {
        this.dispose();

        this.items = Array.from(this.querySelectorAll('.ndev-flex-media-card')).map((card) => ({
          card,
          tab: card.querySelector('.ndev-flex-media-card__tab'),
          media: card.querySelector('.ndev-flex-media-card__media'),
          desc: card.querySelector('.ndev-flex-media-card__desc'),
          videos: Array.from(card.querySelectorAll('.ndev-flex-media-card__video video')),
        }));
        if (!this.items.length) return;

        this.boundListeners = [];
        this.inView = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.items.forEach((item, index) => {
          item.videos.forEach((video) => {
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');
            video.muted = true;
          });

          if (item.tab) {
            const clickHandler = () => this.activate(index, false);
            const keyHandler = (event) => this.handleKeydown(event, index);
            this.listen(item.tab, 'click', clickHandler);
            this.listen(item.tab, 'keydown', keyHandler);
          }

          this.listen(item.card, 'mouseenter', () => {
            if (this._mq.matches) this.activate(index, false);
          });
          this.listen(item.card, 'focusin', () => {
            if (this._mq.matches) this.activate(index, false);
          });
        });

        this.activeIndex = this.getInitialIndex();

        this.applySelection();
        this.applyHiddenState();
        this.syncPlayback();

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.target === this) this.inView = entry.isIntersecting;
              });
              this.syncPlayback();
            },
            { threshold: 0.35 }
          );
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.syncPlayback();
        }

        this.listen(document, 'visibilitychange', () => this.syncPlayback());
        if (this._mq.addEventListener) {
          this.listen(this._mq, 'change', () => {
            this.applyHiddenState();
            this.syncPlayback();
          });
        }
        this.listen(this.reduceMotion, 'change', () => this.syncPlayback());
      }

      listen(target, eventName, handler) {
        target.addEventListener(eventName, handler);
        this.boundListeners.push([target, eventName, handler]);
      }

      dispose() {
        if (this.boundListeners) {
          this.boundListeners.forEach(([target, eventName, handler]) => {
            target.removeEventListener(eventName, handler);
          });
        }
        if (this.observer) this.observer.disconnect();
        this.boundListeners = [];
        this.observer = null;
      }

      getInitialIndex() {
        const activeIndex = this.items.findIndex((item) => item.card.classList.contains('is-active'));
        return activeIndex >= 0 ? activeIndex : 0;
      }

      activate(index, focusTab) {
        const normalized = (index + this.items.length) % this.items.length;
        const changed = normalized !== this.activeIndex;
        this.activeIndex = normalized;
        this.applySelection();
        this.applyHiddenState();
        if (!changed) return;
        this.syncPlayback();
        if (focusTab && this.items[normalized].tab) this.items[normalized].tab.focus();
      }

      applySelection() {
        this.items.forEach((item, index) => {
          const isActive = index === this.activeIndex;
          item.card.classList.toggle('is-active', isActive);
          if (item.tab) item.tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
      }

      applyHiddenState() {
        const isPc = this._mq.matches;
        this.items.forEach((item, index) => {
          const hideRegion = !isPc && index !== this.activeIndex;
          if (item.media) item.media.toggleAttribute('hidden', hideRegion);
          if (item.desc) item.desc.toggleAttribute('hidden', hideRegion);
          if (isPc) {
            item.card.setAttribute('tabindex', '0');
          } else {
            item.card.removeAttribute('tabindex');
          }
        });
      }

      getVisibleVideo(item) {
        const wrap = Array.from(item.card.querySelectorAll('.ndev-flex-media-card__video')).find(
          (node) => window.getComputedStyle(node).display !== 'none' && node.querySelector('video')
        );
        return wrap ? wrap.querySelector('video') : null;
      }

      safePause(video) {
        if (!video) return;
        try {
          video.pause();
        } catch (e) {}
      }

      safePlay(video) {
        if (!video) return;
        try {
          const promise = video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(() => {});
        } catch (e) {}
      }

      syncPlayback() {
        if (!this.items || !this.items.length) return;
        const activeItem = this.items[this.activeIndex];
        const eligible = this.inView && !document.hidden && !this.reduceMotion.matches;

        this.items.forEach((item) => {
          if (item !== activeItem) item.videos.forEach((video) => this.safePause(video));
        });

        if (!activeItem || !eligible) {
          if (activeItem) activeItem.videos.forEach((video) => this.safePause(video));
          return;
        }

        const visibleVideo = this.getVisibleVideo(activeItem);
        activeItem.videos.forEach((video) => {
          if (video !== visibleVideo) this.safePause(video);
        });
        if (visibleVideo) this.safePlay(visibleVideo);
      }

      handleKeydown(event, index) {
        let nextIndex = null;

        if (event.key === 'ArrowLeft') {
          nextIndex = index - 1;
        } else if (event.key === 'ArrowRight') {
          nextIndex = index + 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.items.length - 1;
        }

        if (nextIndex == null) return;

        event.preventDefault();
        this.activate(nextIndex, true);
      }
    }

    customElements.define('ndev-flex-media-card-list', NdevFlexMediaCardList);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-ksp-card"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (customElements.get('ndev-ksp-card')) return;

    class NdevKspCard extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        if (!this.querySelector('.ndev-ksp-card__icon')) return;
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick() {
        const pos = parseInt(this.getAttribute('position'), 10);
        if (!pos) return;

        const sections = document.querySelectorAll('#main-content .shopify-section');
        const section = sections[pos - 1];
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    customElements.define('ndev-ksp-card', NdevKspCard);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-spin"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const ROOT_SELECTOR = '[data-ndev-spin]';
    const INIT_ATTR = 'data-ndev-spin-initialized';
    const HEIGHT_BUFFER = 1;
    const SYNC_DEBOUNCE_MS = 300;
    const LAZY_ROOT_MARGIN = '200px 0px';
    const DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

    function isCacheEnabled(root) {
      return root.getAttribute('data-ndev-spin-cache') !== 'false';
    }

    function isLazyEnabled(root) {
      return root.getAttribute('data-ndev-spin-lazy') === 'true';
    }

    function getStorageKey(embed) {
      const dataId = embed.getAttribute('data-id');
      if (!dataId) return null;
      return 'ndev-spin-h:' + dataId + (DESKTOP_MQ.matches ? ':pc' : ':mb');
    }

    function applyCachedHeight(embed, root) {
      if (!isCacheEnabled(root)) return;

      try {
        const key = getStorageKey(embed);
        if (!key) return;

        const cached = parseInt(localStorage.getItem(key), 10);
        if (!cached || cached <= 0) return;

        embed.style.height = cached + 'px';
        embed.style.minHeight = cached + 'px';
      } catch (e) {}
    }

    function saveCachedHeight(embed, root, height) {
      if (!isCacheEnabled(root)) return;

      try {
        const key = getStorageKey(embed);
        if (!key || !height || height <= 0) return;
        localStorage.setItem(key, String(height));
      } catch (e) {}
    }

    function clearCachedHeight(embed, root) {
      if (!isCacheEnabled(root)) return;

      try {
        const key = getStorageKey(embed);
        if (key) localStorage.removeItem(key);
      } catch (e) {}
    }

    function hasEmbedContent(embed) {
      if (!embed) return false;

      for (let i = 0; i < embed.childNodes.length; i++) {
        const node = embed.childNodes[i];
        if (node.nodeType === 1) return true;
        if (node.nodeType === 3 && node.textContent.trim()) return true;
      }

      return false;
    }

    function resetEmbedShell(embed) {
      embed.style.height = '';
      embed.style.minHeight = '';
      embed.style.overflow = '';
    }

    function clearEmbedHeight(embed, root) {
      embed.style.height = '0';
      embed.style.minHeight = '0';
      embed.style.overflow = 'hidden';

      const container = embed.querySelector('#crazyrocket-iframe-container');
      if (container) {
        container.style.height = '0';
      }

      const iframe = embed.querySelector('iframe');
      if (iframe) iframe.style.height = '0';

      clearCachedHeight(embed, root);
    }

    const controllers = new WeakMap();
    const embedStates = new WeakMap();

    function prepareMeasurementShell(embed, iframe, shellHeight) {
      const height = Math.max(Math.ceil(shellHeight), 1);
      const container = embed.querySelector('#crazyrocket-iframe-container');

      embed.style.height = height + 'px';
      embed.style.minHeight = height + 'px';
      if (container) container.style.height = height + 'px';
      iframe.style.height = height + 'px';
    }

    function measureRequiredHeight(doc) {
      const body = doc.body;
      if (!body) return 0;

      const view = doc.defaultView;
      const origin = body.getBoundingClientRect().top;
      let maxBottom = body.offsetHeight || 0;

      body.querySelectorAll('*').forEach(function (el) {
        const style = view.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return;

        const rect = el.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return;

        if (style.position === 'fixed') {
          // fixed 相对 iframe 视口；不参与 body scrollHeight，但会决定可见区域需求
          maxBottom = Math.max(maxBottom, rect.bottom);
          return;
        }

        maxBottom = Math.max(maxBottom, rect.bottom - origin);
      });

      return Math.ceil(maxBottom);
    }

    function measureIframeContent(embed, iframe, shellHeight) {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc?.body) return 0;

        prepareMeasurementShell(embed, iframe, shellHeight);
        return measureRequiredHeight(doc);
      } catch (e) {
        return 0;
      }
    }

    function lockIframeDocument(iframe) {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc) return;

        if (doc.documentElement) {
          doc.documentElement.style.overflow = 'hidden';
        }
        if (doc.body) {
          doc.body.style.overflow = 'hidden';
        }
      } catch (e) {}
    }

    function applyOuterHeight(embed, iframe, nextHeight) {
      embed.style.height = nextHeight + 'px';
      embed.style.minHeight = nextHeight + 'px';

      const container = embed.querySelector('#crazyrocket-iframe-container');
      if (container) {
        container.style.height = nextHeight + 'px';
      }

      iframe.style.height = nextHeight + 'px';
      lockIframeDocument(iframe);
      return nextHeight;
    }

    function readPlaceholderHeight(embed) {
      const parsed = parseFloat(getComputedStyle(embed).height);
      return Number.isFinite(parsed) && parsed > 0 ? Math.ceil(parsed) : 0;
    }

    function bindIframe(root, embed, iframe) {
      let syncTimer = 0;
      let isSyncing = false;
      let domObserver = null;
      let lastApplied = readPlaceholderHeight(embed);

      resetEmbedShell(embed);

      const teardown = function () {
        clearTimeout(syncTimer);
        if (domObserver) {
          domObserver.disconnect();
          domObserver = null;
        }
      };

      const applyHeight = function (rawHeight) {
        const next = Math.ceil(rawHeight) + HEIGHT_BUFFER;
        if (Math.abs(next - lastApplied) <= 1) return false;
        lastApplied = applyOuterHeight(embed, iframe, next);
        return true;
      };

      const sync = function () {
        if (isSyncing) return;

        if (!hasEmbedContent(embed) || !embed.contains(iframe)) {
          teardown();
          controllers.delete(root);
          clearEmbedHeight(embed, root);
          return;
        }

        isSyncing = true;

        try {
          const height = measureIframeContent(embed, iframe, lastApplied);
          if (height <= 0) return;

          if (applyHeight(height)) {
            saveCachedHeight(embed, root, lastApplied);
          }
        } finally {
          isSyncing = false;
        }
      };

      const scheduleSync = function () {
        clearTimeout(syncTimer);
        syncTimer = setTimeout(sync, SYNC_DEBOUNCE_MS);
      };

      const observeDomChanges = function () {
        try {
          const doc = iframe.contentDocument || iframe.contentWindow?.document;
          if (!doc?.body || domObserver) return;

          domObserver = new MutationObserver(scheduleSync);
          domObserver.observe(doc.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
          });
        } catch (e) {}
      };

      const onLoad = function () {
        sync();
        observeDomChanges();
      };

      controllers.set(root, {
        sync: scheduleSync,
        teardown: teardown,
        embed: embed,
      });

      if (iframe.contentDocument?.readyState === 'complete') {
        onLoad();
      } else {
        iframe.addEventListener('load', onLoad, { once: true });
      }

      window.addEventListener('resize', scheduleSync);
    }

    function handleEmbedState(root, embed) {
      const state = embedStates.get(embed) || { hadContent: false };
      embedStates.set(embed, state);

      const iframe = embed.querySelector('iframe');

      if (!hasEmbedContent(embed)) {
        if (!state.hadContent) return;

        const controller = controllers.get(root);
        if (controller?.teardown) controller.teardown();
        controllers.delete(root);
        clearEmbedHeight(embed, root);
        state.hadContent = false;
        return;
      }

      state.hadContent = true;
      resetEmbedShell(embed);

      if (!iframe) return;

      if (!controllers.has(root)) {
        bindIframe(root, embed, iframe);
        return;
      }

      controllers.get(root).sync();
    }

    function watchEmbed(root) {
      const embed =
        root.querySelector('#crazyrocket-embed') ||
        root.querySelector('[id*="crazyrocket"]');

      if (!embed) return;

      embedStates.set(embed, { hadContent: false });

      let embedStateTimer = 0;

      const scheduleEmbedState = function () {
        clearTimeout(embedStateTimer);
        embedStateTimer = setTimeout(function () {
          handleEmbedState(root, embed);
        }, SYNC_DEBOUNCE_MS);
      };

      applyCachedHeight(embed, root);
      handleEmbedState(root, embed);

      const embedMo = new MutationObserver(scheduleEmbedState);
      embedMo.observe(embed, { childList: true, subtree: true });
    }

    function startWatching(root) {
      watchEmbed(root);

      if (!isCacheEnabled(root)) return;

      const embed =
        root.querySelector('#crazyrocket-embed') ||
        root.querySelector('[id*="crazyrocket"]');
      if (!embed) return;

      const onBreakpointChange = function () {
        applyCachedHeight(embed, root);
        const controller = controllers.get(root);
        if (controller) controller.sync();
      };

      DESKTOP_MQ.addEventListener('change', onBreakpointChange);
    }

    function initRoot(root) {
      if (!root || root.getAttribute(INIT_ATTR) === 'true') return;
      root.setAttribute(INIT_ATTR, 'true');

      const embed =
        root.querySelector('#crazyrocket-embed') ||
        root.querySelector('[id*="crazyrocket"]');
      if (embed) applyCachedHeight(embed, root);

      if (isLazyEnabled(root) && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          function (entries) {
            if (!entries.some(function (entry) {
              return entry.isIntersecting;
            })) {
              return;
            }
            io.disconnect();
            startWatching(root);
          },
          { rootMargin: LAZY_ROOT_MARGIN }
        );
        io.observe(root);
        return;
      }

      startWatching(root);
    }

    function initAll() {
      document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-subscribe-form"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ndev-subscribe-form')) return;

    const owners = new Set();
    let previousOverflow = '';
    const lockScroll = (owner) => {
      if (owners.has(owner) || !document.body) return;
      if (!owners.size) {
        previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      owners.add(owner);
    };
    const unlockScroll = (owner) => {
      if (!owners.delete(owner) || owners.size || !document.body) return;
      document.body.style.overflow = previousOverflow;
      previousOverflow = '';
    };

    class NdevSubscribeForm extends BaseElement {
      init() {
        this.dispose();
        this.generation = (this.generation || 0) + 1;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.button = this.querySelector('button[type="submit"]');
        this.buttonText = this.querySelector('.ndev-subscribe-form__button-text');
        this.message = this.querySelector('[data-message]');
        this.success = this.querySelector('[data-inline-success]');
        this.dialogLayer = this.querySelector('[data-success-dialog]');
        this.dialog = this.dialogLayer && this.dialogLayer.querySelector('[role="dialog"]');
        this.dialogClose = this.querySelector('[data-dialog-close]');
        this.defaultButtonText = this.buttonText ? this.buttonText.textContent : '';
        this.submitting = false;
        this.successLocked = false;
        this.klaviyoWait = null;
        this.onSubmit = this.handleSubmit.bind(this);
        this.onInput = this.hideMessages.bind(this);
        this.onDialogClose = () => this.closeDialog();
        this.onDialogBackdrop = (event) => {
          if (event.target === this.dialogLayer) this.closeDialog();
        };
        this.onDialogKeydown = (event) => this.handleDialogKeydown(event);
        this.resetUi();
        this.form?.addEventListener('submit', this.onSubmit);
        this.input?.addEventListener('input', this.onInput);
        this.checkbox?.addEventListener('change', this.onInput);
        this.dialogClose?.addEventListener('click', this.onDialogClose);
        this.dialogLayer?.addEventListener('click', this.onDialogBackdrop);
        document.addEventListener('keydown', this.onDialogKeydown);
      }

      dispose() {
        this.generation = (this.generation || 0) + 1;
        this.form?.removeEventListener('submit', this.onSubmit);
        this.input?.removeEventListener('input', this.onInput);
        this.checkbox?.removeEventListener('change', this.onInput);
        this.dialogClose?.removeEventListener('click', this.onDialogClose);
        this.dialogLayer?.removeEventListener('click', this.onDialogBackdrop);
        if (this.onDialogKeydown) document.removeEventListener('keydown', this.onDialogKeydown);
        this.cancelKlaviyoWait();
        this.finishDialogClose(false);
        this.form = this.input = this.checkbox = this.button = this.buttonText = this.message = this.success = null;
        this.dialogLayer = this.dialog = this.dialogClose = null;
        this.submitting = false;
        this.successLocked = false;
      }

      resetUi() {
        unlockScroll(this);
        this.classList.remove('is-loading', 'is-error', 'is-success');
        this.setAttribute('aria-busy', 'false');
        if (this.input) this.input.disabled = false;
        if (this.checkbox) this.checkbox.disabled = false;
        if (this.button) this.button.disabled = false;
        if (this.message) {
          this.message.hidden = true;
          this.message.textContent = '';
        }
        if (this.success) this.success.hidden = true;
        if (this.dialogLayer) {
          this.dialogLayer.hidden = true;
          this.dialogLayer.classList.remove('is-open');
        }
        this.clearInvalidFields();
        this.updateButtonText();
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.submitting || this.successLocked) return;
        const generation = this.generation;
        const email = this.input?.value.trim() || '';
        if (!email) {
          this.showError(this.getAttribute('email-empty-message'), 'email');
          return;
        }
        this.submitting = true;
        this.setLoading(true);
        this.hideMessages();
        try {
          const klaviyo = await this.getKlaviyoApi(generation);
          if (!this.isCurrent(generation)) return;
          if (!klaviyo || !this.getAttribute('company-id') || !this.getAttribute('list-id')) {
            this.showError(this.getAttribute('missing-config-message'));
            return;
          }
          if (!klaviyo.validateEmail(email)) {
            this.showError(this.getAttribute('email-invalid-message'), 'email');
            return;
          }
          if (this.getAttribute('require-agreement') === 'true' && this.checkbox && !this.checkbox.checked) {
            this.showError(this.getAttribute('agreement-required-message'), 'agreement');
            return;
          }
          const result = await klaviyo.subscribe({
            email,
            apiKey: this.getAttribute('company-id'),
            listId: this.getAttribute('list-id'),
            emitSuccess: false,
          });
          if (!this.isCurrent(generation)) return;
          const error = result?.error ? String(result.error).toLowerCase() : '';
          if (!result?.success && !(error.includes('already') || error.includes('exists'))) {
            this.showError(this.parseError(result?.error));
            return;
          }
          this.showSuccess();
          this.lockSuccess();
          this.openDialog();
        } catch (error) {
          if (this.isCurrent(generation)) this.showError(this.parseError(error?.message));
        } finally {
          if (this.isCurrent(generation)) {
            this.submitting = false;
            this.setLoading(false);
          }
        }
      }

      isCurrent(generation) {
        return this.isConnected && generation === this.generation;
      }
      setLoading(value) {
        this.classList.toggle('is-loading', value);
        this.setAttribute('aria-busy', value ? 'true' : 'false');
        if (this.button) this.button.disabled = value || this.successLocked;
        if (this.buttonText)
          this.buttonText.textContent = value
            ? this.getAttribute('submitting-text')
            : this.successLocked
            ? this.getAttribute('finished-button-text')
            : this.defaultButtonText;
      }
      updateButtonText() {
        if (this.buttonText) this.buttonText.textContent = this.defaultButtonText;
      }
      lockSuccess() {
        this.successLocked = true;
        if (this.input) this.input.disabled = true;
        if (this.checkbox) this.checkbox.disabled = true;
        if (this.button) this.button.disabled = true;
        if (this.buttonText)
          this.buttonText.textContent = this.getAttribute('finished-button-text') || this.defaultButtonText;
      }
      hideMessages() {
        if (this.successLocked) return;
        this.classList.remove('is-error');
        this.clearInvalidFields();
        if (this.message) {
          this.message.hidden = true;
          this.message.textContent = '';
        }
      }
      clearInvalidFields() {
        this.input?.setAttribute('aria-invalid', 'false');
        this.checkbox?.setAttribute('aria-invalid', 'false');
      }
      showError(message, field) {
        this.classList.add('is-error');
        this.clearInvalidFields();
        if (field === 'email') this.input?.setAttribute('aria-invalid', 'true');
        if (field === 'agreement') this.checkbox?.setAttribute('aria-invalid', 'true');
        if (this.message) {
          this.message.textContent = message || this.getAttribute('error-message') || '';
          this.message.hidden = false;
          this.message.setAttribute('role', 'alert');
          this.message.setAttribute('aria-live', 'assertive');
        }
        const target = field === 'email' ? this.input : field === 'agreement' ? this.checkbox : this.message;
        target?.focus({ preventScroll: true });
      }
      showSuccess() {
        this.classList.add('is-success');
        this.classList.remove('is-error');
        this.clearInvalidFields();
        if (this.message) {
          this.message.hidden = true;
          this.message.textContent = '';
        }
        if (this.success) {
          this.success.hidden = false;
          this.success.focus({ preventScroll: true });
        }
      }
      parseError(message) {
        const raw = message || this.getAttribute('error-message') || '';
        if (window.$klaviyo?.parseErrorMessage)
          return window.$klaviyo.parseErrorMessage(
            { message: raw },
            {
              alreadyRegistered: this.getAttribute('email-already-registered-message'),
              invalid: this.getAttribute('email-invalid-message'),
              default: this.getAttribute('error-message'),
            }
          );
        return raw;
      }
      getKlaviyoApi(generation) {
        if (window.$klaviyo?.subscribe && window.$klaviyo?.validateEmail) return Promise.resolve(window.$klaviyo);
        this.cancelKlaviyoWait();
        return new Promise((resolve) => {
          const ready = () => finish(this.isCurrent(generation) ? window.$klaviyo : null);
          const finish = (api) => {
            if (!this.klaviyoWait) return;
            clearTimeout(this.klaviyoWait.timeout);
            window.removeEventListener('ndev:klaviyo-api-ready', ready);
            this.klaviyoWait = null;
            resolve(api);
          };
          const timeout = setTimeout(() => finish(null), 3000);
          this.klaviyoWait = { timeout, ready, resolve };
          window.addEventListener('ndev:klaviyo-api-ready', ready);
        });
      }
      cancelKlaviyoWait() {
        if (!this.klaviyoWait) return;
        const wait = this.klaviyoWait;
        clearTimeout(wait.timeout);
        window.removeEventListener('ndev:klaviyo-api-ready', wait.ready);
        this.klaviyoWait = null;
        wait.resolve(null);
      }
      openDialog() {
        if (!this.dialogLayer || !this.dialog) return;
        this.dialogLayer.hidden = false;
        lockScroll(this);
        requestAnimationFrame(() => this.dialog?.focus({ preventScroll: true }));
      }
      closeDialog() {
        this.finishDialogClose(true);
      }
      finishDialogClose(restoreFocus) {
        if (this.dialogLayer) this.dialogLayer.hidden = true;
        unlockScroll(this);
        if (restoreFocus) this.success?.focus({ preventScroll: true });
      }
      handleDialogKeydown(event) {
        if (!this.dialogLayer || this.dialogLayer.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeDialog();
          return;
        }
        if (event.key !== 'Tab' || !this.dialog) return;
        const focusable = [
          ...this.dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'),
        ].filter((node) => !node.hidden);
        if (!focusable.length) {
          event.preventDefault();
          this.dialog.focus();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.dialog)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === this.dialog)) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('ndev-subscribe-form', NdevSubscribeForm);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-swiper-list"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var NS = 'ndev-swiper-list';
    var ROOT_SELECTOR = '[data-ndev-swiper-list]';
    var INIT_ATTR = 'data-' + NS + '-initialized';

    var registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    var controllers = window[registryKey][NS];

    /** 子 block 的 style 标签会紧跟根节点输出，不能算作一页 */
    var SLIDE_SKIP_TAGS = { STYLE: 1, SCRIPT: 1, LINK: 1, NOSCRIPT: 1, TEMPLATE: 1 };

    function queryItems(track) {
      if (!track || !track.children) return [];
      var out = [];
      for (var k = 0; k < track.children.length; k++) {
        var el = track.children[k];
        if (!el || el.nodeType !== 1) continue;
        if (SLIDE_SKIP_TAGS[el.tagName]) continue;
        out.push(el);
      }
      return out;
    }

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    /** 与 CSS stroke-dasharray 一致：r=18 时周长约 113.1 */
    var PROGRESS_RING_LENGTH = 113.1;

    function readTrackTranslateX(track) {
      try {
        var s = window.getComputedStyle(track).transform;
        if (!s || s === 'none') return 0;
        var m = new DOMMatrixReadOnly(s);
        return m.m41;
      } catch (eTx) {
        return 0;
      }
    }

    function getFrameContentBox(frame) {
      var fr = frame.getBoundingClientRect();
      var st = window.getComputedStyle(frame);
      var bl = parseFloat(st.borderLeftWidth) || 0;
      var br = parseFloat(st.borderRightWidth) || 0;
      var pl = parseFloat(st.paddingLeft) || 0;
      var pr = parseFloat(st.paddingRight) || 0;
      var W = frame.clientWidth;
      if (W <= 0 && fr.width > 0) {
        W = Math.max(0, fr.width - bl - br - pl - pr);
      }
      var left = fr.left + bl + pl;
      return { left: left, width: W, right: left + W, mid: left + W / 2 };
    }

    function computeTrackTranslateX(frame, track, item) {
      var box = getFrameContentBox(frame);
      var W = box.width;
      if (W <= 0) return 0;
      var cr = item.getBoundingClientRect();
      var tr = track.getBoundingClientRect();
      var T = track.offsetWidth;
      var txCur = readTrackTranslateX(track);

      var d = box.mid - (cr.left + cr.width / 2);

      var dCardLo = box.left - cr.left;
      var dCardHi = box.right - cr.right;
      d = Math.max(dCardLo, Math.min(d, dCardHi));

      if (T > W + 0.5) {
        var dTrackLo = box.right - tr.right;
        var dTrackHi = box.left - tr.left;
        d = Math.max(dTrackLo, Math.min(dTrackHi, d));
      }

      return txCur + d;
    }

    function destroyOne(root) {
      var controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);

      var frame = root.querySelector('[data-ndev-swiper-list-frame]');
      var track = root.querySelector('[data-ndev-swiper-list-track]');
      if (!frame || !track) return;

      var items = queryItems(track);
      if (!items.length) return;

      var paginationEl = root.querySelector('[data-ndev-swiper-list-pagination]');
      var paginationCurrentEl = paginationEl
        ? paginationEl.querySelector('[data-ndev-swiper-list-pagination-current]')
        : null;
      var paginationTotalEl = paginationEl
        ? paginationEl.querySelector('[data-ndev-swiper-list-pagination-total]')
        : null;
      var paginationPrevBtn = paginationEl
        ? paginationEl.querySelector('.ndev-swiper-list__pagination-button--prev')
        : null;
      var paginationNextBtn = paginationEl
        ? paginationEl.querySelector('.ndev-swiper-list__pagination-button--next')
        : null;
      var hidePaginationOnePage = root.getAttribute('data-hide-pagination-one-page') !== 'false';

      root.setAttribute(INIT_ATTR, '1');

      var index = 0;
      var timer = null;
      var ro = null;
      var io = null;
      var reducedMotion = false;
      var resumeTimer = null;
      var inViewKickTimer = null;
      var ringRafId = null;

      try {
        reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      var autoplayOn = root.getAttribute('data-autoplay') === 'true' && !reducedMotion;
      var autoplayMs = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 3000;
      var autoplayInView = (root.getAttribute('data-autoplay-start') || 'immediate').trim() === 'in_view';

      function getProgressRing() {
        return paginationEl ? paginationEl.querySelector('.ndev-swiper-list__progress-ring') : null;
      }

      function stopProgressRingAnim() {
        if (ringRafId !== null) {
          cancelAnimationFrame(ringRafId);
          ringRafId = null;
        }
      }

      function setRingDashOffset(ring, value) {
        if (!ring || !ring.style) return;
        ring.style.strokeDashoffset = String(value);
      }

      function resetProgressRingIdle(ring) {
        if (!ring) return;
        stopProgressRingAnim();
        setRingDashOffset(ring, PROGRESS_RING_LENGTH);
      }

      function startProgressRingAnim(ring) {
        if (!ring || !autoplayOn) return;
        stopProgressRingAnim();
        var duration = autoplayMs;
        if (duration <= 0) return;
        setRingDashOffset(ring, PROGRESS_RING_LENGTH);
        var t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
        function step() {
          var t1 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
          var elapsed = t1 - t0;
          if (elapsed >= duration) {
            setRingDashOffset(ring, 0);
            ringRafId = null;
            return;
          }
          setRingDashOffset(ring, PROGRESS_RING_LENGTH * (1 - elapsed / duration));
          ringRafId = requestAnimationFrame(step);
        }
        ringRafId = requestAnimationFrame(step);
      }

      function refreshPaginationVisibility() {
        if (!paginationEl) return;
        var lock = hidePaginationOnePage && items.length <= 1;
        paginationEl.classList.toggle('ndev-swiper-list__pagination--lock', lock);
        try {
          paginationEl.setAttribute('aria-hidden', lock ? 'true' : 'false');
        } catch (eRing) {}
      }

      function updatePaginationNumbers() {
        if (!paginationCurrentEl || !paginationTotalEl) return;
        paginationCurrentEl.textContent = formatPageNum(index + 1);
        paginationTotalEl.textContent = '/' + formatPageNum(items.length);
      }

      function updatePaginationDisabled() {
        if (!paginationPrevBtn || !paginationNextBtn) return;
        var lock = items.length <= 1;
        paginationPrevBtn.disabled = lock;
        paginationNextBtn.disabled = lock;
      }

      function setClasses(n) {
        var prevIdx = index;
        index = n;
        for (var c = 0; c < items.length; c++) {
          items[c].classList.toggle('actived', c === n);
        }
        updatePaginationNumbers();
        updatePaginationDisabled();
        if (autoplayOn && prevIdx !== n) {
          startProgressRingAnim(getProgressRing());
        }
      }

      function scrollToItem(n, smooth) {
        var item = items[n];
        if (!item) return;
        var tx = computeTrackTranslateX(frame, track, item);
        var useMotion = smooth && !reducedMotion;
        if (useMotion) {
          track.classList.remove('ndev-swiper-list__track--instant');
        } else {
          track.classList.add('ndev-swiper-list__track--instant');
        }
        track.style.transform = 'translate3d(' + tx + 'px,0,0)';
        if (!useMotion) {
          void track.offsetWidth;
          track.classList.remove('ndev-swiper-list__track--instant');
        }
      }

      function setActive(i, instant) {
        if (!items.length) return;
        var n = ((i % items.length) + items.length) % items.length;
        setClasses(n);
        scrollToItem(n, !instant);
      }

      function next() {
        setActive(index + 1);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startTimer() {
        stopTimer();
        if (!autoplayOn || items.length < 2) return;
        timer = setInterval(next, autoplayMs);
        startProgressRingAnim(getProgressRing());
      }

      function inViewport() {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
      }

      function pauseInteraction() {
        stopTimer();
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
        resetProgressRingIdle(getProgressRing());
      }

      function scheduleResume() {
        if (!autoplayOn) return;
        resumeTimer = setTimeout(function () {
          resumeTimer = null;
          if (autoplayInView && !inViewport()) return;
          startTimer();
        }, 2200);
      }

      function bindResize() {
        if (typeof ResizeObserver === 'undefined') {
          window.addEventListener('resize', relayout);
          return;
        }
        ro = new ResizeObserver(relayout);
        ro.observe(frame);
      }

      function unbindResize() {
        if (ro) {
          ro.disconnect();
          ro = null;
        }
        window.removeEventListener('resize', relayout);
      }

      function relayout() {
        scrollToItem(index, false);
      }

      bindResize();

      function setupAutoplay() {
        if (!autoplayOn) return;
        root.addEventListener('touchstart', pauseInteraction, { passive: true });
        root.addEventListener('touchend', scheduleResume, { passive: true });
        if (autoplayInView && typeof IntersectionObserver !== 'undefined') {
          io = new IntersectionObserver(
            function (entries) {
              var ok = entries.some(function (en) {
                return en.isIntersecting;
              });
              if (ok) {
                startTimer();
              } else {
                stopTimer();
                resetProgressRingIdle(getProgressRing());
              }
            },
            { root: null, threshold: 0 }
          );
          io.observe(root);
          inViewKickTimer = setTimeout(function () {
            inViewKickTimer = null;
            if (inViewport()) startTimer();
          }, 50);
        } else {
          startTimer();
        }
      }

      function onItemClick(e) {
        var node = e.target;
        while (node && node !== track) {
          if (node.parentElement === track) {
            for (var i = 0; i < items.length; i++) {
              if (items[i] === node) {
                setActive(i);
                startTimer();
                return;
              }
            }
          }
          node = node.parentElement;
        }
      }

      function onPaginationClick(e) {
        if (!paginationEl) return;
        var target = e.target;
        while (target && target !== paginationEl) {
          if (target.classList && target.classList.contains('ndev-swiper-list__pagination-button--prev')) {
            pauseInteraction();
            setActive(index - 1);
            scheduleResume();
            return;
          }
          if (target.classList && target.classList.contains('ndev-swiper-list__pagination-button--next')) {
            pauseInteraction();
            setActive(index + 1);
            scheduleResume();
            return;
          }
          target = target.parentElement;
        }
      }

      refreshPaginationVisibility();
      updatePaginationNumbers();
      updatePaginationDisabled();
      track.addEventListener('click', onItemClick);
      if (paginationEl) {
        paginationEl.addEventListener('click', onPaginationClick);
      }

      function kick() {
        setActive(0, true);
        setupAutoplay();
      }

      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(kick);
      } else {
        kick();
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          stopTimer();
          stopProgressRingAnim();
          resetProgressRingIdle(getProgressRing());
          if (resumeTimer) clearTimeout(resumeTimer);
          if (inViewKickTimer) clearTimeout(inViewKickTimer);
          unbindResize();
          track.removeEventListener('click', onItemClick);
          if (paginationEl) {
            paginationEl.removeEventListener('click', onPaginationClick);
          }
          if (autoplayOn) {
            root.removeEventListener('touchstart', pauseInteraction);
            root.removeEventListener('touchend', scheduleResume);
          }
          try {
            track.classList.add('ndev-swiper-list__track--instant');
            track.style.transform = '';
            track.classList.remove('ndev-swiper-list__track--instant');
          } catch (eTrack) {}
          if (io) {
            io.disconnect();
            io = null;
          }
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e2) {}
        },
      });
    }

    function initAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var j = 0; j < list.length; j++) destroyOne(list[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-swiper"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-swiper';
    const ROOT_SELECTOR = '[data-ndev-swiper]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    function restartProgressRingAnim(ring) {
      if (!ring || !ring.classList) return;
      ring.classList.remove('ndev-swiper__progress-ring--anim');
      void ring.offsetWidth;
      ring.classList.add('ndev-swiper__progress-ring--anim');
    }

    function ringHostHtml(includeProgress, progressRingClass) {
      var progressCircle = includeProgress
        ? '<circle class="' + progressRingClass + '" cx="20" cy="20" r="18" />'
        : '';
      return (
        '<span class="ndev-swiper__ring-host">' +
        '<svg class="ndev-swiper__progress-ring-svg" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
        '<circle class="ndev-swiper__progress-ring-track" cx="20" cy="20" r="18" />' +
        progressCircle +
        '</svg>' +
        '</span>'
      );
    }

    function renderPagination(swiper, current, total, progressRingClass) {
      return (
        '<div class="ndev-swiper__pagination-info">' +
        '<span class="ndev-swiper__pagination-current">' +
        formatPageNum(current) +
        '</span>' +
        '<span class="ndev-swiper__pagination-total">/' +
        formatPageNum(total) +
        '</span>' +
        '</div>' +
        '<div class="ndev-swiper__pagination-buttons">' +
        '<button class="ndev-swiper__pagination-button ndev-swiper__pagination-button--prev" type="button" aria-label="Previous slide">' +
        ringHostHtml(false) +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '</button>' +
        '<button class="ndev-swiper__pagination-button ndev-swiper__pagination-button--next" type="button" aria-label="Next slide">' +
        ringHostHtml(true, progressRingClass) +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '</button>' +
        '</div>'
      );
    }

    function checkNavigationButtons(swiperEl, navButtons, swiper) {
      if (!swiperEl || !navButtons || !swiper) return;
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperEl.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const swiperEl = root.querySelector('.ndev-swiper__swiper');
      const navButtons = root.querySelector('.ndev-swiper__nav-buttons');
      const paginationEl = root.querySelector('.ndev-swiper__pagination');
      if (!swiperEl) return;

      // 检查是否启用移动端纵向布局
      var mbVerticalLayout = root.getAttribute('data-mb-vertical-layout') === 'true';
      var isMobile = window.innerWidth < 1024;

      // 移动端纵向布局模式下跳过 Swiper 初始化，但允许 PC 端切换时重新初始化
      if (mbVerticalLayout && isMobile) {
        let mbVerticalResizeTimeout = 0;
        const onMbVerticalResize = () => {
          if (mbVerticalResizeTimeout) window.clearTimeout(mbVerticalResizeTimeout);
          mbVerticalResizeTimeout = window.setTimeout(() => {
            if (window.innerWidth >= 1024) {
              window.removeEventListener('resize', onMbVerticalResize);
              initOne(root);
            }
          }, 250);
        };
        window.addEventListener('resize', onMbVerticalResize);
        controllers.set(root, {
          root: root,
          destroy: function () {
            window.removeEventListener('resize', onMbVerticalResize);
            if (mbVerticalResizeTimeout) window.clearTimeout(mbVerticalResizeTimeout);
          }
        });
        return;
      }

      // 检查是否启用侧边导航和底部翻页器（通过元素是否存在判断）
      var enableSideNavigation = !!navButtons;
      var enableBottomPagination = !!paginationEl;
      // 读取自动轮播配置
      var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
      var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 3000;
      var autoplayStart = (root.getAttribute('data-autoplay-start') || 'immediate').trim();
      var autoplayWhenInView = autoplayStart === 'in_view';

      // 检查是否有 slides，如果没有则延迟初始化（等待子 blocks 渲染）
      var slides = swiperEl.querySelectorAll('.swiper-slide');
      if (!slides || slides.length === 0) {
        window.setTimeout(function () {
          initOne(root);
        }, 50);
        return;
      }

      const totalSlides = slides.length;

      // 读取配置
      var slidesPerViewPc = parseInt(root.getAttribute('data-slides-per-view-pc'), 10) || 0;
      var slidesPerViewMb = parseInt(root.getAttribute('data-slides-per-view-mb'), 10) || 0;
      // 读取间距配置（从 CSS 变量获取）
      var cardGapPc = parseInt(getComputedStyle(root).getPropertyValue('--card-gap').trim(), 10) || 0;
      var cardGapMb = parseInt(getComputedStyle(root).getPropertyValue('--card-gap').trim(), 10) || 0;
      // 读取是否只有一页时隐藏翻页器
      var hidePaginationWhenOnePage = root.getAttribute('data-hide-pagination-one-page') !== 'false';

      // 根据开关获取对应的导航元素
      var navNextEl = null;
      var navPrevEl = null;
      if (enableSideNavigation) {
        navNextEl = root.querySelector('.ndev-swiper__nav-button--next');
        navPrevEl = root.querySelector('.ndev-swiper__nav-button--prev');
      }

      var progressRingClass = 'ndev-swiper__progress-ring';
      if (autoplayEnabled && !autoplayWhenInView) {
        progressRingClass += ' ndev-swiper__progress-ring--anim';
      }

      // 构建 Swiper 配置
      var swiperConfig = {
        slidesPerView: slidesPerViewMb === 0 ? 'auto' : slidesPerViewMb,
        spaceBetween: cardGapMb,
        loop: false,
        grabCursor: true,
        snapToSlideEdge: true,
        breakpoints: {
          1024: {
            slidesPerView: slidesPerViewPc === 0 ? 'auto' : slidesPerViewPc,
            spaceBetween: cardGapPc
          }
        }
      };

      if (autoplayEnabled) {
        swiperConfig.autoplay = {
          delay: autoplaySpeed,
          disableOnInteraction: false
        };
      }

      if (navNextEl && navPrevEl) {
        swiperConfig.navigation = {
          nextEl: navNextEl,
          prevEl: navPrevEl,
          disabledClass: 'swiper-button-disabled'
        };
      }

      if (enableBottomPagination && paginationEl) {
        swiperConfig.pagination = {
          el: paginationEl,
          type: 'custom',
          renderCustom: function (s, current, total) {
            // 只有一页且启用隐藏时，返回空字符串
            if (hidePaginationWhenOnePage && total === 1) {
              return '';
            }
            return renderPagination(s, current, total, progressRingClass);
          }
        };
      }

      swiperConfig.on = {
        init: function () {
          if (enableSideNavigation) {
            window.setTimeout(() => checkNavigationButtons(swiperEl, navButtons, swiper), 100);
          }
        },
        autoplayPause: function () {
          // 暂停时移除动画类
          if (enableBottomPagination && paginationEl) {
            var ring = paginationEl.querySelector('.ndev-swiper__progress-ring');
            if (ring) ring.classList.remove('ndev-swiper__progress-ring--anim');
          }
        },
        autoplayResume: function () {
          // 恢复时重触发动画（仅加 class 可能无法从中间态重启 keyframes）
          if (enableBottomPagination && paginationEl) {
            var ring = paginationEl.querySelector('.ndev-swiper__progress-ring');
            restartProgressRingAnim(ring);
          }
        },
        paginationRender: function () {
          if (!autoplayWhenInView || !autoplayEnabled || !enableBottomPagination || !paginationEl) return;
          var inst = this;
          if (!isRootInViewport()) return;
          if (!inst.autoplay || !inst.autoplay.running) return;
          var ring = paginationEl.querySelector('.ndev-swiper__progress-ring');
          restartProgressRingAnim(ring);
        }
      };

      const swiper = new window.Swiper(swiperEl, swiperConfig);

      var autoplayVisibilityIo = null;
      function isRootInViewport() {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var inViewport = r.bottom > 0 && r.right > 0 && r.left < vw && r.top < vh;
        // 检查元素是否真正可见（不仅是在视口内）
        return inViewport && root.checkVisibility();
      }
      function setAutoplayByVisibility(visible) {
        if (!autoplayEnabled || !swiper.autoplay) return;
        if (visible) {
          swiper.autoplay.start();
          if (autoplayWhenInView && enableBottomPagination && paginationEl) {
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                if (!swiper.autoplay || !swiper.autoplay.running) return;
                var ring = paginationEl.querySelector('.ndev-swiper__progress-ring');
                restartProgressRingAnim(ring);
              });
            });
          }
        } else {
          swiper.autoplay.stop();
          if (enableBottomPagination && paginationEl) {
            var ringOff = paginationEl.querySelector('.ndev-swiper__progress-ring');
            if (ringOff) ringOff.classList.remove('ndev-swiper__progress-ring--anim');
          }
        }
      }
      if (autoplayEnabled && autoplayWhenInView) {
        setAutoplayByVisibility(isRootInViewport());
        if (typeof IntersectionObserver !== 'undefined') {
          autoplayVisibilityIo = new IntersectionObserver(
            function (entries) {
              for (var e = 0; e < entries.length; e++) {
                if (entries[e].target === root) {
                  // 检查元素是否在视口内且真正可见
                  var isVisible = entries[e].isIntersecting && root.checkVisibility();
                  setAutoplayByVisibility(isVisible);
                  break;
                }
              }
            },
            { root: null, rootMargin: '0px', threshold: 0 }
          );
          autoplayVisibilityIo.observe(root);
        }
      }

      // 底部翻页器按钮事件委托（由 renderCustom 渲染）
      var handlePaginationClick = function (e) {
        if (!enableBottomPagination) return;
        var target = e.target;
        // 向上查找是否是按钮
        while (target && target !== paginationEl) {
          if (target.classList && target.classList.contains('ndev-swiper__pagination-button--prev')) {
            swiper.slidePrev();
            return;
          }
          if (target.classList && target.classList.contains('ndev-swiper__pagination-button--next')) {
            swiper.slideNext();
            return;
          }
          target = target.parentElement;
        }
      };
      if (enableBottomPagination && paginationEl) {
        paginationEl.addEventListener('click', handlePaginationClick);
      }

      // resize 时检测窗口宽度变化，处理移动端纵向布局切换
      let resizeTimeout = 0;
      let lastIsMobile = isMobile;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          const currentIsMobile = window.innerWidth < 1024;
          // PC → 移动端，且启用了纵向布局：销毁 Swiper，切换为纵向布局模式
          if (!lastIsMobile && currentIsMobile && mbVerticalLayout) {
            destroyOne(root);
            initOne(root);
            return;
          }
          // 移动端（纵向布局）→ PC：销毁纵向布局控制器，重新初始化 Swiper
          if (lastIsMobile && !currentIsMobile && mbVerticalLayout) {
            destroyOne(root);
            initOne(root);
            return;
          }
          lastIsMobile = currentIsMobile;
          if (enableSideNavigation) {
            checkNavigationButtons(swiperEl, navButtons, swiper);
          }
          swiper.update();
        }, 250);
      };
      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      controllers.set(root, {
        root: root,
        destroy: function () {
          window.removeEventListener('resize', onResize);
          if (resizeTimeout) window.clearTimeout(resizeTimeout);
          if (autoplayVisibilityIo) {
            try {
              autoplayVisibilityIo.disconnect();
            } catch (_) {}
            autoplayVisibilityIo = null;
          }
          // 移除分页器按钮事件监听
          if (paginationEl) paginationEl.removeEventListener('click', handlePaginationClick);
          try {
            swiper.destroy(true, true);
          } catch (_) {}
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
